import React, { useState, useEffect, useRef, createElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { toast, ToastContainer } from 'react-toastify';
import * as SlatwalSDK from '@ten24/slatwall-sdk-private/dist/client/index';
import require$$1$1 from 'http';
import require$$2 from 'https';
import require$$0$3 from 'url';
import require$$3 from 'stream';
import require$$4 from 'assert';
import require$$0$2 from 'tty';
import require$$1 from 'util';
import require$$0$1 from 'os';
import require$$8 from 'zlib';
import jwt_decode from 'jwt-decode';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { createSelector } from 'reselect';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useFormik } from 'formik';
import { useHistory as useHistory$1, useLocation as useLocation$2, Redirect as Redirect$1 } from 'react-router';
import dayjs from 'dayjs';
import { useLocation as useLocation$1 } from 'react-use';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ContentLoader from 'react-content-loader';
import Slider from 'react-slick';
import LoadingOverlay from 'react-loading-overlay-ts';
import { Helmet } from 'react-helmet';
import 'react-toastify/dist/ReactToastify.css';
import MailchimpSubscribe from 'react-mailchimp-subscribe';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

const sdkURL = process.env.REACT_APP_API_URL;
const siteCode$1 = process.env.REACT_APP_SITE_CODE;
let SlatwallApiService = SlatwalSDK.init({
  host: sdkURL
}); // This sadly needs to be a in localStorage or default because of how rollup is setup.

SlatwallApiService.sdkScope.httpService.axios.interceptors.request.use(config => {
  config.headers['SWX-requestSiteCode'] = localStorage.getItem('siteCode') || siteCode$1;

  if (localStorage.getItem('token')) {
    config.headers['Auth-Token'] = `Bearer ${localStorage.getItem('token')}`;
  }

  return config;
});
SlatwallApiService.sdkScope.httpService.axios.interceptors.response.use(successRes => {
  if (successRes.data.token) localStorage.setItem('token', successRes.data.token);
  return successRes;
}, error => {});

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$1(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$e = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$d = utils$e;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$3 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$d.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$c = utils$e;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$b = utils$e;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$3 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var enhanceError$2 = enhanceError$3;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$3 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError$2(error, config, code, request, response);
};

var createError$2 = createError$3;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$2 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$2(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var utils$a = utils$e;

var cookies$1 = (
  utils$a.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$a.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$a.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$a.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$9 = utils$e;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$9.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var utils$8 = utils$e;

var isURLSameOrigin$1 = (
  utils$8.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$8.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

var utils$7 = utils$e;
var settle$1 = settle$2;
var cookies = cookies$1;
var buildURL$2 = buildURL$3;
var buildFullPath$1 = buildFullPath$2;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError$1 = createError$3;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils$7.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath$1(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$2(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle$1(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError$1('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError$1('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError$1(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$7.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$7.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var followRedirects = {exports: {}};

var src = {exports: {}};

var browser$1 = {exports: {}};

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = ms;
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

var common = setup;

/* eslint-env browser */

(function (module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};
}(browser$1, browser$1.exports));

var node = {exports: {}};

var hasFlag$1 = (flag, argv) => {
	argv = argv || process.argv;
	const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
	const pos = argv.indexOf(prefix + flag);
	const terminatorPos = argv.indexOf('--');
	return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

const os = require$$0$1;
const hasFlag = hasFlag$1;

const env = process.env;

let forceColor;
if (hasFlag('no-color') ||
	hasFlag('no-colors') ||
	hasFlag('color=false')) {
	forceColor = false;
} else if (hasFlag('color') ||
	hasFlag('colors') ||
	hasFlag('color=true') ||
	hasFlag('color=always')) {
	forceColor = true;
}
if ('FORCE_COLOR' in env) {
	forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
	if (level === 0) {
		return false;
	}

	return {
		level,
		hasBasic: true,
		has256: level >= 2,
		has16m: level >= 3
	};
}

function supportsColor(stream) {
	if (forceColor === false) {
		return 0;
	}

	if (hasFlag('color=16m') ||
		hasFlag('color=full') ||
		hasFlag('color=truecolor')) {
		return 3;
	}

	if (hasFlag('color=256')) {
		return 2;
	}

	if (stream && !stream.isTTY && forceColor !== true) {
		return 0;
	}

	const min = forceColor ? 1 : 0;

	if (process.platform === 'win32') {
		// Node.js 7.5.0 is the first version of Node.js to include a patch to
		// libuv that enables 256 color output on Windows. Anything earlier and it
		// won't work. However, here we target Node.js 8 at minimum as it is an LTS
		// release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
		// release that supports 256 colors. Windows 10 build 14931 is the first release
		// that supports 16m/TrueColor.
		const osRelease = os.release().split('.');
		if (
			Number(process.versions.node.split('.')[0]) >= 8 &&
			Number(osRelease[0]) >= 10 &&
			Number(osRelease[2]) >= 10586
		) {
			return Number(osRelease[2]) >= 14931 ? 3 : 2;
		}

		return 1;
	}

	if ('CI' in env) {
		if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(sign => sign in env) || env.CI_NAME === 'codeship') {
			return 1;
		}

		return min;
	}

	if ('TEAMCITY_VERSION' in env) {
		return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
	}

	if (env.COLORTERM === 'truecolor') {
		return 3;
	}

	if ('TERM_PROGRAM' in env) {
		const version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

		switch (env.TERM_PROGRAM) {
			case 'iTerm.app':
				return version >= 3 ? 3 : 2;
			case 'Apple_Terminal':
				return 2;
			// No default
		}
	}

	if (/-256(color)?$/i.test(env.TERM)) {
		return 2;
	}

	if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
		return 1;
	}

	if ('COLORTERM' in env) {
		return 1;
	}

	if (env.TERM === 'dumb') {
		return min;
	}

	return min;
}

function getSupportLevel(stream) {
	const level = supportsColor(stream);
	return translateLevel(level);
}

var supportsColor_1 = {
	supportsColor: getSupportLevel,
	stdout: getSupportLevel(process.stdout),
	stderr: getSupportLevel(process.stderr)
};

/**
 * Module dependencies.
 */

(function (module, exports) {
const tty = require$$0$2;
const util = require$$1;

/**
 * This is the Node.js implementation of `debug()`.
 */

exports.init = init;
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.destroy = util.deprecate(
	() => {},
	'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.'
);

/**
 * Colors.
 */

exports.colors = [6, 2, 3, 4, 5, 1];

try {
	// Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
	// eslint-disable-next-line import/no-extraneous-dependencies
	const supportsColor = supportsColor_1;

	if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
		exports.colors = [
			20,
			21,
			26,
			27,
			32,
			33,
			38,
			39,
			40,
			41,
			42,
			43,
			44,
			45,
			56,
			57,
			62,
			63,
			68,
			69,
			74,
			75,
			76,
			77,
			78,
			79,
			80,
			81,
			92,
			93,
			98,
			99,
			112,
			113,
			128,
			129,
			134,
			135,
			148,
			149,
			160,
			161,
			162,
			163,
			164,
			165,
			166,
			167,
			168,
			169,
			170,
			171,
			172,
			173,
			178,
			179,
			184,
			185,
			196,
			197,
			198,
			199,
			200,
			201,
			202,
			203,
			204,
			205,
			206,
			207,
			208,
			209,
			214,
			215,
			220,
			221
		];
	}
} catch (error) {
	// Swallow - we only care if `supports-color` is available; it doesn't have to be.
}

/**
 * Build up the default `inspectOpts` object from the environment variables.
 *
 *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
 */

exports.inspectOpts = Object.keys(process.env).filter(key => {
	return /^debug_/i.test(key);
}).reduce((obj, key) => {
	// Camel-case
	const prop = key
		.substring(6)
		.toLowerCase()
		.replace(/_([a-z])/g, (_, k) => {
			return k.toUpperCase();
		});

	// Coerce string value into JS value
	let val = process.env[key];
	if (/^(yes|on|true|enabled)$/i.test(val)) {
		val = true;
	} else if (/^(no|off|false|disabled)$/i.test(val)) {
		val = false;
	} else if (val === 'null') {
		val = null;
	} else {
		val = Number(val);
	}

	obj[prop] = val;
	return obj;
}, {});

/**
 * Is stdout a TTY? Colored output is enabled when `true`.
 */

function useColors() {
	return 'colors' in exports.inspectOpts ?
		Boolean(exports.inspectOpts.colors) :
		tty.isatty(process.stderr.fd);
}

/**
 * Adds ANSI color escape codes if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	const {namespace: name, useColors} = this;

	if (useColors) {
		const c = this.color;
		const colorCode = '\u001B[3' + (c < 8 ? c : '8;5;' + c);
		const prefix = `  ${colorCode};1m${name} \u001B[0m`;

		args[0] = prefix + args[0].split('\n').join('\n' + prefix);
		args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + '\u001B[0m');
	} else {
		args[0] = getDate() + name + ' ' + args[0];
	}
}

function getDate() {
	if (exports.inspectOpts.hideDate) {
		return '';
	}
	return new Date().toISOString() + ' ';
}

/**
 * Invokes `util.format()` with the specified arguments and writes to stderr.
 */

function log(...args) {
	return process.stderr.write(util.format(...args) + '\n');
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	if (namespaces) {
		process.env.DEBUG = namespaces;
	} else {
		// If you set a process.env field to null or undefined, it gets cast to the
		// string 'null' or 'undefined'. Just delete instead.
		delete process.env.DEBUG;
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
	return process.env.DEBUG;
}

/**
 * Init logic for `debug` instances.
 *
 * Create a new `inspectOpts` object in case `useColors` is set
 * differently for a particular `debug` instance.
 */

function init(debug) {
	debug.inspectOpts = {};

	const keys = Object.keys(exports.inspectOpts);
	for (let i = 0; i < keys.length; i++) {
		debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %o to `util.inspect()`, all on a single line.
 */

formatters.o = function (v) {
	this.inspectOpts.colors = this.useColors;
	return util.inspect(v, this.inspectOpts)
		.split('\n')
		.map(str => str.trim())
		.join(' ');
};

/**
 * Map %O to `util.inspect()`, allowing multiple lines if needed.
 */

formatters.O = function (v) {
	this.inspectOpts.colors = this.useColors;
	return util.inspect(v, this.inspectOpts);
};
}(node, node.exports));

/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
	src.exports = browser$1.exports;
} else {
	src.exports = node.exports;
}

var debug$1;

var debug_1 = function () {
  if (!debug$1) {
    try {
      /* eslint global-require: off */
      debug$1 = src.exports("follow-redirects");
    }
    catch (error) {
      debug$1 = function () { /* */ };
    }
  }
  debug$1.apply(null, arguments);
};

var url$1 = require$$0$3;
var URL = url$1.URL;
var http$1 = require$$1$1;
var https$1 = require$$2;
var Writable = require$$3.Writable;
var assert = require$$4;
var debug = debug_1;

// Create handlers that pass events from native requests
var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
var eventHandlers = Object.create(null);
events.forEach(function (event) {
  eventHandlers[event] = function (arg1, arg2, arg3) {
    this._redirectable.emit(event, arg1, arg2, arg3);
  };
});

// Error types with codes
var RedirectionError = createErrorType(
  "ERR_FR_REDIRECTION_FAILURE",
  ""
);
var TooManyRedirectsError = createErrorType(
  "ERR_FR_TOO_MANY_REDIRECTS",
  "Maximum number of redirects exceeded"
);
var MaxBodyLengthExceededError = createErrorType(
  "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
  "Request body larger than maxBodyLength limit"
);
var WriteAfterEndError = createErrorType(
  "ERR_STREAM_WRITE_AFTER_END",
  "write after end"
);

// An HTTP(S) request that can be redirected
function RedirectableRequest(options, responseCallback) {
  // Initialize the request
  Writable.call(this);
  this._sanitizeOptions(options);
  this._options = options;
  this._ended = false;
  this._ending = false;
  this._redirectCount = 0;
  this._redirects = [];
  this._requestBodyLength = 0;
  this._requestBodyBuffers = [];

  // Attach a callback if passed
  if (responseCallback) {
    this.on("response", responseCallback);
  }

  // React to responses of native requests
  var self = this;
  this._onNativeResponse = function (response) {
    self._processResponse(response);
  };

  // Perform the first request
  this._performRequest();
}
RedirectableRequest.prototype = Object.create(Writable.prototype);

RedirectableRequest.prototype.abort = function () {
  abortRequest(this._currentRequest);
  this.emit("abort");
};

// Writes buffered data to the current native request
RedirectableRequest.prototype.write = function (data, encoding, callback) {
  // Writing is not allowed if end has been called
  if (this._ending) {
    throw new WriteAfterEndError();
  }

  // Validate input and shift parameters if necessary
  if (!(typeof data === "string" || typeof data === "object" && ("length" in data))) {
    throw new TypeError("data should be a string, Buffer or Uint8Array");
  }
  if (typeof encoding === "function") {
    callback = encoding;
    encoding = null;
  }

  // Ignore empty buffers, since writing them doesn't invoke the callback
  // https://github.com/nodejs/node/issues/22066
  if (data.length === 0) {
    if (callback) {
      callback();
    }
    return;
  }
  // Only write when we don't exceed the maximum body length
  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
    this._requestBodyLength += data.length;
    this._requestBodyBuffers.push({ data: data, encoding: encoding });
    this._currentRequest.write(data, encoding, callback);
  }
  // Error when we exceed the maximum body length
  else {
    this.emit("error", new MaxBodyLengthExceededError());
    this.abort();
  }
};

// Ends the current native request
RedirectableRequest.prototype.end = function (data, encoding, callback) {
  // Shift parameters if necessary
  if (typeof data === "function") {
    callback = data;
    data = encoding = null;
  }
  else if (typeof encoding === "function") {
    callback = encoding;
    encoding = null;
  }

  // Write data if needed and end
  if (!data) {
    this._ended = this._ending = true;
    this._currentRequest.end(null, null, callback);
  }
  else {
    var self = this;
    var currentRequest = this._currentRequest;
    this.write(data, encoding, function () {
      self._ended = true;
      currentRequest.end(null, null, callback);
    });
    this._ending = true;
  }
};

// Sets a header value on the current native request
RedirectableRequest.prototype.setHeader = function (name, value) {
  this._options.headers[name] = value;
  this._currentRequest.setHeader(name, value);
};

// Clears a header value on the current native request
RedirectableRequest.prototype.removeHeader = function (name) {
  delete this._options.headers[name];
  this._currentRequest.removeHeader(name);
};

// Global timeout for all underlying requests
RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
  var self = this;
  if (callback) {
    this.on("timeout", callback);
  }

  function destroyOnTimeout(socket) {
    socket.setTimeout(msecs);
    socket.removeListener("timeout", socket.destroy);
    socket.addListener("timeout", socket.destroy);
  }

  // Sets up a timer to trigger a timeout event
  function startTimer(socket) {
    if (self._timeout) {
      clearTimeout(self._timeout);
    }
    self._timeout = setTimeout(function () {
      self.emit("timeout");
      clearTimer();
    }, msecs);
    destroyOnTimeout(socket);
  }

  // Prevent a timeout from triggering
  function clearTimer() {
    clearTimeout(this._timeout);
    if (callback) {
      self.removeListener("timeout", callback);
    }
    if (!this.socket) {
      self._currentRequest.removeListener("socket", startTimer);
    }
  }

  // Start the timer when the socket is opened
  if (this.socket) {
    startTimer(this.socket);
  }
  else {
    this._currentRequest.once("socket", startTimer);
  }

  this.on("socket", destroyOnTimeout);
  this.once("response", clearTimer);
  this.once("error", clearTimer);

  return this;
};

// Proxy all other public ClientRequest methods
[
  "flushHeaders", "getHeader",
  "setNoDelay", "setSocketKeepAlive",
].forEach(function (method) {
  RedirectableRequest.prototype[method] = function (a, b) {
    return this._currentRequest[method](a, b);
  };
});

// Proxy all public ClientRequest properties
["aborted", "connection", "socket"].forEach(function (property) {
  Object.defineProperty(RedirectableRequest.prototype, property, {
    get: function () { return this._currentRequest[property]; },
  });
});

RedirectableRequest.prototype._sanitizeOptions = function (options) {
  // Ensure headers are always present
  if (!options.headers) {
    options.headers = {};
  }

  // Since http.request treats host as an alias of hostname,
  // but the url module interprets host as hostname plus port,
  // eliminate the host property to avoid confusion.
  if (options.host) {
    // Use hostname if set, because it has precedence
    if (!options.hostname) {
      options.hostname = options.host;
    }
    delete options.host;
  }

  // Complete the URL object when necessary
  if (!options.pathname && options.path) {
    var searchPos = options.path.indexOf("?");
    if (searchPos < 0) {
      options.pathname = options.path;
    }
    else {
      options.pathname = options.path.substring(0, searchPos);
      options.search = options.path.substring(searchPos);
    }
  }
};


// Executes the next native request (initial or redirect)
RedirectableRequest.prototype._performRequest = function () {
  // Load the native protocol
  var protocol = this._options.protocol;
  var nativeProtocol = this._options.nativeProtocols[protocol];
  if (!nativeProtocol) {
    this.emit("error", new TypeError("Unsupported protocol " + protocol));
    return;
  }

  // If specified, use the agent corresponding to the protocol
  // (HTTP and HTTPS use different types of agents)
  if (this._options.agents) {
    var scheme = protocol.substr(0, protocol.length - 1);
    this._options.agent = this._options.agents[scheme];
  }

  // Create the native request
  var request = this._currentRequest =
        nativeProtocol.request(this._options, this._onNativeResponse);
  this._currentUrl = url$1.format(this._options);

  // Set up event handlers
  request._redirectable = this;
  for (var e = 0; e < events.length; e++) {
    request.on(events[e], eventHandlers[events[e]]);
  }

  // End a redirected request
  // (The first request must be ended explicitly with RedirectableRequest#end)
  if (this._isRedirect) {
    // Write the request entity and end.
    var i = 0;
    var self = this;
    var buffers = this._requestBodyBuffers;
    (function writeNext(error) {
      // Only write if this request has not been redirected yet
      /* istanbul ignore else */
      if (request === self._currentRequest) {
        // Report any write errors
        /* istanbul ignore if */
        if (error) {
          self.emit("error", error);
        }
        // Write the next buffer if there are still left
        else if (i < buffers.length) {
          var buffer = buffers[i++];
          /* istanbul ignore else */
          if (!request.finished) {
            request.write(buffer.data, buffer.encoding, writeNext);
          }
        }
        // End the request if `end` has been called on us
        else if (self._ended) {
          request.end();
        }
      }
    }());
  }
};

// Processes a response from the current native request
RedirectableRequest.prototype._processResponse = function (response) {
  // Store the redirected response
  var statusCode = response.statusCode;
  if (this._options.trackRedirects) {
    this._redirects.push({
      url: this._currentUrl,
      headers: response.headers,
      statusCode: statusCode,
    });
  }

  // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
  // that further action needs to be taken by the user agent in order to
  // fulfill the request. If a Location header field is provided,
  // the user agent MAY automatically redirect its request to the URI
  // referenced by the Location field value,
  // even if the specific status code is not understood.
  var location = response.headers.location;
  if (location && this._options.followRedirects !== false &&
      statusCode >= 300 && statusCode < 400) {
    // Abort the current request
    abortRequest(this._currentRequest);
    // Discard the remainder of the response to avoid waiting for data
    response.destroy();

    // RFC7231§6.4: A client SHOULD detect and intervene
    // in cyclical redirections (i.e., "infinite" redirection loops).
    if (++this._redirectCount > this._options.maxRedirects) {
      this.emit("error", new TooManyRedirectsError());
      return;
    }

    // RFC7231§6.4: Automatic redirection needs to done with
    // care for methods not known to be safe, […]
    // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
    // the request method from POST to GET for the subsequent request.
    if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
        // RFC7231§6.4.4: The 303 (See Other) status code indicates that
        // the server is redirecting the user agent to a different resource […]
        // A user agent can perform a retrieval request targeting that URI
        // (a GET or HEAD request if using HTTP) […]
        (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
      this._options.method = "GET";
      // Drop a possible entity and headers related to it
      this._requestBodyBuffers = [];
      removeMatchingHeaders(/^content-/i, this._options.headers);
    }

    // Drop the Host header, as the redirect might lead to a different host
    var previousHostName = removeMatchingHeaders(/^host$/i, this._options.headers) ||
      url$1.parse(this._currentUrl).hostname;

    // Create the redirected request
    var redirectUrl = url$1.resolve(this._currentUrl, location);
    debug("redirecting to", redirectUrl);
    this._isRedirect = true;
    var redirectUrlParts = url$1.parse(redirectUrl);
    Object.assign(this._options, redirectUrlParts);

    // Drop the Authorization header if redirecting to another host
    if (redirectUrlParts.hostname !== previousHostName) {
      removeMatchingHeaders(/^authorization$/i, this._options.headers);
    }

    // Evaluate the beforeRedirect callback
    if (typeof this._options.beforeRedirect === "function") {
      var responseDetails = { headers: response.headers };
      try {
        this._options.beforeRedirect.call(null, this._options, responseDetails);
      }
      catch (err) {
        this.emit("error", err);
        return;
      }
      this._sanitizeOptions(this._options);
    }

    // Perform the redirected request
    try {
      this._performRequest();
    }
    catch (cause) {
      var error = new RedirectionError("Redirected request failed: " + cause.message);
      error.cause = cause;
      this.emit("error", error);
    }
  }
  else {
    // The response is not a redirect; return it as-is
    response.responseUrl = this._currentUrl;
    response.redirects = this._redirects;
    this.emit("response", response);

    // Clean up
    this._requestBodyBuffers = [];
  }
};

// Wraps the key/value object of protocols with redirect functionality
function wrap(protocols) {
  // Default settings
  var exports = {
    maxRedirects: 21,
    maxBodyLength: 10 * 1024 * 1024,
  };

  // Wrap each protocol
  var nativeProtocols = {};
  Object.keys(protocols).forEach(function (scheme) {
    var protocol = scheme + ":";
    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

    // Executes a request, following redirects
    function request(input, options, callback) {
      // Parse parameters
      if (typeof input === "string") {
        var urlStr = input;
        try {
          input = urlToOptions(new URL(urlStr));
        }
        catch (err) {
          /* istanbul ignore next */
          input = url$1.parse(urlStr);
        }
      }
      else if (URL && (input instanceof URL)) {
        input = urlToOptions(input);
      }
      else {
        callback = options;
        options = input;
        input = { protocol: protocol };
      }
      if (typeof options === "function") {
        callback = options;
        options = null;
      }

      // Set defaults
      options = Object.assign({
        maxRedirects: exports.maxRedirects,
        maxBodyLength: exports.maxBodyLength,
      }, input, options);
      options.nativeProtocols = nativeProtocols;

      assert.equal(options.protocol, protocol, "protocol mismatch");
      debug("options", options);
      return new RedirectableRequest(options, callback);
    }

    // Executes a GET request, following redirects
    function get(input, options, callback) {
      var wrappedRequest = wrappedProtocol.request(input, options, callback);
      wrappedRequest.end();
      return wrappedRequest;
    }

    // Expose the properties on the wrapped protocol
    Object.defineProperties(wrappedProtocol, {
      request: { value: request, configurable: true, enumerable: true, writable: true },
      get: { value: get, configurable: true, enumerable: true, writable: true },
    });
  });
  return exports;
}

/* istanbul ignore next */
function noop() { /* empty */ }

// from https://github.com/nodejs/node/blob/master/lib/internal/url.js
function urlToOptions(urlObject) {
  var options = {
    protocol: urlObject.protocol,
    hostname: urlObject.hostname.startsWith("[") ?
      /* istanbul ignore next */
      urlObject.hostname.slice(1, -1) :
      urlObject.hostname,
    hash: urlObject.hash,
    search: urlObject.search,
    pathname: urlObject.pathname,
    path: urlObject.pathname + urlObject.search,
    href: urlObject.href,
  };
  if (urlObject.port !== "") {
    options.port = Number(urlObject.port);
  }
  return options;
}

function removeMatchingHeaders(regex, headers) {
  var lastValue;
  for (var header in headers) {
    if (regex.test(header)) {
      lastValue = headers[header];
      delete headers[header];
    }
  }
  return lastValue;
}

function createErrorType(code, defaultMessage) {
  function CustomError(message) {
    Error.captureStackTrace(this, this.constructor);
    this.message = message || defaultMessage;
  }
  CustomError.prototype = new Error();
  CustomError.prototype.constructor = CustomError;
  CustomError.prototype.name = "Error [" + code + "]";
  CustomError.prototype.code = code;
  return CustomError;
}

function abortRequest(request) {
  for (var e = 0; e < events.length; e++) {
    request.removeListener(events[e], eventHandlers[events[e]]);
  }
  request.on("error", noop);
  request.abort();
}

// Exports
followRedirects.exports = wrap({ http: http$1, https: https$1 });
followRedirects.exports.wrap = wrap;

var name = "axios";
var version = "0.21.4";
var description = "Promise based HTTP client for the browser and node.js";
var main = "index.js";
var scripts = {
	test: "grunt test",
	start: "node ./sandbox/server.js",
	build: "NODE_ENV=production grunt build",
	preversion: "npm test",
	version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
	postversion: "git push && git push --tags",
	examples: "node ./examples/server.js",
	coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
	fix: "eslint --fix lib/**/*.js"
};
var repository = {
	type: "git",
	url: "https://github.com/axios/axios.git"
};
var keywords = [
	"xhr",
	"http",
	"ajax",
	"promise",
	"node"
];
var author = "Matt Zabriskie";
var license = "MIT";
var bugs = {
	url: "https://github.com/axios/axios/issues"
};
var homepage = "https://axios-http.com";
var devDependencies = {
	coveralls: "^3.0.0",
	"es6-promise": "^4.2.4",
	grunt: "^1.3.0",
	"grunt-banner": "^0.6.0",
	"grunt-cli": "^1.2.0",
	"grunt-contrib-clean": "^1.1.0",
	"grunt-contrib-watch": "^1.0.0",
	"grunt-eslint": "^23.0.0",
	"grunt-karma": "^4.0.0",
	"grunt-mocha-test": "^0.13.3",
	"grunt-ts": "^6.0.0-beta.19",
	"grunt-webpack": "^4.0.2",
	"istanbul-instrumenter-loader": "^1.0.0",
	"jasmine-core": "^2.4.1",
	karma: "^6.3.2",
	"karma-chrome-launcher": "^3.1.0",
	"karma-firefox-launcher": "^2.1.0",
	"karma-jasmine": "^1.1.1",
	"karma-jasmine-ajax": "^0.1.13",
	"karma-safari-launcher": "^1.0.0",
	"karma-sauce-launcher": "^4.3.6",
	"karma-sinon": "^1.0.5",
	"karma-sourcemap-loader": "^0.3.8",
	"karma-webpack": "^4.0.2",
	"load-grunt-tasks": "^3.5.2",
	minimist: "^1.2.0",
	mocha: "^8.2.1",
	sinon: "^4.5.0",
	"terser-webpack-plugin": "^4.2.3",
	typescript: "^4.0.5",
	"url-search-params": "^0.10.0",
	webpack: "^4.44.2",
	"webpack-dev-server": "^3.11.0"
};
var browser = {
	"./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var jsdelivr = "dist/axios.min.js";
var unpkg = "dist/axios.min.js";
var typings = "./index.d.ts";
var dependencies = {
	"follow-redirects": "^1.14.0"
};
var bundlesize = [
	{
		path: "./dist/axios.min.js",
		threshold: "5kB"
	}
];
var require$$0 = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	bugs: bugs,
	homepage: homepage,
	devDependencies: devDependencies,
	browser: browser,
	jsdelivr: jsdelivr,
	unpkg: unpkg,
	typings: typings,
	dependencies: dependencies,
	bundlesize: bundlesize
};

var utils$6 = utils$e;
var settle = settle$2;
var buildFullPath = buildFullPath$2;
var buildURL$1 = buildURL$3;
var http = require$$1$1;
var https = require$$2;
var httpFollow = followRedirects.exports.http;
var httpsFollow = followRedirects.exports.https;
var url = require$$0$3;
var zlib = require$$8;
var pkg$1 = require$$0;
var createError = createError$3;
var enhanceError$1 = enhanceError$3;

var isHttps = /https:?/;

/**
 *
 * @param {http.ClientRequestArgs} options
 * @param {AxiosProxyConfig} proxy
 * @param {string} location
 */
function setProxy(options, proxy, location) {
  options.hostname = proxy.host;
  options.host = proxy.host;
  options.port = proxy.port;
  options.path = location;

  // Basic proxy authorization
  if (proxy.auth) {
    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
  }

  // If a proxy is used, any redirects must also pass through the proxy
  options.beforeRedirect = function beforeRedirect(redirection) {
    redirection.headers.host = redirection.host;
    setProxy(redirection, proxy, redirection.href);
  };
}

/*eslint consistent-return:0*/
var http_1 = function httpAdapter(config) {
  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
    var resolve = function resolve(value) {
      resolvePromise(value);
    };
    var reject = function reject(value) {
      rejectPromise(value);
    };
    var data = config.data;
    var headers = config.headers;

    // Set User-Agent (required by some servers)
    // See https://github.com/axios/axios/issues/69
    if ('User-Agent' in headers || 'user-agent' in headers) {
      // User-Agent is specified; handle case where no UA header is desired
      if (!headers['User-Agent'] && !headers['user-agent']) {
        delete headers['User-Agent'];
        delete headers['user-agent'];
      }
      // Otherwise, use specified value
    } else {
      // Only set header if it hasn't been set in config
      headers['User-Agent'] = 'axios/' + pkg$1.version;
    }

    if (data && !utils$6.isStream(data)) {
      if (Buffer.isBuffer(data)) ; else if (utils$6.isArrayBuffer(data)) {
        data = Buffer.from(new Uint8Array(data));
      } else if (utils$6.isString(data)) {
        data = Buffer.from(data, 'utf-8');
      } else {
        return reject(createError(
          'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
          config
        ));
      }

      // Add Content-Length header if data exists
      headers['Content-Length'] = data.length;
    }

    // HTTP basic authentication
    var auth = undefined;
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      auth = username + ':' + password;
    }

    // Parse url
    var fullPath = buildFullPath(config.baseURL, config.url);
    var parsed = url.parse(fullPath);
    var protocol = parsed.protocol || 'http:';

    if (!auth && parsed.auth) {
      var urlAuth = parsed.auth.split(':');
      var urlUsername = urlAuth[0] || '';
      var urlPassword = urlAuth[1] || '';
      auth = urlUsername + ':' + urlPassword;
    }

    if (auth) {
      delete headers.Authorization;
    }

    var isHttpsRequest = isHttps.test(protocol);
    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

    var options = {
      path: buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
      method: config.method.toUpperCase(),
      headers: headers,
      agent: agent,
      agents: { http: config.httpAgent, https: config.httpsAgent },
      auth: auth
    };

    if (config.socketPath) {
      options.socketPath = config.socketPath;
    } else {
      options.hostname = parsed.hostname;
      options.port = parsed.port;
    }

    var proxy = config.proxy;
    if (!proxy && proxy !== false) {
      var proxyEnv = protocol.slice(0, -1) + '_proxy';
      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
      if (proxyUrl) {
        var parsedProxyUrl = url.parse(proxyUrl);
        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
        var shouldProxy = true;

        if (noProxyEnv) {
          var noProxy = noProxyEnv.split(',').map(function trim(s) {
            return s.trim();
          });

          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
            if (!proxyElement) {
              return false;
            }
            if (proxyElement === '*') {
              return true;
            }
            if (proxyElement[0] === '.' &&
                parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
              return true;
            }

            return parsed.hostname === proxyElement;
          });
        }

        if (shouldProxy) {
          proxy = {
            host: parsedProxyUrl.hostname,
            port: parsedProxyUrl.port,
            protocol: parsedProxyUrl.protocol
          };

          if (parsedProxyUrl.auth) {
            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
            proxy.auth = {
              username: proxyUrlAuth[0],
              password: proxyUrlAuth[1]
            };
          }
        }
      }
    }

    if (proxy) {
      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
    }

    var transport;
    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
    if (config.transport) {
      transport = config.transport;
    } else if (config.maxRedirects === 0) {
      transport = isHttpsProxy ? https : http;
    } else {
      if (config.maxRedirects) {
        options.maxRedirects = config.maxRedirects;
      }
      transport = isHttpsProxy ? httpsFollow : httpFollow;
    }

    if (config.maxBodyLength > -1) {
      options.maxBodyLength = config.maxBodyLength;
    }

    // Create the request
    var req = transport.request(options, function handleResponse(res) {
      if (req.aborted) return;

      // uncompress the response body transparently if required
      var stream = res;

      // return the last request in case of redirects
      var lastRequest = res.req || req;


      // if no content, is HEAD request or decompress disabled we should not decompress
      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
        switch (res.headers['content-encoding']) {
        /*eslint default-case:0*/
        case 'gzip':
        case 'compress':
        case 'deflate':
        // add the unzipper to the body stream processing pipeline
          stream = stream.pipe(zlib.createUnzip());

          // remove the content-encoding in order to not confuse downstream operations
          delete res.headers['content-encoding'];
          break;
        }
      }

      var response = {
        status: res.statusCode,
        statusText: res.statusMessage,
        headers: res.headers,
        config: config,
        request: lastRequest
      };

      if (config.responseType === 'stream') {
        response.data = stream;
        settle(resolve, reject, response);
      } else {
        var responseBuffer = [];
        var totalResponseBytes = 0;
        stream.on('data', function handleStreamData(chunk) {
          responseBuffer.push(chunk);
          totalResponseBytes += chunk.length;

          // make sure the content length is not over the maxContentLength if specified
          if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
            stream.destroy();
            reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded',
              config, null, lastRequest));
          }
        });

        stream.on('error', function handleStreamError(err) {
          if (req.aborted) return;
          reject(enhanceError$1(err, config, null, lastRequest));
        });

        stream.on('end', function handleStreamEnd() {
          var responseData = Buffer.concat(responseBuffer);
          if (config.responseType !== 'arraybuffer') {
            responseData = responseData.toString(config.responseEncoding);
            if (!config.responseEncoding || config.responseEncoding === 'utf8') {
              responseData = utils$6.stripBOM(responseData);
            }
          }

          response.data = responseData;
          settle(resolve, reject, response);
        });
      }
    });

    // Handle errors
    req.on('error', function handleRequestError(err) {
      if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
      reject(enhanceError$1(err, config, null, req));
    });

    // Handle request timeout
    if (config.timeout) {
      // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
      var timeout = parseInt(config.timeout, 10);

      if (isNaN(timeout)) {
        reject(createError(
          'error trying to parse `config.timeout` to int',
          config,
          'ERR_PARSE_TIMEOUT',
          req
        ));

        return;
      }

      // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
      // And then these socket which be hang up will devoring CPU little by little.
      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
      req.setTimeout(timeout, function handleRequestTimeout() {
        req.abort();
        reject(createError(
          'timeout of ' + timeout + 'ms exceeded',
          config,
          config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
          req
        ));
      });
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (req.aborted) return;

        req.abort();
        reject(cancel);
      });
    }

    // Send the request
    if (utils$6.isStream(data)) {
      data.on('error', function handleStreamError(err) {
        reject(enhanceError$1(err, config, null, req));
      }).pipe(req);
    } else {
      req.end(data);
    }
  });
};

var utils$5 = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$3;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = http_1;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$5.isFormData(data) ||
      utils$5.isArrayBuffer(data) ||
      utils$5.isBuffer(data) ||
      utils$5.isStream(data) ||
      utils$5.isFile(data) ||
      utils$5.isBlob(data)
    ) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$5.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$5.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$3.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$4 = utils$e;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$3 = utils$e;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$3.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$2 = utils$e;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$2.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$2.forEach(otherKeys, mergeDeepProperties);

  return config;
};

var pkg = require$$0;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$1 = utils$e;
var buildURL = buildURL$3;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$1(message) {
  this.message = message;
}

Cancel$1.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$1.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$1;

var Cancel = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

var utils = utils$e;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

const siteCode = process.env.REACT_APP_SITE_CODE; // This sadly needs to be a in localStorage or default because of how rollup is setup.

axios.interceptors.request.use(config => {
  config.headers['SWX-requestSiteCode'] = localStorage.getItem('siteCode') || siteCode;

  if (localStorage.getItem('token')) {
    config.headers['Auth-Token'] = `Bearer ${localStorage.getItem('token')}`;
  }

  return config;
});
axios.interceptors.response.use(successRes => {
  if (successRes.data.token) localStorage.setItem('token', successRes.data.token);
  return successRes;
}, error => {});

const cleanHTML = data => data.replace('class=', 'className=');
const renameKeys = (obj, find, replace = '') => {
  Object.keys(obj).forEach(key => {
    const newKey = key.replace(find, replace);
    obj[newKey] = obj[key];
    delete obj[key];
  });
};
const renameKeysInArrayOfObjects = (arr, find, replace) => {
  arr.forEach(obj => {
    renameKeys(obj, find, replace);
  });
};
const isAuthenticated = () => {
  let token = localStorage.getItem('token');

  if (token) {
    try {
      token = jwt_decode(token);
      return token.exp && token.exp * 1000 > Date.now() && token.accountID.length > 0;
    } catch (error) {}
  }

  return false;
};
const containsHTML = str => /<[a-z][\s\S]*>/i.test(str);
const isString = val => 'string' === typeof val;
const isBoolean = val => 'boolean' === typeof val;
const booleanToString = value => value ? 'Yes' : 'No';
const skuIdsToSkuCodes = (idList, productOptionGroups) => {
  return productOptionGroups.map(optionGroup => optionGroup.options.filter(option => {
    return idList.includes(option.optionID);
  }).map(option => {
    let payload = {};
    payload[optionGroup.optionGroupCode] = option.optionCode;
    return payload;
  })).flat();
};
const parseErrorMessages = error => {
  if (error instanceof Object) {
    return Object.keys(error).map(key => parseErrorMessages(error[key])).flat();
  }

  return error;
};
const getErrorMessage = error => {
  var _parseErrorMessages;

  return (_parseErrorMessages = parseErrorMessages(error)) === null || _parseErrorMessages === void 0 ? void 0 : _parseErrorMessages.join('. ');
};
const organizeProductTypes = (parents, list) => {
  return parents.map(parent => {
    let childProductTypes = list.filter(productType => {
      return productType.productTypeIDPath.includes(parent.productTypeIDPath) && productType.productTypeID !== parent.productTypeID;
    }).filter(productType => {
      return productType.productTypeIDPath.split(',').length === parent.productTypeIDPath.split(',').length + 1;
    });

    if (list.length > 0) {
      childProductTypes = organizeProductTypes(childProductTypes, list);
    }

    return { ...parent,
      childProductTypes
    };
  });
};
const augmentProductType = (parent, data) => {
  let parents = data.filter(productType => {
    return productType.urlTitle === parent;
  });
  parents = organizeProductTypes(parents, data);

  if (parents.length > 0) {
    parents = parents[0];
  }

  return parents;
};
const groupBy = (xs, key) => {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};
const processQueryParameters = params => {
  let qParams = queryString.parse(params, {
    arrayFormat: 'separator',
    arrayFormatSeparator: ','
  });
  Object.keys(qParams).forEach(key => qParams[key] = Array.isArray(qParams[key]) ? qParams[key].join() : qParams[key]);
  return qParams;
};

const REQUEST_USER = 'REQUEST_USER';
const RECEIVE_USER = 'RECEIVE_USER';
const REQUEST_WISHLIST = 'REQUEST_WISHLIST';
const RECEIVE_WISHLIST = 'RECEIVE_WISHLIST';
const RECEIVE_WISHLIST_ITEMS = 'RECEIVE_WISHLIST_ITEMS';
const CLEAR_USER = 'CLEAR_USER';
const requestWishlist = () => {
  return {
    type: REQUEST_WISHLIST
  };
};
const receiveWishlist = (lists = []) => {
  return {
    type: RECEIVE_WISHLIST,
    payload: lists
  };
};
const receiveWishlistItems = (items = []) => {
  return {
    type: RECEIVE_WISHLIST_ITEMS,
    payload: items
  };
};
const requestUser = () => {
  return {
    type: REQUEST_USER
  };
};
const receiveUser = (user = {}) => {
  return {
    type: RECEIVE_USER,
    user
  };
};
const clearUser = () => {
  return {
    type: CLEAR_USER
  };
};
const getUser = () => {
  return async dispatch => {
    dispatch(requestUser());
    const payload = {
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.account.get(payload).then(response => {
      var _response$success;

      if (response.isSuccess() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        if (response.success().account.accountID.length) {
          dispatch(receiveUser(response.success().account));
        } else {
          dispatch(softLogout());
        }

        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(softLogout());
      }
    });
  };
};
const updateUser = user => {
  return async dispatch => {
    dispatch(requestUser());
    const payload = { ...user
    };
    await SlatwallApiService.account.update(payload).then(response => {
      var _response$success2;

      if (response.isSuccess() && Object.keys(((_response$success2 = response.success()) === null || _response$success2 === void 0 ? void 0 : _response$success2.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        toast.success('Update Successful');
        dispatch(receiveUser(response.success().account));
      } else {
        toast.error('Update Failed');
      }
    });
  };
};
const addNewAccountAddress = address => {
  return async dispatch => {
    dispatch(requestUser());
    const payload = { ...address,
      returnJSONObjects: 'account'
    };
    await SlatwallApiService.account.addAddress(payload).then(response => {
      if (response.isSuccess() && (response.success().errors === undefined || response.success().errors === null)) {
        toast.success('Update Successful');
        dispatch(receiveUser(response.success().account));
      } else {
        var _response$success6;

        dispatch(receiveUser({}));
        if (response.isSuccess() && Object.keys(((_response$success6 = response.success()) === null || _response$success6 === void 0 ? void 0 : _response$success6.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));
      }
    });
  };
};
const updateAccountAddress = user => {
  return async dispatch => {
    dispatch(requestUser());
    const payload = { ...user,
      returnJSONObjects: 'account'
    };
    await SlatwallApiService.account.updateAddress(payload).then(response => {
      if (response.isSuccess() && (response.success().errors === undefined || response.success().errors === null)) {
        toast.success('Update Successful');
        dispatch(receiveUser(response.success().account));
      } else {
        var _response$success7;

        if (response.isSuccess() && Object.keys(((_response$success7 = response.success()) === null || _response$success7 === void 0 ? void 0 : _response$success7.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));
      }
    });
  };
};
const deleteAccountAddress = accountAddressID => {
  return async dispatch => {
    const payload = {
      accountAddressID,
      returnJSONObjects: 'account'
    };
    await SlatwallApiService.account.deleteAddress(payload).then(response => {
      var _response$success8;

      if (response.isSuccess() && Object.keys(((_response$success8 = response.success()) === null || _response$success8 === void 0 ? void 0 : _response$success8.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        toast.success('Update Successful');
        dispatch(receiveUser(response.success().account));
      } else {
        toast.error('Update Failed');
      }
    });
  };
};
const addPaymentMethod = paymentMethod => {
  return async dispatch => {
    const payload = { ...paymentMethod,
      returnJSONObjects: 'account'
    };
    await SlatwallApiService.account.addPaymentMethod(payload).then(response => {
      if (response.isSuccess() && (response.success().errors === undefined || response.success().errors == null)) {
        dispatch(receiveUser(response.success().account));
        toast.success('New Card Saved');
      } else {
        var _response$success9;

        let errorMessage = response.success() && Object.keys(((_response$success9 = response.success()) === null || _response$success9 === void 0 ? void 0 : _response$success9.errors) || {}).length ? getErrorMessage(response.success().errors) : 'Save Failed';
        toast.error(errorMessage);
      }
    });
  };
};
const deletePaymentMethod = accountPaymentMethodID => {
  return async dispatch => {
    const payload = {
      accountPaymentMethodID,
      returnJSONObjects: 'account'
    };
    await SlatwallApiService.account.deletePaymentMethod(payload).then(response => {
      var _response$success11;

      if (response.isSuccess() && Object.keys(((_response$success11 = response.success()) === null || _response$success11 === void 0 ? void 0 : _response$success11.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        toast.success('Delete Successful');
        dispatch(receiveUser(response.success().account));
      } else {
        toast.error('Delete Failed');
      }
    });
  };
};
const getWishLists = (force = false) => {
  return async (dispatch, getState) => {
    dispatch(requestWishlist());

    if ((!getState().userReducer.wishList.isListLoaded || force) && isAuthenticated()) {
      dispatch(getWishListItems(true));
      const payload = {};
      await SlatwallApiService.orderTemplate.getWishlists(payload).then(response => {
        var _response$success12;

        if (response.isSuccess() && Object.keys(((_response$success12 = response.success()) === null || _response$success12 === void 0 ? void 0 : _response$success12.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          dispatch(receiveWishlist(response.success().accountWishlistProducts));
        }
      });
    }
  };
};
const getWishListItems = (force = false) => {
  return async (dispatch, getState) => {
    dispatch(requestWishlist());

    if ((!getState().userReducer.wishList.isListItemsLoaded || force) && isAuthenticated()) {
      const payload = {};
      await SlatwallApiService.orderTemplate.getWishListItems(payload).then(response => {
        var _response$success13;

        if (response.isSuccess() && Object.keys(((_response$success13 = response.success()) === null || _response$success13 === void 0 ? void 0 : _response$success13.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          dispatch(receiveWishlistItems(response.success().accountWishlistProducts));
        } else {
          dispatch(receiveWishlistItems());
        }
      });
    }
  };
};
const createListAndAddItem = (skuID = '') => {
  return async dispatch => {
    if (isAuthenticated()) {
      const payload = {
        skuID
      };
      await SlatwallApiService.orderTemplate.createAndAddItem(payload).then(response => {
        if (response.isSuccess()) {
          dispatch(getWishLists(true));
        }
      });
    }
  };
};
const addSkuToWishList = (skuID = '', orderTemplateID = null) => {
  return async dispatch => {
    if (isAuthenticated()) {
      const payload = {
        skuID,
        orderTemplateID
      };
      await SlatwallApiService.orderTemplate.addWishlistItem(payload).then(response => {
        var _response$success14;

        if (response.isSuccess() && Object.keys(((_response$success14 = response.success()) === null || _response$success14 === void 0 ? void 0 : _response$success14.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          dispatch(getWishListItems(true));
        }
      });
    }
  };
};
const removeWishlistItem = (removalSkuID = '', orderTemplateID) => {
  return async (dispatch, getState) => {
    dispatch(requestWishlist());

    if (isAuthenticated()) {
      const payload = {
        removalSkuID,
        orderTemplateID
      };
      await SlatwallApiService.orderTemplate.removeWishlistItem(payload).then(response => {
        var _response$success15;

        if (response.isSuccess() && Object.keys(((_response$success15 = response.success()) === null || _response$success15 === void 0 ? void 0 : _response$success15.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          dispatch(getWishListItems(true));
        }
      });
    }
  };
};

const REQUEST_CART = 'REQUEST_CART';
const RECEIVE_CART = 'RECEIVE_CART';
const CONFIRM_ORDER = 'CONFIRM_ORDER';
const requestCart = () => {
  return {
    type: REQUEST_CART
  };
};
const receiveCart = cart => {
  return {
    type: RECEIVE_CART,
    cart
  };
};
const confirmOrder = (isPlaced = true) => {
  return {
    type: CONFIRM_ORDER,
    isPlaced
  };
};
const setOrderOnCart = (orderID, successMsg = "") => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = {
      orderID,
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.addCartToSession(payload).then(response => {
      var _response$success;

      if (response.isSuccess() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        var _response$success2;

        dispatch(receiveCart(response.success().cart));

        if (successMsg !== "" && !Object.keys(((_response$success2 = response.success()) === null || _response$success2 === void 0 ? void 0 : _response$success2.errors) || {}).length) {
          toast.success(successMsg);
        }
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const getCart = () => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.get().then(response => {
      if (response.isSuccess()) {
        if (response.success().errors) toast.error(getErrorMessage(response.success().errors));
        dispatch(receiveCart(response.success().cart));
      }
    });
  };
};
const addToCart = (skuID, quantity = 1, successMsg = "") => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.addItem({
      skuID,
      quantity,
      returnJSONObjects: 'cart'
    }).then(response => {
      var _response$success4;

      if (response.isSuccess() && Object.keys(((_response$success4 = response.success()) === null || _response$success4 === void 0 ? void 0 : _response$success4.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        var _response$success5;

        dispatch(receiveCart(response.success().cart));

        if (successMsg !== "" && !Object.keys(((_response$success5 = response.success()) === null || _response$success5 === void 0 ? void 0 : _response$success5.errors) || {}).length) {
          toast.success(successMsg);
        }
      }
    });
  };
};
const getEligibleFulfillmentMethods = () => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = {};
    await SlatwallApiService.cart.eligibleFulfillmentMethods(payload).then(response => {
      var _response$success6;

      if (response.isSuccess() && Object.keys(((_response$success6 = response.success()) === null || _response$success6 === void 0 ? void 0 : _response$success6.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart({
          eligibleFulfillmentMethods: response.success().eligibleFulfillmentMethods
        }));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const getPickupLocations = () => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.location.getPickupLocations().then(response => {
      var _response$success7;

      if (response.isSuccess() && Object.keys(((_response$success7 = response.success()) === null || _response$success7 === void 0 ? void 0 : _response$success7.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart({
          pickupLocations: response.success().locations
        }));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const clearOrderFulfillment = orderFulfillmentID => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = {
      orderFulfillmentID,
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.clearOrderFulfillment(payload).then(response => {
      var _response$success8;

      if (response.isSuccess() && Object.keys(((_response$success8 = response.success()) === null || _response$success8 === void 0 ? void 0 : _response$success8.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const addPickupLocation = params => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = { ...params,
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.addPickupLocation(payload).then(response => {
      var _response$success9;

      if (response.isSuccess() && Object.keys(((_response$success9 = response.success()) === null || _response$success9 === void 0 ? void 0 : _response$success9.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const setPickupDate = params => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = { ...params,
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.setPickupDate(payload).then(response => {
      var _response$success10;

      if (response.isSuccess() && Object.keys(((_response$success10 = response.success()) === null || _response$success10 === void 0 ? void 0 : _response$success10.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const updateOrderNotes = params => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = { ...params,
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.updateNotes(payload).then(response => {
      var _response$success11;

      if (response.isSuccess() && Object.keys(((_response$success11 = response.success()) === null || _response$success11 === void 0 ? void 0 : _response$success11.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const updateItemQuantity = (skuID, quantity = 1) => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = {
      orderItem: {
        sku: {
          skuID
        },
        qty: quantity
      },
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.updateItemQuantity(payload).then(response => {
      var _response$success12;

      if (response.isSuccess() && Object.keys(((_response$success12 = response.success()) === null || _response$success12 === void 0 ? void 0 : _response$success12.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const removeItem = orderItemID => {
  return async dispatch => {
    dispatch(requestCart());
    const payload = {
      orderItemID,
      returnJSONObjects: 'cart'
    };
    await SlatwallApiService.cart.removeItem(payload).then(response => {
      var _response$success13;

      if (response.isSuccess() && Object.keys(((_response$success13 = response.success()) === null || _response$success13 === void 0 ? void 0 : _response$success13.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      }
    });
  };
};
const addShippingAddress = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.addShippingAddress(params).then(response => {
      var _response$success14;

      if (response.isSuccess() && Object.keys(((_response$success14 = response.success()) === null || _response$success14 === void 0 ? void 0 : _response$success14.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      }
    });
  };
};
const addShippingAddressUsingAccountAddress = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.addShippingAddressUsingAccountAddress({ ...params,
      returnJSONObjects: 'cart'
    }).then(response => {
      var _response$success15;

      if (response.isSuccess() && Object.keys(((_response$success15 = response.success()) === null || _response$success15 === void 0 ? void 0 : _response$success15.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      }
    });
  };
};
const addShippingMethod = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.addShippingMethod({ ...params,
      returnJSONObjects: 'cart'
    }).then(response => {
      var _response$success16;

      if (response.isSuccess() && Object.keys(((_response$success16 = response.success()) === null || _response$success16 === void 0 ? void 0 : _response$success16.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      }
    });
  };
};
const applyPromoCode = (promotionCode, successMsg = "") => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.applyPromoCode({
      promotionCode,
      returnJSONObjects: 'cart'
    }).then(response => {
      var _response$success18;

      if (response.isSuccess() && Object.keys(((_response$success18 = response.success()) === null || _response$success18 === void 0 ? void 0 : _response$success18.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        var _response$success19;

        dispatch(receiveCart(response.success().cart));

        if (successMsg !== "" && !Object.keys(((_response$success19 = response.success()) === null || _response$success19 === void 0 ? void 0 : _response$success19.errors) || {}).length) {
          toast.success(successMsg);
        }
      }
    });
  };
};
const removePromoCode = (promotionCode, promotionCodeID, successMsg = "") => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.removePromoCode({
      promotionCode,
      promotionCodeID,
      returnJSONObjects: 'cart'
    }).then(response => {
      var _response$success20;

      if (response.isSuccess() && Object.keys(((_response$success20 = response.success()) === null || _response$success20 === void 0 ? void 0 : _response$success20.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        var _response$success21;

        dispatch(receiveCart(response.success().cart));

        if (successMsg !== "" && !Object.keys(((_response$success21 = response.success()) === null || _response$success21 === void 0 ? void 0 : _response$success21.errors) || {}).length) {
          toast.success(successMsg);
        }
      }
    });
  };
};
const addPayment = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.addPayment({ ...params,
      returnJSONObjects: 'cart,account'
    }).then(response => {
      var _response$success23;

      if (response.isSuccess() && Object.keys(((_response$success23 = response.success()) === null || _response$success23 === void 0 ? void 0 : _response$success23.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
        dispatch(receiveUser(response.success().account));
      } else {
        dispatch(receiveCart({}));
        toast.error('An Error Occured');
      }
    });
  };
};
const removePayment = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.removePayment({ ...params,
      returnJSONObjects: 'cart'
    }).then(response => {
      var _response$success24;

      if (response.isSuccess() && Object.keys(((_response$success24 = response.success()) === null || _response$success24 === void 0 ? void 0 : _response$success24.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart({ ...response.success().cart
        }));
      }
    });
  };
};
const placeOrder = () => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.placeOrder({
      returnJSONObjects: 'cart'
    }).then(response => {
      if (response.isSuccess()) {
        var _data$cart;

        let data = response.success();
        let errors = { ...(data === null || data === void 0 ? void 0 : data.errors),
          ...(data === null || data === void 0 ? void 0 : (_data$cart = data.cart) === null || _data$cart === void 0 ? void 0 : _data$cart.errors)
        };
        dispatch(receiveCart(data.cart));

        if (Object.keys(errors).length) {
          toast.error(getErrorMessage(errors));
        } else {
          dispatch(confirmOrder());
        }
      }
    });
  };
};
const addNewAddressAndAttachAsShipping = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    dispatch(requestUser());
    const payload = {
      returnJsonObjects: 'cart,account',
      ...params
    };
    await SlatwallApiService.cart.addNewAddressAndAttachAsShipping(payload).then(response => {
      var _response$success25;

      if (response.isSuccess() && Object.keys(((_response$success25 = response.success()) === null || _response$success25 === void 0 ? void 0 : _response$success25.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveUser(response.success().account));
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
        dispatch(receiveUser());
      }
    });
  };
};
const changeOrderFulfillment = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    await SlatwallApiService.cart.updateFulfillment({
      returnJsonObjects: 'cart',
      ...params
    }).then(response => {
      var _response$success26;

      if (response.isSuccess() && Object.keys(((_response$success26 = response.success()) === null || _response$success26 === void 0 ? void 0 : _response$success26.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
      }
    });
  };
};
const addNewAccountAndSetAsBilling = (params = {}) => {
  return async dispatch => {
    dispatch(requestCart());
    dispatch(requestUser());
    const payload = {
      returnJsonObjects: 'cart,account',
      ...params
    };
    await SlatwallApiService.cart.addNewAccountAndSetAsBillingAddress(payload).then(response => {
      var _response$success28;

      if (response.isSuccess() && Object.keys(((_response$success28 = response.success()) === null || _response$success28 === void 0 ? void 0 : _response$success28.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveUser(response.success().account));
        dispatch(receiveCart(response.success().cart));
      } else {
        dispatch(receiveCart());
        dispatch(receiveUser());
      }
    });
  };
};

const REQUEST_LOGIN = 'REQUEST_LOGIN';
const RECEIVE_LOGIN = 'RECEIVE_LOGIN';
const ERROR_LOGIN = 'ERROR_LOGIN';
const LOGOUT = 'LOGOUT';
const requestLogin = () => {
  return {
    type: REQUEST_LOGIN
  };
};
const receiveLogin = isAuthenticanted => {
  return {
    type: RECEIVE_LOGIN,
    isAuthenticanted
  };
};
const errorLogin = () => {
  return {
    type: ERROR_LOGIN
  };
};
const requestLogOut = () => {
  return {
    type: LOGOUT
  };
};
const logout = (success = '', failure = '') => {
  return async dispatch => {
    await SlatwallApiService.auth.revokeToken().then(response => {
      var _response$success;

      if (response.isSuccess() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));
      dispatch(softLogout());
      dispatch(getCart());

      if (response.isSuccess()) {
        toast.success(success);
      } else {
        toast.error(failure);
      }
    });
  };
};
const softLogout = () => {
  return async dispatch => {
    dispatch(requestLogOut());
    dispatch(clearUser());
  };
};

const REQUEST_CONTENT = 'REQUEST_CONTENT';
const RECEIVE_CONTENT = 'RECEIVE_CONTENT';
const RECEIVE_STATE_CODES = 'RECEIVE_STATE_CODES';
const requestContent = () => {
  return {
    type: REQUEST_CONTENT
  };
};
const receiveContent = content => {
  return {
    type: RECEIVE_CONTENT,
    content
  };
};
const receiveStateCodes = codes => {
  return {
    type: RECEIVE_STATE_CODES,
    payload: codes
  };
};
const getPageContent = (content = {}, slug = '') => {
  return async (dispatch, getState) => {
    if (getState().content[slug]) {
      return;
    }

    dispatch(requestContent());
    const payload = {
      'f:activeFlag': true,
      'p:show': 250,
      ...content
    };
    await SlatwallApiService.content.get(payload).then(response => {
      var _response$success;

      if (response.isSuccess() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        const data = response.success().data.pageRecords.reduce((accumulator, content) => {
          accumulator[content.urlTitlePath] = content;
          return accumulator;
        }, {});
        dispatch(receiveContent(data));
      } else {
        dispatch(receiveContent({}));
      }
    });
  };
};
const getStateCodeOptionsByCountryCode = (countryCode = 'US') => {
  return async dispatch => {
    dispatch(requestContent());
    const payload = {};
    await SlatwallApiService.location.states(payload).then(response => {
      var _response$success2;

      if (response.isSuccess() && Object.keys(((_response$success2 = response.success()) === null || _response$success2 === void 0 ? void 0 : _response$success2.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        let responsePayload = {};
        responsePayload[countryCode] = response.success().stateCodeOptions || [];
        dispatch(receiveStateCodes(responsePayload));
      } else {
        dispatch(receiveStateCodes({}));
      }
    });
  };
};
const getCountries = () => {
  return async dispatch => {
    dispatch(requestContent());
    await SlatwallApiService.location.countries().then(response => {
      var _response$success3;

      if (response.isSuccess() && Object.keys(((_response$success3 = response.success()) === null || _response$success3 === void 0 ? void 0 : _response$success3.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

      if (response.isSuccess()) {
        dispatch(receiveContent({
          countryCodeOptions: response.success().countryCodeOptions
        }));
      } else {
        dispatch(receiveContent({}));
      }
    });
  };
};

const getRoutes = state => state.configuration.router;
const getImageFallbackFlag = state => state.configuration.products.fallbackImageCall;
const checkInvetory = state => state.configuration.productPrice.checkInvetory;
const getBrandRoute = createSelector(getRoutes, routes => {
  return routes.map(route => {
    return route.URLKeyType === 'Brand' ? route.URLKey : null;
  }).filter(item => {
    return item;
  })[0];
});
const getProductRoute = createSelector(getRoutes, routes => {
  return routes.map(route => {
    return route.URLKeyType === 'Product' ? route.URLKey : null;
  }).filter(item => {
    return item;
  })[0];
});
createSelector(getRoutes, routes => {
  return routes.map(route => {
    return route.URLKeyType === 'ProductType' ? route.URLKey : null;
  }).filter(item => {
    return item;
  })[0];
});

const getAllContent = state => state.content;
createSelector(getAllContent, (content = {}) => {
  return Object.keys(content).map(key => {
    if (content[key] && content[key].settings) {
      content[key].key = key;
      return content[key];
    }

    return null;
  }).filter(item => {
    return item;
  });
});
const getShopBy = createSelector(getAllContent, (content = {}) => {
  let shopBy = [{
    title: '',
    linkUrl: '/'
  }];

  if (Object.keys(content).includes('home/shop-by')) {
    shopBy = Object.keys(content).filter(key => {
      return key === 'home/shop-by';
    }).map(key => {
      return content[key];
    });
  }

  return shopBy[0];
});
const getMyAccountMenu = createSelector(getAllContent, (content = {}) => {
  return Object.keys(content).filter(key => {
    return key.includes('my-account/') && content[key].displayInNavigation;
  }).map(key => {
    return content[key];
  }).sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1);
});
createSelector(getAllContent, (content = {}) => {
  return Object.keys(content).map(key => {
    if (content[key] && content[key].settings && content[key].settings.contentTemplateFile === 'sidebar.cfm') {
      content[key].key = key;
      return content[key];
    }

    return null;
  }).filter(item => {
    return item;
  });
});
const getAllbanners = createSelector(getAllContent, (content = {}) => {
  return Object.keys(content).map(key => {
    if (content[key] && content[key].settings && content[key].settings.contentTemplateFile === 'banner.cfm') {
      content[key].key = key;
      return content[key];
    }

    return null;
  }).filter(item => {
    return item;
  });
});
const getAllFooterContentSelector = createSelector(getAllContent, (content = {}) => {
  return Object.keys(content).map(key => {
    if (content[key] && content[key].settings) {
      content[key].key = key;
      return content[key];
    }

    return null;
  }).filter(item => {
    return item;
  }).map(content => {
    return content.key.includes(`footer`) ? content : null;
  }).filter(item => {
    return item;
  }).sort((a, b) => {
    return a.sortOrder - b.sortOrder;
  });
});

const getAllOrderFulfillments = state => state.cart.orderFulfillments;
const getAllAccountAddresses$1 = state => state.userReducer.accountAddresses;
const getAllAccountPaymentMethods$1 = state => state.userReducer.accountPaymentMethods;
const getAllPickupLocations = state => state.cart.pickupLocations;
const getAllOrderPayments = state => {
  var _state$cart$orderPaym;

  return (_state$cart$orderPaym = state.cart.orderPayments) === null || _state$cart$orderPaym === void 0 ? void 0 : _state$cart$orderPaym.filter(({
    creditCardType,
    orderPaymentStatusType
  }) => creditCardType !== 'Invalid' && orderPaymentStatusType.systemCode !== 'opstRemoved');
};
const getAllEligiblePaymentMethodDetails = state => state.cart.eligiblePaymentMethodDetails;
const getAllOrderItems = state => state.cart.orderItems;
const isFetching = state => state.cart.isFetching;
const hasOrderItems = createSelector(getAllOrderItems, orderItems => {
  return orderItems.length ? true : false;
});
const orderItemsCountSelector = createSelector(getAllOrderItems, orderItems => {
  return orderItems.length;
});
const disableInteractionSelector = createSelector([hasOrderItems, isFetching], (validOI, fetching) => {
  return !(validOI && !fetching);
});
const fulfillmentMethodSelector = createSelector(getAllOrderFulfillments, orderFulfillments => {
  let selectedFulfillmentMethod = {
    fulfillmentMethodID: ''
  };

  if (orderFulfillments[0] && orderFulfillments[0].fulfillmentMethod) {
    selectedFulfillmentMethod = orderFulfillments[0].fulfillmentMethod;
  }

  return selectedFulfillmentMethod;
});
const fulfillmentSelector = createSelector(getAllOrderFulfillments, orderFulfillments => {
  let selectedFulfillment = {
    fulfillmentMethodID: '',
    fulfillmentMethod: {
      fulfillmentMethodType: ''
    }
  };

  if (orderFulfillments[0]) {
    selectedFulfillment = orderFulfillments[0];
  }

  return selectedFulfillment;
});
const shippingAddressSelector = createSelector(fulfillmentSelector, orderFulfillment => {
  return orderFulfillment.shippingAddress || {};
});
const shippingMethodSelector = createSelector(getAllOrderFulfillments, orderFulfillments => {
  let selectedFulfillmentMethod = {
    shippingMethodID: ''
  };

  if (orderFulfillments[0] && orderFulfillments[0].shippingMethod) {
    selectedFulfillmentMethod = orderFulfillments[0].shippingMethod;
  }

  return selectedFulfillmentMethod;
});
const accountAddressSelector = createSelector([getAllAccountAddresses$1, getAllOrderFulfillments], (accountAddresses, orderFulfillments) => {
  let selectedAccountID = '';

  if (orderFulfillments.length && accountAddresses.length && orderFulfillments[0].accountAddress) {
    const selectAccount = accountAddresses.filter(({
      accountAddressID
    }) => {
      return accountAddressID === orderFulfillments[0].accountAddress.accountAddressID;
    }).map(({
      accountAddressID
    }) => {
      return accountAddressID;
    });
    selectedAccountID = selectAccount.length ? selectAccount[0] : '';
  }

  return selectedAccountID;
});
const pickupLocationOptions = createSelector(getAllPickupLocations, (locations = []) => {
  return locations.map(location => {
    return {
      name: location['NAME'],
      value: location['VALUE']
    };
  });
});
const pickupLocationSelector = createSelector(fulfillmentSelector, fulfillment => {
  let location = {
    locationID: ''
  };

  if (fulfillment.pickupLocation) {
    location = fulfillment.pickupLocation;
  }

  return location;
});
const orderPayment = createSelector(getAllOrderPayments, orderPayments => {
  let orderPayment = {
    paymentMethod: {
      paymentMethodID: ''
    },
    accountPaymentMethod: {
      accountPaymentMethodID: ''
    }
  };

  if (orderPayments.length) {
    orderPayment = orderPayments[0];
  }

  return orderPayment;
});
const eligiblePaymentMethodDetailSelector = createSelector(getAllEligiblePaymentMethodDetails, (eligiblePaymentMethodDetails = []) => {
  return eligiblePaymentMethodDetails.map(({
    paymentMethod
  }) => {
    return {
      name: paymentMethod.paymentMethodName,
      value: paymentMethod.paymentMethodID
    };
  });
});
const billingAccountAddressSelector = createSelector([getAllAccountAddresses$1, orderPayment], (accountAddresses, paymentOnOrder) => {
  let selectedAccountID = '';

  if (accountAddresses.length && paymentOnOrder && paymentOnOrder.billingAccountAddress) {
    const selectAccount = accountAddresses.filter(({
      accountAddressID
    }) => {
      return accountAddressID === paymentOnOrder.billingAccountAddress.accountAddressID;
    }).map(({
      accountAddressID
    }) => {
      return accountAddressID;
    });
    selectedAccountID = selectAccount.length ? selectAccount[0] : '';
  }

  return selectedAccountID;
});
const billingAddressNickname = createSelector([getAllAccountPaymentMethods$1, orderPayment], (accountPaymentMethods, payment) => {
  let billingAddressNickname = '';

  if (payment && payment.accountPaymentMethod) {
    billingAddressNickname = accountPaymentMethods.filter(({
      accountPaymentMethodID
    }) => {
      return accountPaymentMethodID === payment.accountPaymentMethod.accountPaymentMethodID;
    }).map(({
      accountPaymentMethodName
    }) => {
      return accountPaymentMethodName;
    });
    billingAddressNickname = billingAddressNickname.length ? billingAddressNickname[0] : '';
  }

  return billingAddressNickname;
});
const shippingAddressNicknameSelector = createSelector([fulfillmentSelector, getAllAccountAddresses$1], (fulfillment, accountAddresses = []) => {
  let shippingAddressNickname = accountAddresses.filter(accountAddress => {
    return fulfillment.shippingAddress && accountAddress.address.addressID === fulfillment.shippingAddress.addressID;
  }).map(({
    accountAddressName
  }) => {
    return accountAddressName;
  });
  shippingAddressNickname = shippingAddressNickname.length ? shippingAddressNickname[0] : '';
  return shippingAddressNickname;
});

const getAllAccountPaymentMethods = state => state.userReducer.accountPaymentMethods;
const getAllAccountAddresses = state => state.userReducer.accountAddresses;
const getPrimaryAddress = state => state.userReducer.primaryAddress;
const getWishlists = state => state.userReducer.wishList.lists;
const getWishlistsItems = state => state.userReducer.wishList.items;
const isAccountVerified = state => state.userReducer.verifiedAccountFlag;
const accountPaymentMethods = createSelector(getAllAccountPaymentMethods, (accountPaymentMethods = []) => {
  return accountPaymentMethods.map(({
    accountPaymentMethodName,
    creditCardType,
    creditCardLastFour,
    accountPaymentMethodID
  }) => {
    return {
      name: `${accountPaymentMethodName} | ${creditCardType} - *${creditCardLastFour}`,
      value: accountPaymentMethodID
    };
  });
});
const getDefaultWishlist = createSelector(getWishlists, (lists = []) => {
  return lists.length > 0 ? lists[0] : {};
});
const getItemsForDefaultWishList = createSelector(getDefaultWishlist, getWishlistsItems, (defaultWishlist = {}, items = []) => {
  return items.filter(item => {
    return item.orderTemplate_orderTemplateID === (defaultWishlist === null || defaultWishlist === void 0 ? void 0 : defaultWishlist.value);
  }).map(item => item.sku_skuID);
});

var Address = function Address(props) {
  var accountAddressID = props.accountAddressID,
      address = props.address,
      isPrimary = props.isPrimary;
  var streetAddress = address.streetAddress,
      addressID = address.addressID,
      city = address.city,
      stateCode = address.stateCode,
      postalCode = address.postalCode;
  var MySwal = withReactContent(Swal);
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs("tr", {
    children: [/*#__PURE__*/jsxs("td", {
      className: "py-3 align-middle",
      children: ["".concat(streetAddress, " ").concat(city, ", ").concat(stateCode, " ").concat(postalCode), " ", isPrimary && /*#__PURE__*/jsx("span", {
        className: "align-middle badge badge-info ml-2",
        children: t('frontend.core.prinary')
      })]
    }), /*#__PURE__*/jsxs("td", {
      className: "py-3 align-middle",
      children: [/*#__PURE__*/jsx(Link, {
        className: "nav-link-style mr-2",
        to: {
          pathname: "/my-account/addresses/".concat(addressID),
          state: _objectSpread2({}, props)
        },
        "data-toggle": "tooltip",
        children: /*#__PURE__*/jsx("i", {
          className: "far fa-edit"
        })
      }), /*#__PURE__*/jsx("button", {
        type: "button",
        className: "link-button nav-link-style text-primary",
        onClick: function onClick() {
          MySwal.fire({
            icon: 'info',
            title: /*#__PURE__*/jsx("p", {
              children: t('frontend.account.address.remove')
            }),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: t('frontend.core.delete')
          }).then(function (data) {
            if (data.isConfirmed) {
              dispatch(deleteAccountAddress(accountAddressID));
            }
          });
        },
        children: /*#__PURE__*/jsx("i", {
          className: "far fa-trash-alt"
        })
      })]
    })]
  });
};

var AccountAddresses = function AccountAddresses(_ref) {
  var title = _ref.title;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var isLoaded = useSelector(function (state) {
    return state.userReducer.isLoaded;
  });
  var accountAddresses = useSelector(getAllAccountAddresses);
  var primaryAddress = useSelector(getPrimaryAddress);

  if (isLoaded && accountAddresses.length === 0) {
    return /*#__PURE__*/jsx(Redirect, {
      to: "/my-account/addresses/new"
    });
  }

  return /*#__PURE__*/jsxs(AccountLayout, {
    title: title,
    children: [/*#__PURE__*/jsx(AccountContent, {}), accountAddresses.length > 0 && /*#__PURE__*/jsx("div", {
      className: "table-responsive font-size-md",
      children: /*#__PURE__*/jsxs("table", {
        className: "table table-hover mb-0",
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("th", {
              children: t('frontend.account.address.heading')
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.core.actions')
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: accountAddresses && accountAddresses.map(function (address, index) {
            return /*#__PURE__*/jsx(Address, _objectSpread2(_objectSpread2({}, address), {}, {
              isPrimary: address.accountAddressID === primaryAddress.accountAddressID
            }), index);
          })
        })]
      })
    }), /*#__PURE__*/jsx("hr", {
      className: "pb-4"
    }), /*#__PURE__*/jsx("div", {
      className: "text-sm-right",
      children: /*#__PURE__*/jsx(Link, {
        className: "btn btn-primary",
        to: "/my-account/addresses/new",
        children: t('frontend.account.address.add')
      })
    })]
  });
};

//https://www.samanthaming.com/tidbits/30-how-to-format-currency-in-es6/
const useFormatCurrency = ({
  code = 'en-US',
  style = 'currency',
  currency = 'USD',
  minimumFractionDigits = 2
}) => {
  return [value => new Intl.NumberFormat(code, {
    style,
    currency,
    minimumFractionDigits
  }).format(value)];
};

const headers = {};
const useGetEntity = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: [],
    error: '',
    params: {},
    entity: ''
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = { ...request.params,
        entityName: request.entity
      };
      SlatwallApiService.general.getEntity(payload, headers, source).then(response => {
        var _response$success;

        if (response.isSuccess() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess() && response.success().data && response.success().data.pageRecords) {
          setRequest({
            data: response.success().data.pageRecords,
            attributeSets: response.success().attributeSets,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else if (response.isSuccess() && response.success().data && response.success().data[request.entity]) {
          setRequest({
            data: response.success().data[request.entity],
            attributeSets: response.success().attributeSets,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: [],
            attributeSets: [],
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};
const useGetProductsByEntity = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: [],
    error: '',
    params: {},
    entity: ''
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = { ...request.params,
        entityName: 'Product'
      };
      SlatwallApiService.general.getEntity(payload, headers, source).then(response => {
        var _response$success3;

        if (response.isSuccess() && Object.keys(((_response$success3 = response.success()) === null || _response$success3 === void 0 ? void 0 : _response$success3.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          setRequest({
            data: response.success().data.pageRecords,
            attributeSets: response.success().attributeSets,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: [],
            attributeSets: [],
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};
const defaultParams = {
  products: [],
  potentialFilters: {},
  total: 0,
  pageSize: 12,
  totalPages: 1
};
const useGetProductsWithPagination = filters => {
  let [isFetching, setFetching] = useState(true);
  let [data, setData] = useState(defaultParams);
  let [error, setError] = useState({
    isError: false,
    message: ''
  });
  useEffect(() => {
    let source = axios.CancelToken.source();
    const payload = JSON.parse(filters);
    setFetching(true);
    SlatwallApiService.products.search(payload, headers, source).then(response => {
      var _response$success6;

      if (response.isSuccess() && Object.keys(((_response$success6 = response.success()) === null || _response$success6 === void 0 ? void 0 : _response$success6.errors) || {}).length) setError({
        isError: true,
        message: getErrorMessage(response.success().errors)
      });

      if (response.isSuccess()) {
        setData(response.success().data);
      } else {
        setData(defaultParams);
        setError({
          isError: true,
          message: 'Something was wrong'
        });
      }

      setFetching(false);
    });
    return () => {
      source.cancel();
    };
  }, [filters]);
  return {
    isFetching,
    records: data.products,
    potentialFilters: data.potentialFilters,
    total: data.total,
    totalPages: Math.ceil(data.total / data.pageSize),
    error
  };
};
const useGetOrderDetails = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: {},
    error: '',
    params: {}
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = request.params;
      SlatwallApiService.order.get(payload, headers, source).then(response => {
        var _response$success11;

        if (response.isSuccess() && Object.keys(((_response$success11 = response.success()) === null || _response$success11 === void 0 ? void 0 : _response$success11.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          setRequest({
            data: response.success().orderDetails,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: {},
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};
const useGetAllOrders = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: [],
    error: '',
    params: {}
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = request.params;
      SlatwallApiService.account.orders(payload, headers, source).then(response => {
        var _response$success12;

        if (response.isSuccess() && Object.keys(((_response$success12 = response.success()) === null || _response$success12 === void 0 ? void 0 : _response$success12.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          setRequest({
            data: response.success().ordersOnAccount,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: {},
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};
const useGetAccountCartsAndQuotes = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: [],
    error: '',
    params: {}
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = request.params;
      SlatwallApiService.account.cartsAndQuotes(payload, headers, source).then(response => {
        var _response$success13;

        if (response.isSuccess() && Object.keys(((_response$success13 = response.success()) === null || _response$success13 === void 0 ? void 0 : _response$success13.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          setRequest({
            data: response.success().cartsAndQuotesOnAccount.ordersOnAccount,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: {},
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};
const useResizedImageByProfileName = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: [],
    error: '',
    params: {
      profileName: 'listing',
      skuIDs: ''
    }
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = request.params;
      SlatwallApiService.products.getImagePaths(payload, headers, source).then(response => {
        var _response$success14;

        if (response.isSuccess() && Object.keys(((_response$success14 = response.success()) === null || _response$success14 === void 0 ? void 0 : _response$success14.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          setRequest({
            data: response.success().resizedImagePaths,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: {},
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};
const useGetProductImageGallery = () => {
  let [request, setRequest] = useState({
    isFetching: false,
    isLoaded: false,
    makeRequest: false,
    data: {},
    error: '',
    params: {}
  });
  useEffect(() => {
    let source = axios.CancelToken.source();

    if (request.makeRequest) {
      const payload = request.params;
      SlatwallApiService.products.getGallery(payload, headers, source).then(response => {
        var _response$success19;

        if (response.isSuccess() && Object.keys(((_response$success19 = response.success()) === null || _response$success19 === void 0 ? void 0 : _response$success19.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          setRequest({
            data: response.success(),
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {}
          });
        } else {
          setRequest({
            data: {},
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: 'Something was wrong'
          });
        }
      });
    }

    return () => {
      source.cancel();
    };
  }, [request, setRequest]);
  return [request, setRequest];
};

//https://day.js.org/docs/en/display/format

const useFormatDate = () => {
  const dateFormat = useSelector(state => state.configuration.formatting.dateFormat);

  const formateDate = dateString => dayjs(dateString).format(dateFormat);

  return [formateDate];
};

const useFormatDateTime = () => {
  const {
    dateFormat,
    timeFormat
  } = useSelector(state => state.configuration.formatting);

  const formateDate = dateTimeString => dayjs(dateTimeString).format(`${dateFormat} ${timeFormat}`);

  return [formateDate];
};

const useRedirect = ({
  shouldRedirect = false,
  location = '/',
  time = 2000
}) => {
  const history = useHistory();
  const [redirect, setRedirect] = useState(shouldRedirect);
  useEffect(() => {
    if (redirect) {
      const timer = setTimeout(() => {
        history.push(location);
      }, time);
      return () => clearTimeout(timer);
    }
  }, [history, redirect, location, time]);
  return [redirect, setRedirect];
};

const useUtilities = () => {
  let history = useHistory$1();
  const {
    basePath,
    host
  } = useSelector(state => state.configuration.theme);

  const convertToFullPath = (file = '') => {
    if (file.includes('http')) {
      return file;
    } else {
      return host + basePath + file;
    }
  };

  const eventHandlerForWSIWYG = event => {
    event.preventDefault();

    if (event.target.getAttribute('href')) {
      if (event.target.getAttribute('href').includes('.pdf')) {
        window.open(event.target.getAttribute('href'), '_blank');
        return;
      }

      if (event.target.getAttribute('href').includes('http') && !event.target.getAttribute('href').includes('.pdf')) {
        window.location.href = event.target.getAttribute('href');
      } else {
        history.push(event.target.getAttribute('href'));
      }
    }
  };

  return {
    convertToFullPath,
    eventHandlerForWSIWYG,
    cleanHTML,
    renameKeys,
    renameKeysInArrayOfObjects,
    isAuthenticated,
    containsHTML,
    isString,
    isBoolean,
    booleanToString,
    skuIdsToSkuCodes,
    parseErrorMessages,
    organizeProductTypes,
    augmentProductType,
    groupBy,
    processQueryParameters
  };
};

/*
  This will generate a list of skus that match option selection
  */
const filterSkusBySelectedOptions = (skus = [], optionsTofilter = []) => {
  return skus.filter(sku => {
    return optionsTofilter.filter(selection => sku.slug.includes(selection)).length >= optionsTofilter.length && sku;
  });
};
/*
    Will check to see if optionPair exists in a list skus
    */


const optionIsValid = (optionGroupCode, optionCode, skus = []) => {
  return skus.filter(sku => {
    return sku.slug.includes(`${optionGroupCode}=${optionCode}`);
  }).length > 0;
};
/*
    This function will flag options avaliable for
    selection based on previous selection
  
    */


const calculateAvaliableOptions = (productOptions = [], selection, skus) => {
  return productOptions.map(optGrp => {
    if (Object.keys(selection).includes(optGrp.optionGroupCode)) {
      optGrp.options.map(opt => {
        opt.available = true;
        return opt;
      });
    } else {
      optGrp.options.map(opt => {
        opt.available = optionIsValid(optGrp.optionGroupCode, opt.optionCode, skus);
        return opt;
      });
    }

    return optGrp;
  });
};
/*
    This function will check to see if any additional
    parmaters can be added as a result any options 
    being labeled non-active. 
    */


const calculateAdditionalParamters = (currentOptionGroupPairs, productOptions) => {
  const paramCandidates = productOptions.map(optGrp => {
    const validOptions = optGrp.options.filter(opt => opt.available);
    if (validOptions.length === 1 && optGrp.options.length === 1) return generateOptionGroupPair(optGrp.optionGroupCode, validOptions[0].optionCode);
    return null;
  }).filter(data => data);
  const newParams = [...new Set([...currentOptionGroupPairs, ...paramCandidates])]; // http://localhost:3006/product/test-product?soccerBallSize=5 ==>  soccerBallColor=green is added

  const paramtersAreEqual = newParams.length === currentOptionGroupPairs.length && newParams.every(element => currentOptionGroupPairs.includes(element));
  if (paramtersAreEqual) return [];
  if (!paramtersAreEqual) return paramCandidates;
};

const generateOptionGroupPair = (optionGroupCode, optionCode) => {
  return `${optionGroupCode}=${optionCode}`;
};

const useProductDetail = () => {
  return {
    filterSkusBySelectedOptions,
    optionIsValid,
    calculateAvaliableOptions,
    calculateAdditionalParamters,
    generateOptionGroupPair
  };
};

const useAccountFavorites = () => {
  const items = useSelector(getItemsForDefaultWishList);
  const isListItemsLoaded = useSelector(state => state.userReducer.wishList.isListItemsLoaded);
  let [productList, setRequest] = useGetEntity();
  let [skuList, setSkuList] = useState(items);
  const [currentPage, setPage] = useState(1);
  const countToDisplay = 6;

  if (isListItemsLoaded && !productList.isFetching && !productList.isLoaded) {
    setSkuList(items);
    setRequest({ ...productList,
      entity: 'sku',
      params: {
        'f:skuID:in': items.join(),
        'p:show': 250
      },
      makeRequest: true,
      isFetching: true,
      isLoaded: false
    });
  }

  if (skuList.length > 0 && skuList !== items) {
    setSkuList(items);
    setRequest({ ...productList,
      entity: 'sku',
      params: {
        'f:skuID:in': items.join(),
        'p:show': 250
      },
      makeRequest: true,
      isFetching: true,
      isLoaded: false
    });
  }

  const start = (currentPage - 1) * countToDisplay;
  const end = start + countToDisplay;
  return {
    skuList: productList,
    start,
    end,
    countToDisplay,
    setPage
  };
};

const useSingleAccountOrderDetails = ({
  orderInfo,
  orderFulfillments,
  orderPayments
}) => {
  const {
    orderFulfillment_shippingAddress_emailAddress,
    orderFulfillment_fulfillmentMethod_fulfillmentMethodType,
    orderFulfillment_shippingAddress_name,
    orderFulfillment_shippingAddress_streetAddress,
    orderFulfillment_shippingAddress_city,
    orderFulfillment_shippingAddress_stateCode,
    orderFulfillment_shippingAddress_postalCode,
    orderFulfillment_pickupLocation_locationName
  } = orderFulfillments;
  const {
    paymentMethod_paymentMethodType,
    paymentMethod_paymentMethodName,
    purchaseOrderNumber
  } = orderPayments != null ? orderPayments : "";
  const billingAddressDetails = {
    billingAddress: {
      name: orderPayments != null ? orderInfo.billingAddress_name || orderPayments.billingAddress_name : 'N/A',
      streetAddress: orderPayments != null ? orderInfo.billingAddress_streetAddress || orderPayments.billingAddress_streetAddress : '',
      city: orderPayments != null ? orderInfo.billingAddress_city || orderPayments.billingAddress_city : '',
      stateCode: orderPayments != null ? orderInfo.billingAddress_stateCode || orderPayments.billingAddress_stateCode : '',
      postalCode: orderPayments != null ? orderInfo.billingAddress_postalCode || orderPayments.billingAddress_postalCode : '',
      emailAddress: orderPayments != null ? orderInfo.billingAddress_emailAddress || orderPayments.billingAddress_emailAddress : ''
    }
  };
  let shippingAddressDetails = {};
  let pickupLocationDetails = {};
  let termPaymentDetails = {};
  let creditCardPaymentDetails = {};
  let giftCardPaymentDetails = {};
  let cashPaymentDetails = {};

  if (orderFulfillment_fulfillmentMethod_fulfillmentMethodType === 'shipping') {
    shippingAddressDetails = {
      name: orderFulfillment_shippingAddress_name,
      streetAddress: orderFulfillment_shippingAddress_streetAddress,
      city: orderFulfillment_shippingAddress_city,
      emailAddress: orderFulfillment_shippingAddress_emailAddress,
      stateCode: orderFulfillment_shippingAddress_stateCode,
      postalCode: orderFulfillment_shippingAddress_postalCode
    };
  }

  if (orderFulfillment_fulfillmentMethod_fulfillmentMethodType === 'pickup') {
    pickupLocationDetails = {
      locationName: orderFulfillment_pickupLocation_locationName
    };
  }

  if (paymentMethod_paymentMethodType !== undefined) {
    if (paymentMethod_paymentMethodType === 'creditCard') {
      creditCardPaymentDetails = { ...orderPayments,
        paymentMethod: {
          paymentMethodName: orderPayments.paymentMethod_paymentMethodName
        }
      };
    }

    if (paymentMethod_paymentMethodType === 'giftCard') {
      giftCardPaymentDetails = {};
    }

    if (paymentMethod_paymentMethodType === 'cash') {
      cashPaymentDetails = {};
    }

    if (paymentMethod_paymentMethodType === 'termPayment') {
      termPaymentDetails = {
        purchaseOrderNumber: purchaseOrderNumber,
        paymentMethod: {
          paymentMethodName: paymentMethod_paymentMethodName
        }
      };
    }
  }

  return {
    billingAddressDetails,
    shippingAddressDetails,
    pickupLocationDetails,
    termPaymentDetails,
    creditCardPaymentDetails,
    giftCardPaymentDetails,
    cashPaymentDetails,
    paymentMethodType: paymentMethod_paymentMethodType
  };
};

const useCartLineItem = orderItemID => {
  const {
    isFetching,
    orderItems
  } = useSelector(state => state.cart);
  const productRouting = useSelector(getProductRoute);
  const orderItem = orderItems.filter(orderItem => {
    return orderItem.orderItemID === orderItemID;
  })[0];
  const {
    skuPrices = []
  } = orderItem.sku;
  const listPrice = skuPrices.map(price => price.listPrice).sort((a, b) => a - b)[0] || 0;
  const isBackordered = false;
  return {
    orderItem,
    listPrice,
    productRouting,
    isFetching,
    isBackordered
  };
};

const useProductImage = ({
  skuID,
  imageFile,
  defaultSku_imageFile,
  forceImageCall = false
}) => {
  const imageFallbackFlag = useSelector(getImageFallbackFlag);
  let [imageRequest, setImageRequest] = useResizedImageByProfileName();
  const callForImage = (!imageFile || !defaultSku_imageFile) && (imageFallbackFlag || forceImageCall);
  useEffect(() => {
    let didCancel = false;

    if (!didCancel && !imageRequest.isFetching && !imageRequest.isLoaded && callForImage) {
      setImageRequest({ ...imageRequest,
        params: {
          skuIDs: skuID,
          profileName: 'listing'
        },
        makeRequest: true,
        isFetching: true,
        isLoaded: false
      });
    }

    return () => {
      didCancel = true;
    };
  }, [imageRequest, setImageRequest, skuID, callForImage]);
  return {
    callForImage,
    imageRequest
  };
};

/*

Probably should move to this eventually 
https://react-slick.neostack.com/docs/example/custom-paging
*/

const useProductDetailGallery = ({
  productID,
  skuID,
  imageFile
}) => {
  var _filterImages, _filterImages2, _filterImages3;

  let [productImageGallery, setRequest] = useGetProductImageGallery();
  const [sliders, setSliders] = useState({
    nav1: null,
    nav2: null
  });
  const slider1 = useRef();
  const slider2 = useRef();
  useEffect(() => {
    setSliders({
      nav1: slider1.current,
      nav2: slider2.current
    });

    if (!productImageGallery.isLoaded && !productImageGallery.isFetching) {
      setRequest({ ...productImageGallery,
        isFetching: true,
        isLoaded: false,
        params: {
          productID,
          resizeSizes: 'large,small'
        },
        makeRequest: true
      });
    }
  }, [productImageGallery, setRequest, productID]);
  let filterImages = [];

  if (productImageGallery.isLoaded) {
    var _productImageGallery$, _productImageGallery$2;

    filterImages = (_productImageGallery$ = productImageGallery.data) === null || _productImageGallery$ === void 0 ? void 0 : (_productImageGallery$2 = _productImageGallery$.images) === null || _productImageGallery$2 === void 0 ? void 0 : _productImageGallery$2.filter(({
      ASSIGNEDSKUIDLIST = false,
      TYPE
    }) => {
      return TYPE === 'skuDefaultImage' || TYPE === 'productAlternateImage' || ASSIGNEDSKUIDLIST && ASSIGNEDSKUIDLIST.includes(skuID);
    }).filter(({
      RESIZEDIMAGEPATHS = []
    }) => {
      return RESIZEDIMAGEPATHS[0] && !RESIZEDIMAGEPATHS[0].includes('missingimage');
    });
  }

  if (((_filterImages = filterImages) === null || _filterImages === void 0 ? void 0 : _filterImages.length) === 0) {
    filterImages = [{
      ORIGINALPATH: '',
      NAME: '',
      RESIZEDIMAGEPATHS: ['', '', '']
    }];
  }

  (_filterImages2 = filterImages) === null || _filterImages2 === void 0 ? void 0 : _filterImages2.unshift(filterImages.splice(filterImages.findIndex(item => item.ORIGINALFILENAME === imageFile), 1)[0]);
  filterImages = (_filterImages3 = filterImages) === null || _filterImages3 === void 0 ? void 0 : _filterImages3.reverse();
  return {
    productImageGallery,
    sliders,
    slider1,
    slider2,
    filterImages
  };
};

const useProductPrice = ({
  salePrice,
  listPrice,
  type = 'product'
}) => {
  const {
    isAuthenticated,
    isString
  } = useUtilities();
  if (isString(salePrice)) salePrice = salePrice.trim().length > 0 ? parseInt(salePrice) : 0;
  if (isString(listPrice)) listPrice = listPrice.trim().length > 0 ? parseInt(listPrice) : 0;
  let showSalePrice = true;
  let showListPrice = true;
  let showMissingPrice = false;
  const isAuthed = isAuthenticated();
  const isVerified = useSelector(isAccountVerified);
  /*   
  Unauthenticated Rules
    - Only look at list price for pricing display
    - Dont show a Zero list price
    - if we know list and sale price are both Zero dont let the user add it to the cart
             list  sale
   Case 1:    0     0
   Case 2:    0     5
   Case 3:    5     5
   Case 4:    5     0
   Case 5:    10    5
   Case 6:    5     10
   */

  if (!isAuthed || !isVerified) {
    showSalePrice = false; // Case 1-5

    if (listPrice <= 0) {
      // Case 1
      showMissingPrice = true;
      showListPrice = false;
    }
  }
  /*   
  Authenticated Rules
    - Dont show a Sale price for of list and sale are Zero
    - if we know list and sale price are both Zero dont let the user add it to the cart
             list  sale
   Case 7:    0     0
   Case 8:    0     5
   Case 9:    5     5
   Case 10:   5     0
   Case 11:   10    5
   Case 12:   5     10
   */


  if (isAuthed && isVerified) {
    showListPrice = false;

    if (salePrice <= 0 && listPrice <= 0) {
      // Case 7
      showMissingPrice = true;
      showSalePrice = false;
    }

    if (salePrice < listPrice) showListPrice = true; // Case 11
  }

  const showAddToCart = !(salePrice <= 0 && listPrice <= 0);
  return {
    showAddToCart,
    showSalePrice,
    showListPrice,
    showMissingPrice
  };
};

const buildPath = params => {
  return queryString.stringify(params, {
    arrayFormat: 'comma'
  });
};

const useReconcile = ({
  option,
  brand,
  attribute,
  category,
  priceRange,
  productType
}) => {
  const loc = useLocation();
  let core = queryString.parse(loc.search, {
    arrayFormat: 'separator',
    arrayFormatSeparator: ','
  });
  let queryStringParams = queryString.parse(loc.search, {
    arrayFormat: 'separator',
    arrayFormatSeparator: ','
  });

  const evaluation = ({
    qs,
    facetKey,
    facetIdentifier,
    filter
  }) => {
    if (qs[facetKey] && qs[facetKey].length) {
      let params = Array.isArray(qs[facetKey]) ? qs[facetKey] : [qs[facetKey]];
      const missingFilter = params.filter(optionToValidate => !filter.options.filter(opt => opt[facetIdentifier] === optionToValidate).map(data => data).length ? optionToValidate : false).filter(data => data);

      if (missingFilter.length > 0) {
        qs[facetKey] = params.filter(param => !missingFilter.includes(param));
        return qs;
      }
    }

    return qs;
  };

  if (category && category !== {}) {
    [category].forEach(filter => {
      queryStringParams = evaluation({
        filter,
        qs: queryStringParams,
        facetIdentifier: 'name',
        facetKey: `category`
      });
    });
  } else {
    Object.keys(queryStringParams).filter(paramKey => paramKey === 'category').forEach(keyToDelete => {
      delete queryStringParams[keyToDelete];
    });
  }

  if (productType && productType !== {}) {
    [productType].forEach(filter => {
      queryStringParams = evaluation({
        filter,
        qs: queryStringParams,
        facetIdentifier: 'slug',
        facetKey: `productType_slug`
      });
    });
  }

  if (brand && brand !== {}) [brand].forEach(filter => {
    queryStringParams = evaluation({
      filter,
      qs: queryStringParams,
      facetIdentifier: 'slug',
      facetKey: `brand_slug`
    });
  });
  if (priceRange && priceRange !== {}) [priceRange].forEach(filter => {
    queryStringParams = evaluation({
      filter,
      qs: queryStringParams,
      facetIdentifier: 'value',
      facetKey: `priceRange`
    });
  });

  if (attribute && attribute.subFacets) {
    Object.keys(attribute.subFacets).forEach(facetKey => {
      return [attribute.subFacets[facetKey]].forEach(filter => {
        queryStringParams = evaluation({
          filter,
          qs: queryStringParams,
          facetIdentifier: 'name',
          facetKey: `attribute_${facetKey}`
        });
      });
    });
  } else {
    Object.keys(queryStringParams).filter(paramKey => paramKey.includes('attribute_')).forEach(keyToDelete => {
      delete queryStringParams[keyToDelete];
    });
  }

  if (option && option.subFacets) {
    Object.keys(option.subFacets).forEach(facetKey => {
      return [option.subFacets[facetKey]].forEach(filter => {
        queryStringParams = evaluation({
          filter,
          qs: queryStringParams,
          facetIdentifier: 'name',
          facetKey: `option_${facetKey}`
        });
      });
    });
  } else {
    Object.keys(queryStringParams).filter(paramKey => paramKey.includes('option_')).forEach(keyToDelete => {
      delete queryStringParams[keyToDelete];
    });
  }

  return {
    shouldUpdate: JSON.stringify(queryStringParams) !== JSON.stringify(core),
    queryStringParams
  };
};

const useListing = preFilter => {
  const loc = useLocation();
  const productSearch = useSelector(state => state.configuration.productSearch);
  const initialData = useSelector(state => state.configuration.productSearchFilters);
  let history = useHistory();
  let params = processQueryParameters(loc.search);
  params = { ...initialData,
    ...params,
    ...preFilter
  };
  const returnFacetList = !!params['brand_slug'] || !!params['productType_slug'] ? 'brand,option,attribute,sorting,priceRange,productType' : 'brand,sorting,productType';
  const cachedFilters = JSON.stringify({ ...params,
    ...productSearch,
    returnFacetList
  });
  let {
    isFetching,
    records,
    potentialFilters,
    total,
    totalPages,
    error
  } = useGetProductsWithPagination(cachedFilters);
  const {
    shouldUpdate,
    queryStringParams
  } = useReconcile({ ...potentialFilters
  });

  const setPage = pageNumber => {
    params['currentPage'] = pageNumber;
    history.push({
      pathname: loc.pathname,
      search: buildPath(params)
    });
  };

  const setKeyword = keyword => {
    params = { ...params,
      ...initialData,
      ...preFilter,
      orderBy: params.orderBy,
      keyword: keyword
    };
    history.push({
      pathname: loc.pathname,
      search: buildPath(params)
    });
  };

  const setSort = orderBy => {
    params['orderBy'] = orderBy;
    params['currentPage'] = 1;
    history.push({
      pathname: loc.pathname,
      search: buildPath(params)
    });
  };

  const updateAttribute = (attribute, scrollKey) => {
    var _params$attribute$fil;

    let attributeFilters = ((_params$attribute$fil = params[attribute.filterName]) === null || _params$attribute$fil === void 0 ? void 0 : _params$attribute$fil.split(',').filter(data => data)) || [];

    if (attributeFilters.includes(attribute.name)) {
      attributeFilters = attributeFilters.filter(item => item !== attribute.name);
    } else {
      attributeFilters.push(attribute.name);
    }

    params[attribute.filterName] = attributeFilters;
    params['currentPage'] = 1; // This is a check for if we deselct a brand or Poroduct type and need to reset other checked params

    if (Object.keys(params).length >= 6 && !params.brand_slug.length && !params.productType_slug.length) {
      params = { ...initialData,
        ...preFilter,
        orderBy: params.orderBy,
        keyword: params.keyword
      };
    }

    history.push({
      pathname: loc.pathname,
      search: buildPath(params),
      hash: scrollKey
    });
  };

  if (shouldUpdate && !isFetching) {
    const path = queryString.stringify(queryStringParams, {
      arrayFormat: 'comma'
    });
    params = processQueryParameters(path);
    history.replace({
      pathname: loc.pathname,
      search: path
    });
  }

  return {
    records,
    potentialFilters,
    isFetching,
    total,
    totalPages,
    error,
    setSort,
    updateAttribute,
    setPage,
    setKeyword,
    params
  };
};

const useListingFilter = (options, selectType, facetKey) => {
  const loc = useLocation$1();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const getAppliedFilters = facetKey => {
    const qs = queryString.parse(loc.search, {
      arrayFormat: 'separator',
      arrayFormatSeparator: ','
    });

    if (qs[facetKey]) {
      return Array.isArray(qs[facetKey]) ? qs[facetKey] : [qs[facetKey]];
    }

    return [];
  };

  const appliedFilters = getAppliedFilters(facetKey);
  useEffect(() => {
    let results = options;

    if (searchTerm.length) {
      results = options.filter(option => option.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    if (selectType === 'single') {
      const selectedResults = options.filter(option => {
        return appliedFilters.includes(option.name);
      });

      if (selectedResults.length !== 0) {
        results = selectedResults;
      }
    }

    setSearchResults([...results]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, options]);
  return {
    searchTerm,
    setSearchTerm,
    searchResults,
    appliedFilters
  };
};

const useFilterFormatter = ({
  option,
  brand,
  attribute,
  category,
  priceRange,
  productType
}) => {
  const [formatCurrency] = useFormatCurrency({});

  if (category && category.options) {
    category.options = category.options.map(option => {
      return { ...option,
        displayName: option.name
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  }

  if (productType && productType.options) {
    productType.options = productType.options.map(option => {
      return { ...option,
        displayName: option.name
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  }

  if (brand && brand.options) {
    brand.options = brand.options.map(option => {
      return { ...option,
        displayName: option.name
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  }

  if (priceRange && priceRange.options) {
    priceRange.options = priceRange.options.map(option => {
      const ranges = option.name.split('-');

      if (ranges.length !== 2) {
        return { ...option,
          displayName: option.name
        };
      }

      const name = formatCurrency(parseFloat(ranges[0])) + ' - ' + formatCurrency(parseFloat(ranges[1]));
      return {
        displayName: name,
        name: option.name,
        value: option.value,
        legacyName: option.name
      };
    });
  }

  if (option && option.subFacets) {
    Object.keys(option.subFacets).map(subFact => {
      let thisSubFacet = option.subFacets[subFact];
      thisSubFacet.options = thisSubFacet.options.map(option => {
        return { ...option,
          displayName: option.name
        };
      }).sort((a, b) => a.sortOrder - b.sortOrder);
      return thisSubFacet;
    });
  }

  if (attribute && attribute.subFacets) {
    Object.keys(attribute.subFacets).map(subFact => {
      let thisSubFacet = attribute.subFacets[subFact];
      thisSubFacet.options = thisSubFacet.options.map(option => {
        return { ...option,
          displayName: option.name
        };
      }).sort((a, b) => a.sortOrder - b.sortOrder);
      return thisSubFacet;
    });
  }

  return {
    option,
    brand,
    attribute,
    category,
    priceRange,
    productType
  };
};

var CreateOrEditAccountAddress = function CreateOrEditAccountAddress(_ref) {
  var path = _ref.path,
      heading = _ref.heading,
      _ref$redirectLocation = _ref.redirectLocation,
      redirectLocation = _ref$redirectLocation === void 0 ? '/my-account/addresses' : _ref$redirectLocation,
      customBody = _ref.customBody,
      contentTitle = _ref.contentTitle,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? 'Account Address' : _ref$action;

  var _useRedirect = useRedirect({
    location: redirectLocation
  }),
      _useRedirect2 = _slicedToArray(_useRedirect, 2),
      redirect = _useRedirect2[0],
      setRedirect = _useRedirect2[1];

  var dispatch = useDispatch();
  var accountAddresses = useSelector(function (state) {
    return state.userReducer.accountAddresses;
  });
  var countryCodeOptions = useSelector(function (state) {
    return state.content.countryCodeOptions;
  });
  var stateCodeOptions = useSelector(function (state) {
    return state.content.stateCodeOptions;
  });
  var isFetching = useSelector(function (state) {
    return state.content.isFetching;
  });
  var filteredAddress = accountAddresses.filter(function (address) {
    return address.address.addressID === path;
  });
  var isEdit = filteredAddress.length ? true : false;
  var accountAddress = filteredAddress.length ? filteredAddress[0] : null;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      accountAddressID: accountAddress ? accountAddress.accountAddressID : '',
      accountAddressName: accountAddress ? accountAddress.accountAddressName : '',
      countryCode: accountAddress ? accountAddress.address.countryCode : 'US',
      name: accountAddress ? accountAddress.address.name : '',
      company: accountAddress ? accountAddress.address.company : '',
      emailAddress: accountAddress ? accountAddress.address.emailAddress : '',
      phoneNumber: accountAddress ? accountAddress.address.phoneNumber : '',
      streetAddress: accountAddress ? accountAddress.address.streetAddress : '',
      street2Address: accountAddress ? accountAddress.address.street2Address : '',
      city: accountAddress ? accountAddress.address.city : '',
      stateCode: accountAddress ? accountAddress.address.stateCode : '',
      postalCode: accountAddress ? accountAddress.address.postalCode : ''
    },
    onSubmit: function onSubmit(values) {
      // TODO: Dispatch Actions
      if (isEdit) {
        dispatch(updateAccountAddress(values));
      } else {
        dispatch(addNewAccountAddress(values));
      }

      setRedirect(_objectSpread2(_objectSpread2({}, redirect), {}, {
        shouldRedirect: true
      }));
    }
  });
  useEffect(function () {
    if (countryCodeOptions.length === 0 && !isFetching) {
      dispatch(getCountries());
    }

    if (!stateCodeOptions[formik.values.countryCode] && !isFetching) {
      dispatch(getStateCodeOptionsByCountryCode(formik.values.countryCode));
    }
  }, [dispatch, formik, stateCodeOptions, countryCodeOptions, isFetching]);
  return /*#__PURE__*/jsxs(AccountLayout, {
    title: "Add ".concat(action),
    children: [/*#__PURE__*/jsx(AccountContent, {
      customBody: customBody,
      contentTitle: contentTitle
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/jsx("h2", {
        children: heading
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "accountAddressName",
            children: t('frontend.account.nickname')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "accountAddressName",
            value: formik.values['accountAddressName'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "name",
            children: t('frontend.account.fullname')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "name",
            value: formik.values['name'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "company",
            children: t('frontend.account.company')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "company",
            value: formik.values['company'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsxs("label", {
            htmlFor: "phoneNumber",
            children: [t('frontend.account.phoneNumber'), " "]
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "phoneNumber",
            pattern: "[0-9.]+",
            value: formik.values['phoneNumber'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsxs("label", {
            htmlFor: "phoneNumber",
            children: [t('frontend.account.emailAddress'), " "]
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "email",
            id: "emailAddress",
            value: formik.values['emailAddress'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "countryCode",
            children: t('frontend.account.countryCode')
          }), /*#__PURE__*/jsx(SwSelect, {
            id: "countryCode",
            value: formik.values.countryCode,
            onChange: function onChange(e) {
              e.preventDefault();
              dispatch(getStateCodeOptionsByCountryCode(e.target.value));
              formik.handleChange(e);
            },
            options: countryCodeOptions
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "streetAddress",
            children: t('frontend.account.streetAddress')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "streetAddress",
            value: formik.values['streetAddress'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "street2Address",
            children: t('frontend.account.street2Address')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "street2Address",
            value: formik.values['street2Address'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "city",
            children: t('frontend.account.city')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "city",
            value: formik.values['city'],
            onChange: formik.handleChange
          })]
        }), stateCodeOptions[formik.values.countryCode] && stateCodeOptions[formik.values.countryCode].length > 0 && /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-3",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "stateCode",
            children: t('frontend.account.stateCode')
          }), /*#__PURE__*/jsx(SwSelect, {
            id: "stateCode",
            value: formik.values['stateCode'],
            onChange: function onChange(e) {
              e.preventDefault();
              formik.handleChange(e);
            },
            options: stateCodeOptions[formik.values.countryCode]
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-3",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "postalCode",
            children: t('frontend.account.postalCode')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "postalCode",
            value: formik.values['postalCode'],
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "col-12",
          children: [/*#__PURE__*/jsx("hr", {
            className: "mt-2 mb-3"
          }), /*#__PURE__*/jsx("div", {
            className: "d-flex flex-wrap justify-content-end",
            children: /*#__PURE__*/jsx("button", {
              type: "submit",
              className: "btn btn-primary mt-3 mt-sm-0",
              children: isEdit ? "".concat(t('frontend.core.save'), " ").concat(action) : "".concat(t('frontend.core.saveNew'), " ").concat(action)
            })
          })]
        })]
      })]
    })]
  });
};

var AccountContent = function AccountContent() {
  var loc = useLocation();
  var content = useSelector(function (state) {
    return state.content[loc.pathname.substring(1)];
  });

  var _ref = content || {},
      _ref$customBody = _ref.customBody,
      customBody = _ref$customBody === void 0 ? '' : _ref$customBody,
      _ref$contentSubtitle = _ref.contentSubtitle,
      contentSubtitle = _ref$contentSubtitle === void 0 ? '' : _ref$contentSubtitle;

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "d-flex justify-content-between align-items-center pt-lg-2 pb-4 pb-lg-5 mb-lg-3",
      children: /*#__PURE__*/jsx("div", {
        className: "d-flex justify-content-between w-100",
        children: /*#__PURE__*/jsx("h5", {
          className: "h5",
          children: contentSubtitle
        })
      })
    }), /*#__PURE__*/jsx("div", {
      onClick: eventHandlerForWSIWYG,
      dangerouslySetInnerHTML: {
        __html: customBody
      }
    })]
  });
};

var AccountToolBar = function AccountToolBar(_ref) {
  var term = _ref.term,
      updateTerm = _ref.updateTerm,
      search = _ref.search;
  return /*#__PURE__*/jsx("div", {
    className: "d-flex justify-content-between align-items-center pt-lg-2 pb-4 pb-lg-5 mb-lg-3",
    children: /*#__PURE__*/jsx("div", {
      className: "d-flex justify-content-between w-100",
      children: /*#__PURE__*/jsxs("div", {
        className: "input-group-overlay d-lg-flex mr-3 w-50",
        children: [/*#__PURE__*/jsx("input", {
          className: "form-control appended-form-control",
          type: "text",
          value: term,
          required: true,
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter') {
              e.preventDefault();

              if (e.target.checkValidity()) {
                search();
              }
            }
          },
          onChange: function onChange(event) {
            event.preventDefault();
            updateTerm(event.target.value);
          },
          placeholder: "Search item #, order #, or PO"
        }), /*#__PURE__*/jsx("div", {
          className: "input-group-append-overlay",
          children: /*#__PURE__*/jsx("span", {
            className: "input-group-text",
            children: /*#__PURE__*/jsx("i", {
              className: "far fa-search",
              style: {
                cursor: 'pointer'
              },
              onClick: function onClick(event) {
                event.preventDefault();
                search();
              }
            })
          })
        })]
      })
    })
  });
};

var AccountFavorites = function AccountFavorites() {
  var _useAccountFavorites = useAccountFavorites(),
      skuList = _useAccountFavorites.skuList,
      start = _useAccountFavorites.start,
      end = _useAccountFavorites.end,
      countToDisplay = _useAccountFavorites.countToDisplay,
      setPage = _useAccountFavorites.setPage;

  var products = skuList.data.slice(start, end).map(function (sku) {
    return _objectSpread2(_objectSpread2({}, sku), {}, {
      productName: sku.product_productName,
      productCode: sku.product_productCode,
      brandUrlTitle: sku.product_brand_urlTitle,
      brandName: sku.product_brand_brandName,
      urlTitle: sku.product_urlTitle
    });
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(AccountLayout, {
    children: [/*#__PURE__*/jsx("div", {
      className: "d-flex justify-content-between align-items-center pt-lg-2 pb-4 pb-lg-5 mb-lg-3",
      children: /*#__PURE__*/jsx("div", {
        className: "d-flex justify-content-between w-100",
        children: "\xA0"
      })
    }), !skuList.isFetching && products.length === 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: "alert alert-info",
        role: "alert",
        children: t('frontend.account.favorites.none')
      }), /*#__PURE__*/jsx("hr", {
        className: "pb-4"
      }), /*#__PURE__*/jsx("div", {
        className: "text-sm-left",
        children: /*#__PURE__*/jsx(Link, {
          className: "btn btn-primary",
          to: "/",
          children: t('frontend.homepage')
        })
      })]
    }), products.length > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Grid, {
        isFetching: skuList.isFetching,
        products: products
      }), /*#__PURE__*/jsx(ListingPagination, {
        recordsCount: skuList.data.length,
        totalPages: Math.ceil(skuList.data.length / countToDisplay),
        setPage: setPage
      })]
    })]
  });
};

var isSelectedClass = 'bg-secondary  mb-0 text-primary';

var AccountSidebar = function AccountSidebar() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var loc = useLocation();
  var accountMenu = useSelector(getMyAccountMenu);
  var user = useSelector(function (state) {
    return state.userReducer;
  });
  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      disableButton = _useState2[0],
      setdisableButton = _useState2[1];

  return /*#__PURE__*/jsx("aside", {
    className: "col-lg-4 pt-4 pt-lg-0",
    children: /*#__PURE__*/jsxs("div", {
      className: "cz-sidebar-static rounded-lg box-shadow-lg px-0 pb-0 mb-5 mb-lg-0",
      children: [/*#__PURE__*/jsx("div", {
        className: "px-4 mb-4",
        children: /*#__PURE__*/jsx("div", {
          className: "media align-items-center",
          children: /*#__PURE__*/jsxs("div", {
            className: "media-body",
            children: [/*#__PURE__*/jsx("h3", {
              className: "font-size-base mb-0",
              children: "".concat(user.firstName, " ").concat(user.lastName)
            }), /*#__PURE__*/jsx("button", {
              type: "button",
              disabled: disableButton,
              onClick: function onClick() {
                setdisableButton(true);
                dispatch(logout(t('frontend.account.logout.success'), t('frontend.account.logout.failure')));
              },
              className: "link-button text-accent font-size-sm",
              children: t('frontend.core.logout')
            }), /*#__PURE__*/jsx("br", {})]
          })
        })
      }), /*#__PURE__*/jsxs("ul", {
        className: "list-unstyled mb-0 ",
        children: [/*#__PURE__*/jsx("li", {
          className: "border-bottom mb-0 ".concat(loc.pathname === "/my-account" && isSelectedClass),
          children: /*#__PURE__*/jsxs(Link, {
            to: '/my-account',
            className: "nav-link-style d-flex align-items-center px-4 py-3",
            children: [/*#__PURE__*/jsx("i", {
              className: "far pr-2"
            }), " ", t('frontend.account.overview')]
          })
        }, '/my-account'), accountMenu.map(function (_ref) {
          var contentID = _ref.contentID,
              urlTitlePath = _ref.urlTitlePath,
              title = _ref.title;
          return /*#__PURE__*/jsx("li", {
            className: "border-bottom mb-0 ".concat(loc.pathname.startsWith("/".concat(urlTitlePath)) && isSelectedClass),
            children: /*#__PURE__*/jsxs(Link, {
              to: "/".concat(urlTitlePath),
              className: "nav-link-style d-flex align-items-center px-4 py-3",
              children: [/*#__PURE__*/jsx("i", {
                className: "far pr-2"
              }), " ", title]
            })
          }, contentID);
        })]
      })]
    })
  });
};

var AccountHeader = function AccountHeader() {
  var loc = useLocation();
  var content = useSelector(function (state) {
    return state.content[loc.pathname.substring(1)];
  });

  var _ref2 = content || {},
      title = _ref2.title;

  return /*#__PURE__*/jsx("div", {
    className: "page-title-overlap bg-lightgray pt-4",
    children: /*#__PURE__*/jsxs("div", {
      className: "container d-lg-flex justify-content-between py-2 py-lg-3",
      children: [/*#__PURE__*/jsx("div", {
        className: "order-lg-2 mb-3 mb-lg-0 pt-lg-2"
      }), /*#__PURE__*/jsx("div", {
        className: "order-lg-1 pr-lg-4 text-center text-lg-left",
        children: /*#__PURE__*/jsx("h1", {
          className: "h3 mb-0",
          children: title
        })
      })]
    })
  });
};

var MyAccountLayout = function MyAccountLayout(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(AccountHeader, {}), /*#__PURE__*/jsx("div", {
      className: "container pb-5 mb-2 mb-md-3",
      children: /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx(AccountSidebar, {}), /*#__PURE__*/jsx("section", {
          className: "col-lg-8",
          children: children
        })]
      })
    })]
  });
};

var PromptLayout = function PromptLayout(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/jsx("div", {
    className: "container py-4 py-lg-5 my-4",
    children: /*#__PURE__*/jsx("div", {
      className: "row d-flex justify-content-center",
      children: /*#__PURE__*/jsx("div", {
        className: "col-md-6",
        children: /*#__PURE__*/jsx("div", {
          className: "card box-shadow",
          children: /*#__PURE__*/jsx("div", {
            className: "card-body",
            children: children
          })
        })
      })
    })
  });
};

var AccountLayout = MyAccountLayout;

var LoginForm = function LoginForm() {
  var dispatch = useDispatch();
  var match = useRouteMatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var location = useLocation$2();
  var formik = useFormik({
    initialValues: {
      loginEmail: '',
      loginPassword: ''
    },
    validateOnChange: false,
    validationSchema: Yup.object().shape({
      loginEmail: Yup.string().email('Invalid email').required('Required'),
      loginPassword: Yup.string().required('Required')
    }),
    onSubmit: function onSubmit(values) {
      dispatch(requestLogin());
      dispatch(requestUser());
      dispatch(requestCart());
      var payload = {
        emailAddress: values.loginEmail,
        password: values.loginPassword,
        returnJSONObjects: 'account,cart'
      };
      SlatwallApiService.auth.login(payload).then(function (response) {
        if (response.isSuccess() && (response.success().errors === undefined || response.success().errors === null)) {
          dispatch(receiveLogin({
            isAuthenticanted: true
          }));
          dispatch(receiveUser(response.success().account));
          dispatch(receiveCart(response.success().cart));
          dispatch(getWishLists());
          toast.success(t('frontend.account.auth.success'));
        } else {
          var _response$success, _response$success$err;

          var errorMessage;

          if (Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length && Object.keys(((_response$success$err = response.success().errors) === null || _response$success$err === void 0 ? void 0 : _response$success$err.passwordUpdateRequired) || {}).length) {
            errorMessage = t('frontend.account.auth.passwordUpdate');
          } else {
            var _response$success2;

            errorMessage = response.success() && Object.keys(((_response$success2 = response.success()) === null || _response$success2 === void 0 ? void 0 : _response$success2.errors) || {}).length ? getErrorMessage(response.success().errors) : t('frontend.account.auth.failure');
          }

          toast.error(errorMessage);
          dispatch(errorLogin());
        }

        formik.setSubmitting(false);
      });
    }
  });
  return /*#__PURE__*/jsx("div", {
    className: "col-md-6",
    children: /*#__PURE__*/jsx("div", {
      className: "card box-shadow",
      children: /*#__PURE__*/jsxs("div", {
        className: "card-body",
        children: [/*#__PURE__*/jsx("h2", {
          className: "h4 mb-1",
          children: t('frontend.account.sign_in')
        }), /*#__PURE__*/jsxs("p", {
          className: "font-size-sm text-muted mb-4",
          children: ["".concat(t('frontend.account.no_account'), " "), " ", /*#__PURE__*/jsx(Link, {
            to: "".concat(match.path, "/createAccount").concat(location.search),
            children: t('frontend.account.request')
          }), "."]
        }), /*#__PURE__*/jsxs("form", {
          onSubmit: formik.handleSubmit,
          children: [/*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "loginEmail",
              children: t('frontend.account.email')
            }), /*#__PURE__*/jsx("input", {
              value: formik.values.loginEmail,
              onBlur: formik.handleBlur,
              onChange: formik.handleChange,
              autoComplete: "email",
              className: "form-control",
              type: "email",
              id: "loginEmail"
            }), formik.errors.loginEmail && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.loginEmail
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "loginPassword",
              children: t('frontend.account.password')
            }), /*#__PURE__*/jsx("input", {
              value: formik.values.loginPassword,
              onBlur: formik.handleBlur,
              onChange: formik.handleChange,
              autoComplete: "current-password",
              className: "form-control",
              type: "password",
              id: "loginPassword"
            }), formik.errors.loginPassword && formik.touched.loginPassword && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.loginPassword
            })]
          }), /*#__PURE__*/jsx("div", {
            className: "text-right",
            children: /*#__PURE__*/jsx(Link, {
              to: "".concat(match.path, "/forgotPassword"),
              className: "nav-link-inline font-size-sm",
              children: t('frontend.account.forgot_password')
            })
          }), /*#__PURE__*/jsx("hr", {
            className: "mt-4"
          }), /*#__PURE__*/jsx("div", {
            className: "text-right pt-4",
            children: /*#__PURE__*/jsx("button", {
              className: "btn btn-primary",
              disabled: formik.isSubmitting,
              type: "submit",
              children: t('frontend.account.sign_in')
            })
          })]
        })]
      })
    })
  });
};

var AccountLogin = function AccountLogin() {
  return /*#__PURE__*/jsx("div", {
    className: "container py-4 py-lg-5 my-4",
    children: /*#__PURE__*/jsx("div", {
      className: "row d-flex justify-content-center",
      children: /*#__PURE__*/jsx(LoginForm, {})
    })
  });
};

var AccountOrderDetail = function AccountOrderDetail(props) {
  var orderID = props.path;

  var _useGetOrderDetails = useGetOrderDetails(),
      _useGetOrderDetails2 = _slicedToArray(_useGetOrderDetails, 2),
      order = _useGetOrderDetails2[0],
      setRequest = _useGetOrderDetails2[1];

  useEffect(function () {
    var didCancel = false;

    if (!order.isFetching && !order.isLoaded && !didCancel) {
      setRequest(_objectSpread2(_objectSpread2({}, order), {}, {
        isFetching: true,
        isLoaded: false,
        params: {
          orderID: orderID
        },
        makeRequest: true
      }));
    }

    return function () {
      didCancel = true;
    };
  }, [order, orderID, setRequest]);
  return /*#__PURE__*/jsxs(AccountLayout, {
    title: "Order: ".concat(order.isLoaded && order.data.orderInfo[0].orderNumber || ''),
    children: [/*#__PURE__*/jsx(OrderToolbar, {
      delivered: order.isLoaded && order.data.orderInfo[0].orderStatusType_typeName
    }), order.isLoaded && /*#__PURE__*/jsx(OrderDetails, {
      orderInfo: order.data.orderInfo[0],
      orderFulfillments: order.data.orderFulfillments[0],
      orderPayments: order.data.orderPayments[0]
    }), order.isLoaded && /*#__PURE__*/jsx(OrderShipments, {
      shipments: [{
        orderItems: order.data.orderItems
      }]
    })]
  });
};

var OrderDetails = function OrderDetails(_ref) {
  var orderInfo = _ref.orderInfo,
      orderFulfillments = _ref.orderFulfillments,
      orderPayments = _ref.orderPayments;

  var _useFormatDateTime = useFormatDateTime(),
      _useFormatDateTime2 = _slicedToArray(_useFormatDateTime, 1),
      formateDate = _useFormatDateTime2[0];

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useSingleAccountOrde = useSingleAccountOrderDetails({
    orderInfo: orderInfo,
    orderFulfillments: orderFulfillments,
    orderPayments: orderPayments
  }),
      billingAddressDetails = _useSingleAccountOrde.billingAddressDetails,
      shippingAddressDetails = _useSingleAccountOrde.shippingAddressDetails,
      pickupLocationDetails = _useSingleAccountOrde.pickupLocationDetails,
      termPaymentDetails = _useSingleAccountOrde.termPaymentDetails,
      creditCardPaymentDetails = _useSingleAccountOrde.creditCardPaymentDetails,
      paymentMethodType = _useSingleAccountOrde.paymentMethodType;

  return /*#__PURE__*/jsxs("div", {
    className: "row align-items-start mb-5 mr-3",
    children: [/*#__PURE__*/jsx("div", {
      className: "col-md-7",
      children: /*#__PURE__*/jsxs("div", {
        className: "row text-sm",
        children: [/*#__PURE__*/jsxs("div", {
          className: "col-6 ",
          children: [paymentMethodType === 'shipping' && /*#__PURE__*/jsx(ShippingAddressDetails, {
            className: "",
            shippingAddress: shippingAddressDetails,
            shippingAddressNickname: ''
          }), paymentMethodType === 'pickup' && /*#__PURE__*/jsx(PickupLocationDetails, {
            className: "",
            pickupLocation: pickupLocationDetails
          }), /*#__PURE__*/jsx("h3", {
            className: "h6",
            children: t('frontend.account.order.datePlaced')
          }), /*#__PURE__*/jsx("p", {
            children: formateDate(orderInfo.orderOpenDateTime)
          }), /*#__PURE__*/jsx("h3", {
            className: "h6",
            children: t('frontend.order.OrderNo')
          }), /*#__PURE__*/jsx("p", {
            children: orderPayments != null ? orderPayments.order_orderNumber : orderInfo.orderNumber
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "col-6",
          children: [/*#__PURE__*/jsx(BillingAddressDetails, {
            billingAddressNickname: '',
            orderPayment: billingAddressDetails
          }), paymentMethodType === 'termPayment' && /*#__PURE__*/jsx(TermPaymentDetails, {
            termPayment: termPaymentDetails
          }), paymentMethodType === 'giftCard' && /*#__PURE__*/jsx(GiftCardDetails, {}), paymentMethodType === 'creditCard' && /*#__PURE__*/jsx(CCDetails, {
            creditCardPayment: creditCardPaymentDetails
          }), ' ']
        })]
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "col-md-5 order-summary border rounded p-3 text-center",
      children: [/*#__PURE__*/jsx("h3", {
        className: "h6",
        children: t('frontend.order.summary')
      }), /*#__PURE__*/jsx("table", {
        className: "w-100 text-sm",
        style: {
          lineHeight: '1.5'
        },
        children: /*#__PURE__*/jsxs("tbody", {
          children: [/*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsxs("td", {
              className: "text-left",
              children: [" ", t('frontend.order.subtotal')]
            }), /*#__PURE__*/jsx("td", {
              className: "text-right",
              children: formatCurrency(orderInfo.calculatedSubTotal)
            })]
          }), /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("td", {
              className: "text-left",
              children: t('frontend.order.shipping')
            }), /*#__PURE__*/jsx("td", {
              className: "text-right",
              children: formatCurrency(orderInfo.calculatedFulfillmentTotal)
            })]
          }), /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("td", {
              className: "text-left",
              children: t('frontend.order.taxes')
            }), /*#__PURE__*/jsx("td", {
              className: "text-right",
              children: formatCurrency(orderInfo.calculatedTaxTotal)
            })]
          }), /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsxs("td", {
              className: "text-left",
              children: [" ", t('frontend.order.discount')]
            }), /*#__PURE__*/jsxs("td", {
              className: "text-right text-success font-weight-bold",
              children: ["- ", formatCurrency(orderInfo.calculatedDiscountTotal)]
            })]
          })]
        })
      }), /*#__PURE__*/jsx("hr", {
        className: "mb-4 mt-4"
      }), /*#__PURE__*/jsx("span", {
        className: "order-total h3",
        children: formatCurrency(orderInfo.calculatedTotal)
      })]
    })]
  });
};

var OrderNav = function OrderNav() {
  return /*#__PURE__*/jsxs("div", {
    className: "d-flex justify-content-between mb-4 mr-3",
    children: [/*#__PURE__*/jsxs("a", {
      href: "##",
      className: "previous-btn",
      children: [/*#__PURE__*/jsx("i", {
        className: "far fa-chevron-left"
      }), "Previous Order"]
    }), /*#__PURE__*/jsxs("a", {
      href: "##",
      className: "next-btn",
      children: ["Next Order", /*#__PURE__*/jsx("i", {
        className: "far fa-chevron-right"
      })]
    })]
  });
};

var OrderItem = function OrderItem(_ref) {
  var quantity = _ref.quantity,
      sku_skuID = _ref.sku_skuID,
      sku_product_productName = _ref.sku_product_productName,
      images = _ref.images,
      sku_product_urlTitle = _ref.sku_product_urlTitle,
      BrandName = _ref.BrandName,
      isSeries = _ref.isSeries,
      ProductSeries = _ref.ProductSeries,
      calculatedExtendedPriceAfterDiscount = _ref.calculatedExtendedPriceAfterDiscount,
      sku_calculatedSkuDefinition = _ref.sku_calculatedSkuDefinition,
      sku_imageFile = _ref.sku_imageFile,
      price = _ref.price,
      _ref$imageFallbackFil = _ref.imageFallbackFileName,
      imageFallbackFileName = _ref$imageFallbackFil === void 0 ? '' : _ref$imageFallbackFil;

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var useResizedImage = images && (images === null || images === void 0 ? void 0 : images.length) > 0;
  var productRouting = useSelector(getProductRoute);
  return /*#__PURE__*/jsxs("div", {
    className: "row border-bottom pb-3 pt-4 mx-1",
    children: [/*#__PURE__*/jsx("div", {
      className: "col-sm-2 col-3 pr-0",
      children: /*#__PURE__*/jsxs(Link, {
        to: "/".concat(productRouting, "/").concat(sku_product_urlTitle, "?skuid=").concat(sku_skuID),
        className: "d-inline-block mx-auto image-width",
        children: [useResizedImage && /*#__PURE__*/jsx(SimpleImage, {
          src: images[0],
          alt: sku_product_productName
        }), !useResizedImage && /*#__PURE__*/jsx(SWImage, {
          customPath: 'custom/assets/images/product/default/',
          src: sku_imageFile,
          alt: "Product",
          fallbackPath: imageFallbackFileName.length ? "".concat(imageFallbackFileName) : ''
        }), ' ']
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "col-9 col-sm-10 col-md-4",
      children: [isSeries && /*#__PURE__*/jsx("span", {
        className: "product-meta d-block font-size-xs pb-1",
        children: ProductSeries
      }), /*#__PURE__*/jsx("h3", {
        className: "product-title font-size-base mb-2",
        children: /*#__PURE__*/jsx(Link, {
          to: "/".concat(productRouting, "/").concat(sku_product_urlTitle, "?skuid=").concat(sku_skuID),
          children: sku_product_productName
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "font-size-sm",
        children: [BrandName, " ", /*#__PURE__*/jsx("span", {
          className: "text-muted mr-2",
          children: sku_calculatedSkuDefinition
        })]
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "col-sm-12 col-md-6 mt-2 mt-md-0",
      children: /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-3",
          children: /*#__PURE__*/jsx("div", {
            className: "product-price",
            children: /*#__PURE__*/jsx("div", {
              className: "font-size-sm",
              children: formatCurrency(price)
            })
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-4",
          children: /*#__PURE__*/jsxs("p", {
            className: "mb-0",
            children: [/*#__PURE__*/jsxs("span", {
              className: "text-muted font-size-sm",
              children: [t('frontend.cart.qty'), " "]
            }), /*#__PURE__*/jsx("span", {
              children: quantity
            })]
          })
        }), /*#__PURE__*/jsxs("div", {
          className: "col-3",
          children: [/*#__PURE__*/jsx("div", {
            className: "text-accent",
            children: formatCurrency(calculatedExtendedPriceAfterDiscount)
          }), /*#__PURE__*/jsx("button", {
            onClick: function onClick(event) {
              event.preventDefault();
              dispatch(addToCart(sku_skuID, quantity));
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            },
            className: "btn btn-outline-secondary mt-2",
            children: t('frontend.account.reOrder')
          })]
        })]
      })
    })]
  });
};

var OrderShipments = function OrderShipments(_ref2) {
  var shipments = _ref2.shipments;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/jsx("div", {
    className: "order-items mr-3",
    children: shipments && shipments.map(function (shipment, index) {
      return /*#__PURE__*/jsxs("div", {
        className: "shipment mb-5",
        children: [/*#__PURE__*/jsx("div", {
          className: "order-tracking bg-lightgray px-3 py-2",
          children: /*#__PURE__*/jsxs("div", {
            className: "row",
            children: [/*#__PURE__*/jsx("div", {
              className: "col-sm-6",
              children: "".concat(t('frontend.account.order.shipment'), " ").concat(index + 1, " of ").concat(shipments.length)
            }), shipment.trackingNumber && /*#__PURE__*/jsxs("div", {
              className: "col-sm-6 text-right",
              children: ["".concat(t('rontend.account.order.tracking_number'), ": "), /*#__PURE__*/jsx("a", {
                href: "/#to-shipper",
                target: "_blank",
                children: shipment.trackingNumber
              })]
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "card-header",
          children: /*#__PURE__*/jsxs("div", {
            className: "row",
            children: [/*#__PURE__*/jsx("div", {
              className: "col-sm-12 col-md-6",
              children: /*#__PURE__*/jsx("h4", {
                className: "mb-0 small",
                children: t('frontend.cart.orderItems')
              })
            }), /*#__PURE__*/jsx("div", {
              className: "col-sm-12 col-md-6 d-none d-md-block",
              children: /*#__PURE__*/jsxs("div", {
                className: "row",
                children: [/*#__PURE__*/jsx("div", {
                  className: "col-sm-3",
                  children: /*#__PURE__*/jsx("small", {
                    children: t('frontend.cart.price')
                  })
                }), /*#__PURE__*/jsx("div", {
                  className: "col-sm-4",
                  children: /*#__PURE__*/jsx("small", {
                    children: t('frontend.cart.qty')
                  })
                }), /*#__PURE__*/jsx("div", {
                  className: "col-sm-3",
                  children: /*#__PURE__*/jsx("small", {
                    children: t('frontend.cart.total')
                  })
                })]
              })
            })]
          })
        }), shipment.orderItems && shipment.orderItems.map(function (item, index) {
          return /*#__PURE__*/jsx(OrderItem, _objectSpread2({}, item), index);
        })]
      }, index);
    })
  });
};

var OrderToolbar = function OrderToolbar(_ref) {
  var delivered = _ref.delivered;
  return /*#__PURE__*/jsx("div", {
    className: "d-flex justify-content-between align-items-center pt-lg-2 pb-4 pb-lg-5",
    children: /*#__PURE__*/jsxs("div", {
      className: "row justify-content-between w-100 align-items-center",
      children: [/*#__PURE__*/jsxs("div", {
        className: "col-sm-6",
        children: ["Status ", /*#__PURE__*/jsx("span", {
          className: "badge badge-success m-0 p-2 ml-2",
          children: delivered
        })]
      }), /*#__PURE__*/jsx("div", {
        className: "col-sm-6",
        children: /*#__PURE__*/jsx("div", {
          className: "row justify-content-end",
          children: /*#__PURE__*/jsx("div", {
            children: /*#__PURE__*/jsxs("button", {
              className: "btn btn-outline-secondary btn-print",
              onClick: function onClick() {
                return window.print();
              },
              children: [/*#__PURE__*/jsx("i", {
                className: "far fa-print mr-2"
              }), " Print"]
            })
          })
        })
      })]
    })
  });
};

var OrderStatus$1 = function OrderStatus(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      text = _ref.text;
  return /*#__PURE__*/jsx("span", {
    className: "badge badge-".concat(type, " m-0"),
    children: text
  });
};

var OrderListItem$1 = function OrderListItem(props) {
  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useFormatDateTime = useFormatDateTime(),
      _useFormatDateTime2 = _slicedToArray(_useFormatDateTime, 1),
      formateDate = _useFormatDateTime2[0];

  var orderNumber = props.orderNumber,
      orderID = props.orderID,
      createdDateTime = props.createdDateTime,
      orderStatusType_typeName = props.orderStatusType_typeName,
      calculatedTotal = props.calculatedTotal;
  return /*#__PURE__*/jsxs("tr", {
    children: [/*#__PURE__*/jsxs("td", {
      className: "py-3",
      children: [/*#__PURE__*/jsx(Link, {
        className: "nav-link-style font-weight-medium font-size-sm",
        to: "/my-account/orders/".concat(orderID),
        children: orderNumber
      }), /*#__PURE__*/jsx("br", {})]
    }), /*#__PURE__*/jsx("td", {
      className: "py-3",
      children: formateDate(createdDateTime)
    }), /*#__PURE__*/jsx("td", {
      className: "py-3",
      children: /*#__PURE__*/jsx(OrderStatus$1, {
        text: orderStatusType_typeName
      })
    }), /*#__PURE__*/jsx("td", {
      className: "py-3",
      children: formatCurrency(calculatedTotal)
    })]
  });
};

var OrderHistoryList = function OrderHistoryList() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      keyword = _useState2[0],
      setSearchTerm = _useState2[1];

  var _useGetAllOrders = useGetAllOrders(),
      _useGetAllOrders2 = _slicedToArray(_useGetAllOrders, 2),
      orders = _useGetAllOrders2[0],
      setRequest = _useGetAllOrders2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var search = function search() {
    var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    setRequest(_objectSpread2(_objectSpread2({}, orders), {}, {
      params: {
        currentPage: currentPage,
        pageRecordsShow: 10,
        keyword: keyword
      },
      makeRequest: true,
      isFetching: true,
      isLoaded: false
    }));
  };

  useEffect(function () {
    var didCancel = false;

    if (!orders.isFetching && !orders.isLoaded && !didCancel) {
      setRequest(_objectSpread2(_objectSpread2({}, orders), {}, {
        isFetching: true,
        isLoaded: false,
        params: {
          pageRecordsShow: 10,
          keyword: keyword
        },
        makeRequest: true
      }));
    }

    return function () {
      didCancel = true;
    };
  }, [orders, keyword, setRequest]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(AccountToolBar, {
      term: keyword,
      updateTerm: setSearchTerm,
      search: search
    }), /*#__PURE__*/jsx("div", {
      className: "table-responsive font-size-md",
      children: /*#__PURE__*/jsxs("table", {
        className: "table table-hover mb-0",
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsxs("th", {
              children: [t('frontend.account.order.heading'), " #"]
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.account.order.date')
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.account.order.status')
            }), /*#__PURE__*/jsxs("th", {
              children: [" ", t('frontend.account.order.total')]
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: orders.isLoaded && orders.data.ordersOnAccount.map(function (order, index) {
            return /*#__PURE__*/jsx(OrderListItem$1, _objectSpread2({}, order), index);
          })
        })]
      })
    }), /*#__PURE__*/jsx("hr", {
      className: "pb-4"
    }), /*#__PURE__*/jsx(ListingPagination, {
      recordsCount: orders.data.records,
      currentPage: orders.data.currentPage,
      totalPages: Math.ceil(orders.data.records / 10),
      setPage: search
    })]
  });
};

var AccountOrderHistory = function AccountOrderHistory(_ref2) {
  _ref2.crumbs;
      _ref2.title;
      var orders = _ref2.orders;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/jsx(AccountLayout, {
    title: t('frontend.account.account_order_history'),
    children: /*#__PURE__*/jsx(OrderHistoryList, {
      orders: orders
    })
  });
};

var AccountRecentOrders = function AccountRecentOrders() {
  var _useGetAllOrders = useGetAllOrders(),
      _useGetAllOrders2 = _slicedToArray(_useGetAllOrders, 2),
      orders = _useGetAllOrders2[0],
      setRequest = _useGetAllOrders2[1];

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useFormatDateTime = useFormatDateTime(),
      _useFormatDateTime2 = _slicedToArray(_useFormatDateTime, 1),
      formateDate = _useFormatDateTime2[0];

  useEffect(function () {
    var didCancel = false;

    if (!orders.isFetching && !orders.isLoaded && !didCancel) {
      setRequest(_objectSpread2(_objectSpread2({}, orders), {}, {
        isFetching: true,
        isLoaded: false,
        params: {},
        makeRequest: true
      }));
    }

    return function () {
      didCancel = true;
    };
  }, [orders, setRequest]);
  return /*#__PURE__*/jsx(Fragment, {
    children: orders.data && orders.data.ordersOnAccount && orders.data.ordersOnAccount.length > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("h3", {
        className: "h4 mt-5 mb-3",
        children: "Most Recent Order"
      }), /*#__PURE__*/jsxs("div", {
        className: "row bg-lightgray rounded align-items-center justify-content-between mb-4",
        children: [/*#__PURE__*/jsxs("div", {
          className: "col-xs-4 p-3",
          children: [/*#__PURE__*/jsxs("h6", {
            children: ["Order ", orders.data.ordersOnAccount[0].orderNumber]
          }), /*#__PURE__*/jsx("span", {
            children: formateDate(orders.data.ordersOnAccount[0].createdDateTime)
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "col-xs-3 p-3",
          children: [/*#__PURE__*/jsx("h6", {
            children: "Status"
          }), /*#__PURE__*/jsx("span", {
            children: orders.data.ordersOnAccount[0].orderStatusType_typeName
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "col-xs-3 p-3",
          children: [/*#__PURE__*/jsx("h6", {
            children: "Order Total"
          }), /*#__PURE__*/jsx("span", {
            children: formatCurrency(orders.data.ordersOnAccount[0].calculatedTotal)
          })]
        }), /*#__PURE__*/jsx("div", {
          className: "p-3",
          children: /*#__PURE__*/jsx(Link, {
            className: "btn btn-outline-secondary",
            to: "/my-account/orders/".concat(orders.data.ordersOnAccount[0].orderID),
            children: "View"
          })
        })]
      }), /*#__PURE__*/jsx(Link, {
        className: "btn btn-primary",
        to: "/my-account/orders",
        children: "View All Orders"
      })]
    })
  });
};

var AccountOverview = function AccountOverview(_ref) {
  var customBody = _ref.customBody,
      crumbs = _ref.crumbs,
      title = _ref.title,
      contentTitle = _ref.contentTitle;
  return /*#__PURE__*/jsxs(AccountLayout, {
    crumbs: crumbs,
    title: title,
    children: [/*#__PURE__*/jsx(AccountContent, {
      contentTitle: contentTitle,
      customBody: customBody
    }), /*#__PURE__*/jsx(AccountRecentOrders, {})]
  });
};

var OrderStatus = function OrderStatus(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      text = _ref.text;
  return /*#__PURE__*/jsx("span", {
    className: "badge badge-".concat(type, " m-0"),
    children: text
  });
};

var OrderListItem = function OrderListItem(_ref2) {
  var orderID = _ref2.orderID,
      createdDateTime = _ref2.createdDateTime,
      orderStatusType_typeName = _ref2.orderStatusType_typeName,
      calculatedTotal = _ref2.calculatedTotal;

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useFormatDate = useFormatDate(),
      _useFormatDate2 = _slicedToArray(_useFormatDate, 1),
      formateDate = _useFormatDate2[0];

  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs("tr", {
    children: [/*#__PURE__*/jsx("td", {
      className: "py-3",
      children: formateDate(createdDateTime)
    }), /*#__PURE__*/jsx("td", {
      className: "py-3",
      children: /*#__PURE__*/jsx(OrderStatus, {
        text: orderStatusType_typeName
      })
    }), /*#__PURE__*/jsx("td", {
      className: "py-3",
      children: formatCurrency(calculatedTotal)
    }), /*#__PURE__*/jsxs("td", {
      className: "py-3",
      children: [/*#__PURE__*/jsx(Link, {
        className: "text-link",
        onClick: function onClick(event) {
          dispatch(setOrderOnCart(orderID, t('frontend.account.order.change_order_success')));
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        },
        children: t('frontend.account.order.change_order')
      }), /*#__PURE__*/jsx("br", {})]
    })]
  });
};

var AccountCarts = function AccountCarts(_ref3) {
  var _orders$data;

  _ref3.customBody;
      var crumbs = _ref3.crumbs,
      title = _ref3.title;
      _ref3.contentTitle;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      keyword = _useState2[0],
      setSearchTerm = _useState2[1];

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var _useGetAccountCartsAn = useGetAccountCartsAndQuotes(),
      _useGetAccountCartsAn2 = _slicedToArray(_useGetAccountCartsAn, 2),
      orders = _useGetAccountCartsAn2[0],
      setRequest = _useGetAccountCartsAn2[1];

  var search = function search() {
    var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    setRequest(_objectSpread2(_objectSpread2({}, orders), {}, {
      params: {
        currentPage: currentPage,
        pageRecordsShow: 10,
        keyword: keyword
      },
      makeRequest: true,
      isFetching: true,
      isLoaded: false
    }));
  };

  useEffect(function () {
    var didCancel = false;

    if (!orders.isFetching && !orders.isLoaded && !didCancel) {
      setRequest(_objectSpread2(_objectSpread2({}, orders), {}, {
        isFetching: true,
        isLoaded: false,
        params: {
          pageRecordsShow: 20,
          keyword: keyword
        },
        makeRequest: true
      }));
    }

    return function () {
      didCancel = true;
    };
  }, [orders, keyword, setRequest]);
  return /*#__PURE__*/jsxs(AccountLayout, {
    crumbs: crumbs,
    title: title,
    children: [/*#__PURE__*/jsx(AccountToolBar, {
      term: keyword,
      updateTerm: setSearchTerm,
      search: search
    }), /*#__PURE__*/jsx("div", {
      className: "table-responsive font-size-md",
      children: /*#__PURE__*/jsxs("table", {
        className: "table table-hover mb-0",
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("th", {
              children: t('frontend.core.date_created')
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.account.order.status')
            }), /*#__PURE__*/jsxs("th", {
              children: [" ", t('frontend.account.order.total')]
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.account.order.select_order')
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: orders.isLoaded && (orders === null || orders === void 0 ? void 0 : (_orders$data = orders.data) === null || _orders$data === void 0 ? void 0 : _orders$data.map(function (order, index) {
            return /*#__PURE__*/jsx(OrderListItem, _objectSpread2({}, order), index);
          }))
        })]
      })
    }), /*#__PURE__*/jsx("hr", {
      className: "pb-4"
    }), /*#__PURE__*/jsx(ListingPagination, {
      recordsCount: orders.data.records,
      currentPage: orders.data.currentPage,
      totalPages: Math.ceil(orders.data.records / 20),
      setPage: search
    })]
  });
};

var AccountPaymentMethods = function AccountPaymentMethods() {
  var _useSelector = useSelector(function (state) {
    return state.userReducer;
  }),
      primaryPaymentMethod = _useSelector.primaryPaymentMethod,
      accountPaymentMethods = _useSelector.accountPaymentMethods;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(AccountLayout, {
    children: [/*#__PURE__*/jsx(AccountContent, {}), accountPaymentMethods.length === 0 && /*#__PURE__*/jsx("div", {
      className: "alert alert-info",
      role: "alert",
      children: t('frontend.account.payment_methods.none')
    }), accountPaymentMethods.length > 0 && /*#__PURE__*/jsx("div", {
      className: "table-responsive font-size-md",
      children: /*#__PURE__*/jsxs("table", {
        className: "table table-hover mb-0",
        children: [/*#__PURE__*/jsx("thead", {
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsx("th", {
              children: t('frontend.account.payment_method.types')
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.account.payment_method.name')
            }), /*#__PURE__*/jsx("th", {
              children: t('frontend.account.payment_method.expires')
            }), /*#__PURE__*/jsx("th", {})]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: accountPaymentMethods && accountPaymentMethods.map(function (card, index) {
            return /*#__PURE__*/jsx(PaymentMethodItem, _objectSpread2(_objectSpread2({}, card), {}, {
              isPrimary: card.accountPaymentMethodID === primaryPaymentMethod.accountPaymentMethodID
            }), index);
          })
        })]
      })
    }), /*#__PURE__*/jsx("hr", {
      className: "pb-4"
    }), /*#__PURE__*/jsx("div", {
      className: "text-sm-right",
      children: /*#__PURE__*/jsx(Link, {
        className: "btn btn-primary",
        to: "/my-account/cards/new",
        children: t('frontend.account.payment_method.add')
      })
    })]
  });
};

AccountPaymentMethods.propTypes = {};

var AccountAddressForm = function AccountAddressForm(_ref) {
  var formik = _ref.formik;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useDispatch();
  var countryCodeOptions = useSelector(function (state) {
    return state.content.countryCodeOptions;
  });
  var stateCodeOptions = useSelector(function (state) {
    return state.content.stateCodeOptions;
  });
  var isFetching = useSelector(function (state) {
    return state.content.isFetching;
  });
  useEffect(function () {
    if (countryCodeOptions.length === 0 && !isFetching) {
      dispatch(getCountries());
    }

    if (!stateCodeOptions[formik.values.billingAddress.countryCode] && !isFetching) {
      dispatch(getStateCodeOptionsByCountryCode(formik.values.billingAddress.countryCode));
    }
  }, [dispatch, formik, stateCodeOptions, countryCodeOptions, isFetching]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "col-12",
      children: /*#__PURE__*/jsx("h5", {
        className: "mt-4 mb-2",
        children: "Billing Address"
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.countryCode",
          children: t('frontend.account.countryCode')
        }), /*#__PURE__*/jsx(SwSelect, {
          id: "billingAddress.countryCode",
          name: "billingAddress.countryCode",
          value: formik.values.billingAddress.countryCode,
          onChange: function onChange(e) {
            e.preventDefault();
            dispatch(getStateCodeOptionsByCountryCode(e.target.value));
            formik.handleChange(e);
          },
          options: countryCodeOptions
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.name",
          children: t('frontend.account.fullname')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.name",
          type: "text",
          id: "billingAddress.name",
          value: formik.values.billingAddress.name,
          onChange: formik.handleChange,
          required: true
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.company",
          children: t('frontend.account.company')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.company",
          type: "text",
          id: "billingAddress.company",
          value: formik.values.billingAddress.company,
          onChange: formik.handleChange
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.phoneNumber",
          children: t('frontend.account.phoneNumber')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.phoneNumber",
          type: "text",
          pattern: "[0-9.]+",
          id: "billingAddress.phoneNumber",
          value: formik.values.billingAddress.phoneNumber,
          onChange: formik.handleChange
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.emailAddress",
          children: t('frontend.account.emailAddress')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.emailAddress",
          type: "email",
          id: "billingAddress.emailAddress",
          value: formik.values.billingAddress.emailAddress,
          onChange: formik.handleChange,
          required: true
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.streetAddress",
          children: t('frontend.account.streetAddress')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.streetAddress",
          type: "text",
          id: "billingAddress.streetAddress",
          value: formik.values.billingAddress.streetAddress,
          onChange: formik.handleChange,
          required: true
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.street2Address",
          children: t('frontend.account.street2Address')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.street2Address",
          type: "text",
          id: "billingAddress.street2Address",
          value: formik.values.billingAddress.street2Address,
          onChange: formik.handleChange
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-6",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.city",
          children: t('frontend.account.city')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.city",
          type: "text",
          id: "billingAddress.city",
          value: formik.values.billingAddress.city,
          onChange: formik.handleChange,
          required: true
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-3",
      children: stateCodeOptions[formik.values.billingAddress.countryCode] && stateCodeOptions[formik.values.billingAddress.countryCode].length > 0 && /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.stateCode",
          children: t('frontend.account.stateCode')
        }), /*#__PURE__*/jsx(SwSelect, {
          id: "billingAddress.stateCode",
          name: "billingAddress.stateCode",
          value: formik.values.billingAddress.stateCode,
          onChange: function onChange(e) {
            e.preventDefault();
            formik.setFieldValue('billingAddress.stateCode', e.target.value);
          },
          options: stateCodeOptions[formik.values.billingAddress.countryCode]
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "col-md-3",
      children: /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("label", {
          htmlFor: "billingAddress.postalCode",
          children: t('frontend.account.postalCode')
        }), /*#__PURE__*/jsx("input", {
          className: "form-control",
          name: "billingAddress.postalCode",
          type: "text",
          id: "billingAddress.postalCode",
          value: formik.values.billingAddress.postalCode,
          onChange: formik.handleChange
        })]
      })
    })]
  });
};

var months$1 = Array.from({
  length: 12
}, function (_, i) {
  return {
    key: i + 1,
    value: i + 1
  };
});
var years$1 = Array(10).fill(new Date().getFullYear()).map(function (year, index) {
  return {
    key: year + index,
    value: year + index
  };
});

var CreateOrEditAccountPaymentMethod = function CreateOrEditAccountPaymentMethod(_ref) {
  var customBody = _ref.customBody,
      contentTitle = _ref.contentTitle;
  var accountAddresses = useSelector(function (state) {
    return state.userReducer.accountAddresses;
  });

  var _useRedirect = useRedirect({
    location: '/my-account/cards'
  }),
      _useRedirect2 = _slicedToArray(_useRedirect, 2),
      redirect = _useRedirect2[0],
      setRedirect = _useRedirect2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showNewAddressForm = _useState2[0],
      setShowNewAddressForm = _useState2[1];

  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      accountPaymentMethodName: '',
      paymentMethodType: 'creditCard',
      creditCardNumber: "",
      nameOnCreditCard: '',
      expirationMonth: new Date().getMonth() + 2,
      expirationYear: new Date().getFullYear().toString().substring(2),
      securityCode: '',
      billingAccountAddress: {
        accountAddressID: ''
      },
      billingAddress: {
        countryCode: 'US',
        name: '',
        company: '',
        phoneNumber: '',
        emailAddress: '',
        streetAddress: '',
        street2Address: '',
        city: '',
        stateCode: '',
        postalCode: ''
      }
    },
    validationSchema: Yup.object().shape({
      creditCardNumber: Yup.string().matches(/^[0-9]+$/, "Credit Card Number must be only digits").required("".concat(t('frontend.account.payment_method.ccn_required'))),
      nameOnCreditCard: Yup.string().required("".concat(t('frontend.account.payment_method.name_required'))),
      expirationMonth: Yup.string().matches(/^[0-9]+$/, "Expiration Month must be only digits").required("".concat(t('frontend.account.payment_method.expiration_month_required'))),
      expirationYear: Yup.string().matches(/^[0-9]+$/, "Expiration Year must be only digits").required("".concat(t('frontend.account.payment_method.expiration_year_required'))),
      securityCode: Yup.string().matches(/^[0-9]+$/, "Security Code must be only digits").min(2).max(4).required("".concat(t('frontend.account.payment_method.cvv_required')))
    }),
    onSubmit: function onSubmit(values) {
      // TODO: Dispatch Actions
      if (values.billingAccountAddress.accountAddressID.length) {
        delete values.billingAddress.countryCode;
        delete values.billingAddress.name;
        delete values.billingAddress.company;
        delete values.billingAddress.phoneNumber;
        delete values.billingAddress.emailAddress;
        delete values.billingAddress.streetAddress;
        delete values.billingAddress.street2Address;
        delete values.billingAddress.city;
        delete values.billingAddress.stateCode;
        delete values.billingAddress.postalCode;
      }

      dispatch(addPaymentMethod(values));
      setRedirect(_objectSpread2(_objectSpread2({}, redirect), {}, {
        shouldRedirect: true
      }));
    }
  });
  var validCreditCard = formik.values.nameOnCreditCard.length > 0 && formik.values.creditCardNumber.length > 0 && formik.values.securityCode.length > 0;
  return /*#__PURE__*/jsxs(AccountLayout, {
    title: 'Add Account Payment Method',
    children: [/*#__PURE__*/jsx(AccountContent, {
      customBody: customBody,
      contentTitle: contentTitle
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: formik.handleSubmit,
      className: "mt-5",
      children: [/*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-md-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "paymentMethodType",
              children: t('frontend.account.payment_method.heading')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "paymentMethodType",
              value: formik.values['paymentMethodType'],
              onChange: formik.handleChange,
              options: [{
                key: 'Credit Card',
                value: 'creditCard'
              }],
              disabled: formik.isSubmitting
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-12",
          children: /*#__PURE__*/jsx("h5", {
            className: "my-2",
            children: t('frontend.account.payment_method.cc_details')
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "creditCardNumber",
              children: t('frontend.account.payment_method.ccn')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              type: "text",
              id: "creditCardNumber",
              value: formik.values.creditCardNumber,
              onChange: formik.handleChange,
              disabled: formik.isSubmitting
            }), formik.errors.creditCardNumber && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.creditCardNumber
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "nameOnCreditCard",
              children: t('frontend.account.payment_method.name')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              type: "text",
              id: "nameOnCreditCard",
              value: formik.values.nameOnCreditCard,
              onChange: formik.handleChange,
              disabled: formik.isSubmitting
            }), formik.errors.nameOnCreditCard && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.nameOnCreditCard
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-3",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "expirationMonth",
              children: t('frontend.account.payment_method.expiration_month')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "expirationMonth",
              value: formik.values.expirationMonth,
              onChange: formik.handleChange,
              options: months$1,
              disabled: formik.isSubmitting
            }), formik.errors.expirationMonth && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.expirationMonth
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-3",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "expirationYear",
              children: t('frontend.account.payment_method.expiration_year')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "expirationYear",
              value: formik.values.expirationYear,
              onChange: formik.handleChange,
              options: years$1,
              disabled: formik.isSubmitting
            }), formik.errors.expirationYear && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.expirationYear
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "securityCode",
              children: t('frontend.account.payment_method.cvv')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              type: "text",
              placeholder: "***",
              id: "securityCode",
              value: formik.values.securityCode,
              onChange: formik.handleChange,
              disabled: formik.isSubmitting
            }), formik.errors.securityCode && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.securityCode
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-12",
          children: /*#__PURE__*/jsx("hr", {
            className: "my-4"
          })
        }), validCreditCard && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx("div", {
            className: "col-md-6",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "accountAddressID",
                children: t('frontend.account.billing_address')
              }), /*#__PURE__*/jsx(SwRadioSelect, {
                onChange: function onChange(value) {
                  formik.setFieldValue('billingAccountAddress.accountAddressID', value);
                  setShowNewAddressForm(false);
                },
                options: accountAddresses.map(function (_ref2) {
                  var accountAddressName = _ref2.accountAddressName,
                      accountAddressID = _ref2.accountAddressID,
                      streetAddress = _ref2.address.streetAddress;
                  return {
                    name: "".concat(accountAddressName, " - ").concat(streetAddress),
                    value: accountAddressID
                  };
                }),
                selectedValue: formik.values.billingAccountAddress.accountAddressID
              }), !showNewAddressForm && /*#__PURE__*/jsx("button", {
                className: "btn btn-secondary mt-2",
                onClick: function onClick(e) {
                  e.preventDefault();
                  setShowNewAddressForm(true);
                  formik.setFieldValue('billingAccountAddress.accountAddressID', '');
                },
                children: "New Address"
              })]
            })
          }), showNewAddressForm && /*#__PURE__*/jsx(AccountAddressForm, {
            formik: formik
          })]
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-12",
          children: /*#__PURE__*/jsx("hr", {
            className: "mt-2 mb-4"
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-12 d-flex flex-wrap justify-content-end",
          children: /*#__PURE__*/jsx("button", {
            type: "submit",
            className: "btn btn-primary mt-3 mt-sm-0",
            disabled: formik.isSubmitting,
            children: t('frontend.account.payment.saveNewPayment')
          })
        })]
      })]
    })]
  });
};

var PaymentMethodItem = function PaymentMethodItem(props) {
  var accountPaymentMethodID = props.accountPaymentMethodID,
      accountPaymentMethodName = props.accountPaymentMethodName,
      nameOnCreditCard = props.nameOnCreditCard,
      _props$isPrimary = props.isPrimary,
      isPrimary = _props$isPrimary === void 0 ? false : _props$isPrimary,
      creditCardType = props.creditCardType,
      expirationYear = props.expirationYear,
      expirationMonth = props.expirationMonth;
  var MySwal = withReactContent(Swal);
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs("tr", {
    children: [/*#__PURE__*/jsx("td", {
      className: "py-3 align-middle",
      children: /*#__PURE__*/jsx("div", {
        className: "media align-items-center",
        children: /*#__PURE__*/jsxs("div", {
          className: "media-body",
          children: [/*#__PURE__*/jsx("span", {
            className: "font-weight-medium text-heading mr-1",
            children: creditCardType
          }), accountPaymentMethodName, isPrimary && /*#__PURE__*/jsx("span", {
            className: "align-middle badge badge-info ml-2",
            children: "Primary"
          })]
        })
      })
    }), /*#__PURE__*/jsx("td", {
      className: "py-3 align-middle",
      children: nameOnCreditCard
    }), /*#__PURE__*/jsx("td", {
      className: "py-3 align-middle",
      children: "".concat(expirationMonth, "/").concat(expirationYear)
    }), /*#__PURE__*/jsx("td", {
      className: "py-3 align-middle",
      children: /*#__PURE__*/jsx("button", {
        type: "button",
        className: "link-button nav-link-style text-primary",
        onClick: function onClick() {
          MySwal.fire({
            icon: 'info',
            title: /*#__PURE__*/jsx("p", {
              children: t('frontend.account.payment_method.remove')
            }),
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: t('frontend.core.delete')
          }).then(function (data) {
            if (data.isConfirmed) {
              dispatch(deletePaymentMethod(accountPaymentMethodID));
            }
          });
        },
        "data-toggle": "tooltip",
        title: "",
        "data-original-title": "Remove",
        children: /*#__PURE__*/jsx("i", {
          className: "far fa-trash-alt"
        })
      })
    })]
  });
};

var AccountProfile = function AccountProfile(_ref) {
  var crumbs = _ref.crumbs,
      title = _ref.title,
      customBody = _ref.customBody,
      contentTitle = _ref.contentTitle;
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var user = useSelector(function (state) {
    return state.userReducer;
  });
  var formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      accountFirstName: user.firstName,
      accountLastName: user.lastName,
      accountEmailAddress: user.primaryEmailAddress.emailAddress,
      // accountPhoneNumber: user.primaryPhoneNumber.phoneNumber,
      // accountExt: '',
      accountCompany: user.company
    },
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      dispatch(updateUser({
        firstName: values.accountFirstName,
        lastName: values.accountLastName,
        emailAddress: values.accountEmailAddress,
        company: values.accountCompany,
        returnJSONObjects: 'account'
      }));
      setSubmitting(false);
    }
  });
  return /*#__PURE__*/jsxs(AccountLayout, {
    crumbs: crumbs,
    title: title,
    children: [/*#__PURE__*/jsx(AccountContent, {
      customBody: customBody,
      contentTitle: contentTitle
    }), /*#__PURE__*/jsx("form", {
      onSubmit: formik.handleSubmit,
      children: /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-12",
          children: /*#__PURE__*/jsx("h4", {
            className: "text-left my-lg-4",
            children: "Profile Info"
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "accountFirstName",
              children: t('frontend.account.first_name')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              type: "text",
              id: "accountFirstName",
              value: formik.values.accountFirstName,
              onChange: formik.handleChange
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "accountLastName",
              children: t('frontend.account.last_name')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              type: "text",
              id: "accountLastName",
              value: formik.values.accountLastName,
              onChange: formik.handleChange
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "accountEmailAddress",
              children: t('frontend.account.email')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              type: "accountEmailAddress",
              id: "accountEmailAddress",
              value: formik.values.accountEmailAddress,
              onChange: formik.handleChange,
              disabled: ""
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "accountCompany",
              children: t('frontend.account.company')
            }), /*#__PURE__*/jsx("input", {
              className: "form-control",
              value: formik.values.accountCompany,
              type: "text",
              onChange: formik.handleChange,
              id: "accountCompany"
            })]
          })
        }), /*#__PURE__*/jsxs("div", {
          className: "col-12",
          children: [/*#__PURE__*/jsx("hr", {
            className: "mt-2 mb-3"
          }), /*#__PURE__*/jsxs("div", {
            className: "d-flex flex-wrap justify-content-end",
            children: [/*#__PURE__*/jsx(Link, {
              className: "btn btn-secondary mt-3 mt-sm-0 mr-3",
              to: "/my-account/updatePassword",
              children: t('frontend.account.password_update')
            }), /*#__PURE__*/jsx("button", {
              type: "submit",
              disabled: formik.isSubmitting,
              className: "btn btn-primary mt-3 mt-sm-0",
              children: t('frontend.account.profile_update')
            })]
          })]
        })]
      })
    })]
  });
};

var CreateAccount = function CreateAccount() {
  var dispatch = useDispatch();
  var phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var history = useHistory(); // eslint-disable-next-line no-unused-vars

  var signupSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    phoneNumber: Yup.string().required('Required').matches(phoneRegExp, 'Phone number is not valid'),
    password: Yup.string().required('Required'),
    passwordConfirm: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
    emailAddress: Yup.string().email('Invalid email').required('Required'),
    emailAddressConfirm: Yup.string().email('Invalid email').oneOf([Yup.ref('emailAddress'), null], 'Emails must match')
  });
  var formik = useFormik({
    initialValues: {
      returnTokenFlag: '1',
      createAuthenticationFlag: '1',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailAddress: '',
      emailAddressConfirm: '',
      password: '',
      passwordConfirm: ''
    },
    validateOnChange: false,
    validationSchema: signupSchema,
    onSubmit: function onSubmit(values) {
      SlatwallApiService.account.create(values).then(function (response) {
        var _response$success;

        if (response.isSuccess() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

        if (response.isSuccess()) {
          if (!response.success().failureActions.length) {
            toast.success('Success');
            dispatch(getUser());
            dispatch(getWishLists());

            if (history.location.search.includes('redirect')) {
              history.replace("/my-account".concat(history.location.search));
            } else {
              history.replace("/my-account");
            }
          }
        } else {
          toast.error('Error');
        }
      });
    }
  });
  return /*#__PURE__*/jsx(PromptLayout, {
    children: /*#__PURE__*/jsxs(SWForm, {
      formik: formik,
      primaryButtontext: "Create Account & Continue",
      title: "Create Account",
      children: [/*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx(SWInput, {
          formik: formik,
          token: "firstName",
          label: "First Name",
          wrapperClasses: ""
        }), /*#__PURE__*/jsx(SWInput, {
          formik: formik,
          token: "lastName",
          label: "Last Name",
          wrapperClasses: ""
        })]
      }), /*#__PURE__*/jsx(SWInput, {
        formik: formik,
        token: "phoneNumber",
        label: "Phone Number",
        type: "phone"
      }), /*#__PURE__*/jsx(SWInput, {
        formik: formik,
        token: "emailAddress",
        label: "Email Address",
        type: "email"
      }), /*#__PURE__*/jsx(SWInput, {
        formik: formik,
        token: "emailAddressConfirm",
        label: "Confirm Email Address",
        type: "email"
      }), /*#__PURE__*/jsx(SWInput, {
        formik: formik,
        token: "password",
        label: "Password",
        type: "password"
      }), /*#__PURE__*/jsx(SWInput, {
        formik: formik,
        token: "passwordConfirm",
        label: "Confirm Password",
        type: "password"
      }), /*#__PURE__*/jsx(Link, {
        to: "/my-account",
        children: t('frontend.account.back_to_login')
      })]
    })
  });
};

var UpdatePassword = function UpdatePassword(_ref) {
  _ref.path;
      var heading = _ref.heading,
      _ref$redirectLocation = _ref.redirectLocation,
      redirectLocation = _ref$redirectLocation === void 0 ? '/my-account/profile' : _ref$redirectLocation,
      customBody = _ref.customBody,
      contentTitle = _ref.contentTitle,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? 'Update Password' : _ref$action;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useRedirect = useRedirect({
    location: redirectLocation
  }),
      _useRedirect2 = _slicedToArray(_useRedirect, 2),
      redirect = _useRedirect2[0],
      setRedirect = _useRedirect2[1];

  var formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      accountPassword: '',
      accountPasswordConfirm: ''
    },
    onSubmit: function onSubmit(values) {
      SlatwallApiService.account.changePassword({
        password: values.accountPassword,
        passwordConfirm: values.accountPasswordConfirm
      }).then(function (response) {
        if (response.isSuccess()) {
          if (response.success().successfulActions.length) {
            toast.success(t('frontend.account.password_update'));
            setRedirect(_objectSpread2(_objectSpread2({}, redirect), {}, {
              shouldRedirect: true
            }));
          } else {
            var errors = response.success().errors.password ? response.success().errors.password : response.success().errors.passwordConfirm;
            toast.error(errors.join(' '));
          }
        } else {
          toast.error('Network Error');
        }
      });
    }
  });
  return /*#__PURE__*/jsxs(AccountLayout, {
    title: "Add ".concat(action),
    children: [/*#__PURE__*/jsx(AccountContent, {
      customBody: customBody,
      contentTitle: contentTitle
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/jsx("h2", {
        children: heading
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "accountPassword",
            children: "Password"
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "password",
            id: "accountPassword",
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "form-group col-md-6",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "accountPasswordConfirm",
            children: "Confirm Password"
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "password",
            id: "accountPasswordConfirm",
            onChange: formik.handleChange
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "col-12",
          children: [/*#__PURE__*/jsx("hr", {
            className: "mt-2 mb-3"
          }), /*#__PURE__*/jsx("div", {
            className: "d-flex flex-wrap justify-content-end",
            children: /*#__PURE__*/jsx("button", {
              type: "submit",
              className: "btn btn-primary mt-3 mt-sm-0",
              children: t('frontend.core.save')
            })
          })]
        })]
      })]
    })]
  });
}; //

var ForgotPassword = function ForgotPassword() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t; // eslint-disable-next-line no-unused-vars


  var _useRedirect = useRedirect({
    location: '/my-account'
  }),
      _useRedirect2 = _slicedToArray(_useRedirect, 2);
      _useRedirect2[0];
      var setRedirect = _useRedirect2[1];

  var formik = useFormik({
    initialValues: {
      emailAddress: ''
    },
    onSubmit: function onSubmit(values) {
      SlatwallApiService.account.forgotPassword(values).then(function (response) {
        if (response.isSuccess() && !response.success().failureActions.length) {
          toast.success(t('frontend.account.forgotpassword.success'));
          setRedirect({
            shouldRedirect: true
          });
        } else {
          var _response$success;

          var errorMessage;
          errorMessage = response.success() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length ? getErrorMessage(response.success().errors) : t('frontend.account.forgotpassword.error');
          toast.error(errorMessage);
        }
      });
    }
  });
  return /*#__PURE__*/jsx(PromptLayout, {
    children: /*#__PURE__*/jsxs(SWForm, {
      formik: formik,
      title: "Forgot Password",
      primaryButtontext: "Send Me Reset Email",
      children: [/*#__PURE__*/jsx(SWInput, {
        required: true,
        formik: formik,
        token: "emailAddress",
        label: "Email Address",
        type: "email"
      }), /*#__PURE__*/jsx(Link, {
        to: "/my-account",
        children: t('frontend.account.back_to_login')
      })]
    })
  });
}; //

var ForgotPasswordReset = function ForgotPasswordReset() {
  var loc = useLocation();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldRedirect = _useState2[0],
      setRedirect = _useState2[1];

  var history = useHistory();
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _queryString$parse = queryString.parse(loc.search, {
    arrayFormat: 'separator',
    arrayFormatSeparator: ','
  }),
      swprid = _queryString$parse.swprid;

  var formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirm: ''
    },
    validateOnChange: false,
    validationSchema: Yup.object().shape({
      password: Yup.string().required('Required'),
      passwordConfirm: Yup.string().required('Required').oneOf([Yup.ref('password'), null], t('frontend.account.forgot.match'))
    }),
    onSubmit: function onSubmit(_ref) {
      var password = _ref.password,
          passwordConfirm = _ref.passwordConfirm;
      var payload = {
        swprid: swprid,
        passwordConfirm: passwordConfirm,
        password: password
      };
      SlatwallApiService.account.resetPassword(payload).then(function (response) {
        if (response.isSuccess() && (response.success().errors === undefined || response.success().errors === null) && response.success().failureActions.length === 0) {
          toast.success(t('frontend.account.forgot.success'));
          setRedirect(true);
        } else {
          var _response$success;

          var errorMessage = response.success() && Object.keys(((_response$success = response.success()) === null || _response$success === void 0 ? void 0 : _response$success.errors) || {}).length ? getErrorMessage(response.success().errors) : t('frontend.account.forgot.failure');
          toast.error(errorMessage);
          dispatch(errorLogin());
        }

        formik.setSubmitting(false);
      });
    }
  });
  if (!swprid || shouldRedirect) history.replace('/my-account/Login');
  return /*#__PURE__*/jsx("div", {
    className: "container py-4 py-lg-5 my-4",
    children: /*#__PURE__*/jsx("div", {
      className: "row d-flex justify-content-center",
      children: /*#__PURE__*/jsx("div", {
        className: "col-md-6",
        children: /*#__PURE__*/jsx("div", {
          className: "card box-shadow",
          children: /*#__PURE__*/jsxs("div", {
            className: "card-body",
            children: [/*#__PURE__*/jsx("h2", {
              className: "h4 mb-1",
              children: t('frontend.account.forgot.heading')
            }), /*#__PURE__*/jsx("p", {
              className: "font-size-sm text-muted mb-4"
            }), /*#__PURE__*/jsxs("form", {
              children: [/*#__PURE__*/jsxs("div", {
                className: "form-group",
                children: [/*#__PURE__*/jsx("label", {
                  htmlFor: "password",
                  children: t('frontend.account.forgot.new')
                }), /*#__PURE__*/jsx("input", {
                  value: formik.values.password,
                  onBlur: formik.handleBlur,
                  onChange: formik.handleChange,
                  autoComplete: "current-password",
                  className: "form-control",
                  type: "password",
                  id: "password"
                }), formik.errors.password && formik.touched.password && /*#__PURE__*/jsx("span", {
                  className: "form-error-msg",
                  children: formik.errors.password
                })]
              }), /*#__PURE__*/jsxs("div", {
                className: "form-group",
                children: [/*#__PURE__*/jsx("label", {
                  htmlFor: "passwordConfirm",
                  children: t('frontend.account.forgot.confirm')
                }), /*#__PURE__*/jsx("input", {
                  value: formik.values.passwordConfirm,
                  onBlur: formik.handleBlur,
                  onChange: formik.handleChange,
                  autoComplete: "current-password",
                  className: "form-control",
                  type: "password",
                  id: "passwordConfirm"
                }), formik.errors.passwordConfirm && formik.touched.passwordConfirm && /*#__PURE__*/jsx("span", {
                  className: "form-error-msg",
                  children: formik.errors.passwordConfirm
                })]
              }), /*#__PURE__*/jsx("hr", {
                className: "mt-4"
              }), /*#__PURE__*/jsx("div", {
                className: "text-right pt-4",
                children: /*#__PURE__*/jsx(Button, {
                  isLoading: formik.isSubmitting,
                  disabled: formik.isSubmitting,
                  classList: "btn btn-primary btn-lg mt-3",
                  onClick: formik.handleSubmit,
                  children: t('frontend.account.forgot.submit')
                })
              })]
            })]
          })
        })
      })
    })
  });
};

var CartLineItem = function CartLineItem(_ref) {
  var orderItemID = _ref.orderItemID,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useDispatch();

  var _useCartLineItem = useCartLineItem(orderItemID),
      orderItem = _useCartLineItem.orderItem,
      listPrice = _useCartLineItem.listPrice,
      productRouting = _useCartLineItem.productRouting,
      isFetching = _useCartLineItem.isFetching,
      isBackordered = _useCartLineItem.isBackordered;

  var productRoute = useSelector(getProductRoute);
  var productLink = "/".concat(productRoute, "/").concat(orderItem.sku.product.urlTitle);
  var isAuthed = isAuthenticated();
  var isVerified = useSelector(isAccountVerified);
  return /*#__PURE__*/jsxs("div", {
    className: "row border-bottom pb-3 pt-4 mx-1",
    children: [/*#__PURE__*/jsx("div", {
      className: "col-sm-2 col-3 pr-0",
      children: /*#__PURE__*/jsx(Link, {
        className: "d-inline-block mx-auto image-width",
        to: productLink,
        children: orderItem.sku.images && orderItem.sku.images.length > 0 && /*#__PURE__*/jsx(SimpleImage, {
          src: orderItem.sku.images[0],
          alt: orderItem.sku.product.productName
        })
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "col-9 col-sm-10 col-md-4",
      children: [/*#__PURE__*/jsx("span", {
        className: "product-meta d-block font-size-xs pb-1",
        children: orderItem.sku.product.productSeries
      }), /*#__PURE__*/jsx("h3", {
        className: "product-title font-size-base mb-2",
        children: /*#__PURE__*/jsx(Link, {
          to: {
            pathname: "/".concat(productRouting, "/").concat(orderItem.sku.product.urlTitle),
            state: _objectSpread2({}, orderItem.sku.product)
          },
          children: orderItem.sku.product.productName
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "font-size-sm",
        children: ["".concat(orderItem.sku.product.brand.brandName, " "), /*#__PURE__*/jsx("span", {
          className: "text-muted mr-2",
          children: orderItem.sku.skuCode
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "col-sm-12 col-md-6 mt-2 mt-md-0",
      children: [/*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-3",
          children: /*#__PURE__*/jsx("div", {
            className: "product-price",
            children: /*#__PURE__*/jsx(ProductPrice, {
              type: "cart",
              salePrice: orderItem.price,
              listPrice: listPrice,
              accentSalePrice: false
            })
          })
        }), isDisabled && /*#__PURE__*/jsx("div", {
          className: "col-4",
          children: /*#__PURE__*/jsxs("p", {
            className: "mb-0",
            children: [/*#__PURE__*/jsxs("span", {
              className: "text-muted font-size-sm",
              children: [t('frontend.cart.qty'), " "]
            }), /*#__PURE__*/jsx("span", {
              children: orderItem.quantity
            })]
          })
        }), !isDisabled && /*#__PURE__*/jsxs("div", {
          className: "col-4",
          children: [/*#__PURE__*/jsx("label", {
            className: "d-md-none small",
            children: t('frontend.core.quantity')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "number",
            id: "quantity4",
            "aria-label": "quantity",
            defaultValue: orderItem.quantity,
            disabled: isFetching,
            onChange: function onChange(e) {
              dispatch(updateItemQuantity(orderItem.sku.skuID, e.target.value));
            }
          })]
        }), /*#__PURE__*/jsx("div", {
          className: "col-3",
          children: /*#__PURE__*/jsx("div", {
            className: "text-accent",
            children: isAuthed && isVerified ? formatCurrency(orderItem.extendedPriceAfterDiscount) : '__'
          })
        }), !isDisabled && /*#__PURE__*/jsx("div", {
          className: "col-1",
          children: /*#__PURE__*/jsx("button", {
            className: "btn btn-link p-0",
            type: "button",
            title: "remove",
            disabled: isFetching,
            onClick: function onClick(event) {
              event.preventDefault();
              dispatch(removeItem(orderItem.orderItemID));
            },
            children: /*#__PURE__*/jsx("i", {
              className: "fal fa-times-circle h5 m-0"
            })
          })
        })]
      }), isBackordered && /*#__PURE__*/jsx("div", {
        className: "row",
        children: /*#__PURE__*/jsx("div", {
          className: "col",
          children: /*#__PURE__*/jsxs("div", {
            className: "p-2 border rounded w-100 d-flex mt-3 align-items-center",
            children: [/*#__PURE__*/jsx("i", {
              className: "fal fa-exclamation-circle mr-2"
            }), /*#__PURE__*/jsx("p", {
              className: "text-sm mb-0",
              children: t('frontend.order.backorder')
            })]
          })
        })
      })]
    })]
  });
};

var CartPromoBox = function CartPromoBox() {
  var promotionCodes = useSelector(function (state) {
    return state.cart.promotionCodes;
  });
  var disableInteraction = useSelector(disableInteractionSelector);
  var dispatch = useDispatch();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      promoCode = _useState2[0],
      setPromoCode = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsx("div", {
    className: "accordion",
    id: "order-options",
    children: /*#__PURE__*/jsxs("div", {
      className: "card",
      children: [/*#__PURE__*/jsx("div", {
        className: "card-header",
        children: /*#__PURE__*/jsx("h3", {
          className: "accordion-heading",
          children: /*#__PURE__*/jsx("a", {
            href: "#promo-code",
            role: "button",
            "data-toggle": "collapse",
            "aria-expanded": "true",
            "aria-controls": "promo-code",
            children: t('frontend.order.promo.code.apply')
          })
        })
      }), /*#__PURE__*/jsx("div", {
        className: "collapse show",
        id: "promo-code",
        "data-parent": "#order-options",
        children: /*#__PURE__*/jsxs("form", {
          className: "card-body needs-validation",
          method: "post",
          noValidate: "",
          children: [/*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("input", {
              disabled: disableInteraction,
              className: "form-control",
              type: "text",
              placeholder: "Promo code",
              value: promoCode,
              required: true,
              onChange: function onChange(e) {
                return setPromoCode(e.target.value);
              }
            }), /*#__PURE__*/jsx("div", {
              className: "invalid-feedback",
              children: t('frontend.order.promo.code.provide')
            })]
          }), /*#__PURE__*/jsx("button", {
            className: "btn btn-outline-primary btn-block",
            type: "submit",
            disabled: disableInteraction,
            onClick: function onClick(e) {
              e.preventDefault();
              dispatch(applyPromoCode(promoCode, t('frontend.checkout.promo_code_applied')));
              setPromoCode('');
            },
            children: t('frontend.order.promo.code.apply')
          }), promotionCodes.length > 0 && promotionCodes.map(function (promotionCodeItem) {
            var promotionCode = promotionCodeItem.promotionCode,
                promotion = promotionCodeItem.promotion;
            var promotionName = promotion.promotionName;
            return /*#__PURE__*/jsx("button", {
              className: "btn btn-link px-0 w-100",
              type: "button",
              disabled: disableInteraction,
              onClick: function onClick(event) {
                event.preventDefault();
                dispatch(removePromoCode(promotionCode, undefined, t('frontend.checkout.promo_code_removed')));
              },
              children: /*#__PURE__*/jsxs("span", {
                className: "btn-sm btn-success font-size-sm d-block",
                children: [" ", /*#__PURE__*/jsxs("strong", {
                  children: [" ", promotionName, " ", /*#__PURE__*/jsx("i", {
                    className: "fal fa-times-circle ml-1"
                  }), " "]
                }), " "]
              })
            }, promotionCode);
          })]
        })
      })]
    })
  });
};

var OrderNotes = function OrderNotes() {
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state.cart;
  }),
      _useSelector$orderNot = _useSelector.orderNotes,
      orderNotes = _useSelector$orderNot === void 0 ? '' : _useSelector$orderNot,
      isFetching = _useSelector.isFetching;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState({
    text: '',
    original: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      notes = _useState2[0],
      setOrderNotes = _useState2[1];

  if (orderNotes !== notes.original) {
    setOrderNotes({
      text: orderNotes,
      original: orderNotes
    });
  }

  return /*#__PURE__*/jsxs("div", {
    className: "form-group mb-4 mt-3",
    children: [/*#__PURE__*/jsx("label", {
      className: "mb-2",
      htmlFor: "order-comments",
      children: /*#__PURE__*/jsx("span", {
        className: "font-weight-medium",
        children: t('frontend.order.notes')
      })
    }), /*#__PURE__*/jsx("textarea", {
      className: "form-control",
      rows: "6",
      disabled: isFetching,
      id: "order-comments",
      value: notes.text,
      onChange: function onChange(e) {
        e.preventDefault();
        setOrderNotes({
          text: e.target.value,
          original: orderNotes
        });
      }
    }), notes.text !== notes.original && /*#__PURE__*/jsx("button", {
      className: "btn btn-secondary btn-block mt-4",
      type: "submit",
      disabled: isFetching,
      onClick: function onClick(event) {
        dispatch(updateOrderNotes({
          orderNotes: notes.text
        }));
        event.preventDefault();
      },
      children: "Save Notes"
    })]
  });
};

var PromotionalMessaging = function PromotionalMessaging() {
  var appliedPromotionMessages = useSelector(function (state) {
    return state.cart.appliedPromotionMessages;
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: appliedPromotionMessages.length > 0 && appliedPromotionMessages.map(function (_ref, index) {
      var message = _ref.message;
      return /*#__PURE__*/jsxs("div", {
        className: "alert alert-success alert-wicon",
        role: "alert",
        children: [/*#__PURE__*/jsx("i", {
          className: "fal fa-usd-circle"
        }), message]
      }, index);
    })
  });
};

var OrderSummary = function OrderSummary() {
  var cart = useSelector(function (state) {
    return state.cart;
  });
  var total = cart.total,
      taxTotal = cart.taxTotal,
      subtotal = cart.subtotal,
      discountTotal = cart.discountTotal,
      fulfillmentChargeAfterDiscountTotal = cart.fulfillmentChargeAfterDiscountTotal;
  var isAuthed = isAuthenticated();
  var isVerified = useSelector(isAccountVerified);

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "widget mb-3",
      children: /*#__PURE__*/jsx("h2", {
        className: "widget-title text-center",
        children: t('frontend.order.summary')
      })
    }), /*#__PURE__*/jsxs("ul", {
      className: "list-unstyled font-size-sm pb-2 border-bottom",
      children: [/*#__PURE__*/jsxs("li", {
        className: "d-flex justify-content-between align-items-center",
        children: [/*#__PURE__*/jsxs("span", {
          className: "mr-2",
          children: [t('frontend.order.subtotal'), ":"]
        }), /*#__PURE__*/jsx("span", {
          className: "text-right",
          children: isAuthed && isVerified && subtotal > 0 ? formatCurrency(subtotal) : '--'
        })]
      }), /*#__PURE__*/jsxs("li", {
        className: "d-flex justify-content-between align-items-center",
        children: [/*#__PURE__*/jsxs("span", {
          className: "mr-2",
          children: [t('frontend.order.shipping'), ":"]
        }), /*#__PURE__*/jsx("span", {
          className: "text-right",
          children: fulfillmentChargeAfterDiscountTotal > 0 ? formatCurrency(fulfillmentChargeAfterDiscountTotal) : '--'
        })]
      }), /*#__PURE__*/jsxs("li", {
        className: "d-flex justify-content-between align-items-center",
        children: [/*#__PURE__*/jsxs("span", {
          className: "mr-2",
          children: [t('frontend.order.taxes'), ":"]
        }), /*#__PURE__*/jsx("span", {
          className: "text-right",
          children: taxTotal > 0 ? formatCurrency(taxTotal) : '--'
        })]
      }), /*#__PURE__*/jsxs("li", {
        className: "d-flex justify-content-between align-items-center",
        children: [/*#__PURE__*/jsxs("span", {
          className: "mr-2",
          children: [t('frontend.order.discount'), ":"]
        }), /*#__PURE__*/jsx("span", {
          className: "text-right text-success font-weight-bold",
          children: discountTotal > 0 ? formatCurrency(discountTotal) : '--'
        })]
      })]
    }), /*#__PURE__*/jsx("h3", {
      className: "font-weight-normal text-center my-4",
      children: /*#__PURE__*/jsx("span", {
        children: isAuthed && isVerified && total > 0 ? formatCurrency(total) : '--'
      })
    })]
  });
};

var CheckoutSideBar = function CheckoutSideBar() {
  var cart = useSelector(function (state) {
    return state.cart;
  });
  var isFetching = cart.isFetching;
  var loc = useLocation();
  var path = loc.pathname.split('/').reverse()[0].toLowerCase();
  var currentStep = getCurrentStep(path);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useDispatch();
  return /*#__PURE__*/jsx("aside", {
    className: "col-lg-4 pt-4 pt-lg-0",
    children: /*#__PURE__*/jsxs("div", {
      className: "cz-sidebar-static rounded-lg box-shadow-lg ml-lg-auto",
      children: [/*#__PURE__*/jsx(PromotionalMessaging, {}), /*#__PURE__*/jsx(OrderSummary, {}), currentStep.key !== REVIEW && /*#__PURE__*/jsx(CartPromoBox, {}), currentStep.key === REVIEW && /*#__PURE__*/jsx(OrderNotes, {}), currentStep.key === REVIEW && /*#__PURE__*/jsx("button", {
        className: "btn btn-primary btn-block mt-4",
        type: "submit",
        disabled: isFetching,
        onClick: function onClick(event) {
          dispatch(placeOrder());
          event.preventDefault();
        },
        children: t('frontend.order.complete')
      })]
    })
  });
};

var getCurrentStep$1 = function getCurrentStep(path) {
  return (checkOutSteps.filter(function (step) {
    return step.key === path;
  }) || [checkOutSteps[1]])[0];
};

var StepsHeader = function StepsHeader() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var loc = useLocation();
  var history = useHistory();
  var path = loc.pathname.split('/').reverse()[0].toLowerCase();
  var current = getCurrentStep$1(path);
  return /*#__PURE__*/jsx("div", {
    className: "steps steps-dark pt-2 pb-3 mb-5",
    children: checkOutSteps.map(function (step) {
      var progressSate = '';

      if (step.progress < current.progress) {
        progressSate = 'active';
      } else if (step.progress === current.progress) {
        progressSate = 'active current';
      }

      return /*#__PURE__*/jsxs("button", {
        className: "step-item ".concat(progressSate, " btn btn-link flex-grow-1 p-0"),
        style: {
          border: 'none'
        },
        onClick: function onClick(e) {
          e.preventDefault();
          if (step.key === 'checkout') history.push('/shopping-cart');else history.push(step.key);
        },
        disabled: progressSate === '',
        children: [/*#__PURE__*/jsx("div", {
          className: "step-progress",
          children: /*#__PURE__*/jsx("span", {
            className: "step-count",
            children: step.progress
          })
        }), /*#__PURE__*/jsxs("div", {
          className: "step-label",
          children: [/*#__PURE__*/jsx("i", {
            className: "fal fa-".concat(step.icon)
          }), t(step.name)]
        })]
      }, step.progress);
    })
  });
};

var SlideNavigation = function SlideNavigation(_ref) {
  var currentStep = _ref.currentStep,
      _ref$nextActive = _ref.nextActive,
      nextActive = _ref$nextActive === void 0 ? true : _ref$nextActive;
  var history = useHistory();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs("div", {
      className: "d-lg-flex pt-4 mt-3",
      children: [/*#__PURE__*/jsx("div", {
        className: "w-50 pr-3",
        children: /*#__PURE__*/jsxs(Link, {
          className: "btn btn-secondary btn-block",
          to: currentStep.previous,
          children: [/*#__PURE__*/jsx("i", {
            className: "far fa-chevron-left"
          }), " ", /*#__PURE__*/jsx("span", {
            className: "d-none d-sm-inline",
            children: t('frontend.pagination.previous')
          }), /*#__PURE__*/jsx("span", {
            className: "d-inline d-sm-none",
            children: t('frontend.pagination.previous')
          })]
        })
      }), currentStep.next.length > 0 && /*#__PURE__*/jsx("div", {
        className: "w-50 pl-2",
        children: /*#__PURE__*/jsxs("button", {
          className: "btn btn-primary btn-block",
          disabled: !nextActive,
          onClick: function onClick(e) {
            e.preventDefault();
            history.push(currentStep.next);
          },
          children: [/*#__PURE__*/jsx("span", {
            className: "d-none d-sm-inline",
            children: t('frontend.pagination.Continue')
          }), /*#__PURE__*/jsx("span", {
            className: "d-inline d-sm-none",
            children: t('frontend.pagination.next')
          }), " ", /*#__PURE__*/jsx("i", {
            className: "far fa-chevron-right"
          })]
        })
      })]
    })
  });
};

var CART = 'checkout';
var SHIPPING = 'shipping';
var PAYMENT = 'payment';
var REVIEW = 'review';

var getCurrentStep = function getCurrentStep(path) {
  return (checkOutSteps.filter(function (step) {
    return step.key === path;
  }) || [checkOutSteps[1]])[0];
};

var checkOutSteps = [{
  key: CART,
  progress: 1,
  icon: 'shopping-cart',
  name: 'frontend.checkout.cart.heading',
  state: '',
  previous: '',
  next: ''
}, {
  key: SHIPPING,
  progress: 2,
  icon: 'shipping-fast',
  name: 'frontend.checkout.shipping.heading',
  state: '',
  next: 'payment',
  previous: '/shopping-cart'
}, {
  key: PAYMENT,
  progress: 3,
  icon: 'credit-card',
  name: 'frontend.checkout.payment.heading',
  state: '',
  previous: 'shipping',
  next: 'review'
}, {
  key: REVIEW,
  progress: 4,
  icon: 'check-circle',
  name: 'frontend.checkout.review.heading',
  state: '',
  previous: 'payment',
  next: ''
}];

var PickupLocationDetails = function PickupLocationDetails(_ref) {
  var pickupLocation = _ref.pickupLocation;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("h3", {
      className: "h6",
      children: [t('frontend.checkout.fulfilment.pickup.location'), ":"]
    }), /*#__PURE__*/jsx("p", {
      children: pickupLocation.locationName
    })]
  });
};

var ShippingAddressDetails = function ShippingAddressDetails(_ref) {
  var shippingAddress = _ref.shippingAddress,
      shippingAddressNickname = _ref.shippingAddressNickname;

  var _ref2 = shippingAddress || {},
      name = _ref2.name,
      streetAddress = _ref2.streetAddress,
      city = _ref2.city,
      stateCode = _ref2.stateCode,
      postalCode = _ref2.postalCode,
      emailAddress = _ref2.emailAddress;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h3", {
      className: "h6",
      children: t('frontend.checkout.shipping_address')
    }), /*#__PURE__*/jsxs("p", {
      children: [shippingAddressNickname && /*#__PURE__*/jsxs(Fragment, {
        children: [shippingAddressNickname, /*#__PURE__*/jsx("br", {})]
      }), name, " ", /*#__PURE__*/jsx("br", {}), streetAddress, " ", /*#__PURE__*/jsx("br", {}), "".concat(city, ", ").concat(stateCode, " ").concat(postalCode), " ", /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("span", {
        className: "d-inline-block text-truncate w-100",
        children: emailAddress && emailAddress
      })]
    })]
  });
};

var BillingAddressDetails = function BillingAddressDetails(_ref) {
  var orderPayment = _ref.orderPayment,
      billingNickname = _ref.billingNickname;
  var billingAddress = orderPayment.billingAddress;

  var _ref2 = billingAddress || {},
      name = _ref2.name,
      streetAddress = _ref2.streetAddress,
      city = _ref2.city,
      stateCode = _ref2.stateCode,
      postalCode = _ref2.postalCode,
      emailAddress = _ref2.emailAddress;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h3", {
      className: "h6",
      children: t('frontend.checkout.billing_address')
    }), billingAddress && /*#__PURE__*/jsxs("p", {
      children: [billingNickname && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("em", {
          children: billingNickname
        }), /*#__PURE__*/jsx("br", {})]
      }), name, " ", /*#__PURE__*/jsx("br", {}), streetAddress, " ", /*#__PURE__*/jsx("br", {}), "".concat(city, ", ").concat(stateCode, " ").concat(postalCode), " ", /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("span", {
        className: "d-inline-block text-truncate w-100",
        children: emailAddress && emailAddress
      })]
    })]
  });
};

var TermPaymentDetails = function TermPaymentDetails(_ref) {
  var termPayment = _ref.termPayment,
      hideHeading = _ref.hideHeading;
  var purchaseOrderNumber = termPayment.purchaseOrderNumber,
      paymentMethod = termPayment.paymentMethod;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [!hideHeading && /*#__PURE__*/jsx("h3", {
      className: "h6",
      children: t('frontend.checkout.payment_method')
    }), /*#__PURE__*/jsx("em", {
      children: paymentMethod.paymentMethodName
    }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("p", {
      children: purchaseOrderNumber
    })]
  });
};

var CCDetails = function CCDetails(_ref) {
  var creditCardPayment = _ref.creditCardPayment,
      _ref$hideHeading = _ref.hideHeading,
      hideHeading = _ref$hideHeading === void 0 ? false : _ref$hideHeading;
  var paymentMethod = creditCardPayment.paymentMethod,
      creditCardType = creditCardPayment.creditCardType,
      nameOnCreditCard = creditCardPayment.nameOnCreditCard,
      creditCardLastFour = creditCardPayment.creditCardLastFour;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [!hideHeading && /*#__PURE__*/jsx("h3", {
      className: "h6",
      children: t('frontend.checkout.payment_method')
    }), /*#__PURE__*/jsxs("p", {
      children: [/*#__PURE__*/jsx("em", {
        children: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.paymentMethodName
      }), /*#__PURE__*/jsx("br", {}), nameOnCreditCard, " ", /*#__PURE__*/jsx("br", {}), "".concat(creditCardType, " ending in ").concat(creditCardLastFour)]
    })]
  });
};

var GiftCardDetails = function GiftCardDetails(_ref) {
  var hideHeading = _ref.hideHeading;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [!hideHeading && /*#__PURE__*/jsx("h3", {
      className: "h6",
      children: t('frontend.checkout.payment_method')
    }), /*#__PURE__*/jsx("p", {
      children: t('frontend.checkout.payment.giftCard.title')
    })]
  });
};

var ReviewSlide = function ReviewSlide(_ref) {
  var currentStep = _ref.currentStep;
  var cart = useSelector(function (state) {
    return state.cart;
  });

  var _useSelector = useSelector(fulfillmentSelector),
      fulfillmentMethod = _useSelector.fulfillmentMethod;

  var payment = useSelector(orderPayment);
  var shippingAddress = useSelector(shippingAddressSelector);
  var shippingMethod = useSelector(shippingMethodSelector);
  var pickupLocation = useSelector(pickupLocationSelector);
  var billingNickname = useSelector(billingAddressNickname);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var shippingAddressNickname = useSelector(shippingAddressNicknameSelector);

  if (cart.isPlaced) {
    return /*#__PURE__*/jsx(Redirect$1, {
      to: '/order-confirmation'
    });
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: "row bg-lightgray p-3 rounded mb-5 text-break",
      children: [fulfillmentMethod.fulfillmentMethodType === 'shipping' && /*#__PURE__*/jsxs("div", {
        className: "col-md-4",
        children: [/*#__PURE__*/jsx(ShippingAddressDetails, {
          shippingAddress: shippingAddress,
          shippingAddressNickname: shippingAddressNickname
        }), /*#__PURE__*/jsx(Link, {
          to: "/checkout/shipping",
          className: "text-link",
          children: t('frontend.core.edit')
        })]
      }), fulfillmentMethod.fulfillmentMethodType === 'pickup' && /*#__PURE__*/jsxs("div", {
        className: "col-md-4",
        children: [/*#__PURE__*/jsx(PickupLocationDetails, {
          pickupLocation: pickupLocation
        }), /*#__PURE__*/jsx(Link, {
          to: "/checkout/shipping",
          className: "text-link",
          children: t('frontend.core.edit')
        })]
      }), /*#__PURE__*/jsx("div", {
        className: "col-md-4",
        children: /*#__PURE__*/jsx(BillingAddressDetails, {
          billingAddressNickname: billingNickname,
          orderPayment: payment
        })
      }), payment.paymentMethod.paymentMethodType === 'creditCard' && /*#__PURE__*/jsxs("div", {
        className: "col-md-4",
        children: [/*#__PURE__*/jsx(CCDetails, {
          creditCardPayment: payment
        }), /*#__PURE__*/jsx(Link, {
          to: "/checkout/payment",
          className: "text-link",
          children: t('frontend.core.edit')
        })]
      }), payment.paymentMethod.paymentMethodType === 'giftCard' && /*#__PURE__*/jsxs("div", {
        className: "col-md-4",
        children: [/*#__PURE__*/jsx(GiftCardDetails, {}), /*#__PURE__*/jsx(Link, {
          to: "/checkout/payment",
          className: "text-link",
          children: t('frontend.core.edit')
        })]
      }), payment.paymentMethod.paymentMethodType === 'termPayment' && /*#__PURE__*/jsxs("div", {
        className: "col-md-4",
        children: [/*#__PURE__*/jsx(TermPaymentDetails, {
          termPayment: payment
        }), /*#__PURE__*/jsx(Link, {
          to: "/checkout/payment",
          className: "text-link",
          children: t('frontend.core.edit')
        })]
      }), fulfillmentMethod.fulfillmentMethodType === 'shipping' && /*#__PURE__*/jsxs("div", {
        className: "col-md-4 mt-4 mb-4",
        children: [/*#__PURE__*/jsx("h3", {
          className: "h6",
          children: t('frontend.checkout.shippingMethod')
        }), shippingMethod.shippingMethodName]
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "card-header",
      children: /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-12 col-md-6",
          children: /*#__PURE__*/jsx("h4", {
            className: "mb-0 h6",
            children: t('frontend.checkout.review.order')
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-12 col-md-6 d-none d-md-block",
          children: /*#__PURE__*/jsxs("div", {
            className: "row",
            children: [/*#__PURE__*/jsx("div", {
              className: "col-sm-3",
              children: /*#__PURE__*/jsx("small", {
                children: t('frontend.cart.price')
              })
            }), /*#__PURE__*/jsx("div", {
              className: "col-sm-4",
              children: /*#__PURE__*/jsx("small", {
                children: t('frontend.cart.qty')
              })
            }), /*#__PURE__*/jsx("div", {
              className: "col-sm-3",
              children: /*#__PURE__*/jsx("small", {
                children: t('frontend.cart.total')
              })
            })]
          })
        })]
      })
    }), cart.orderItems && cart.orderItems.map(function (_ref2) {
      var orderItemID = _ref2.orderItemID;
      return /*#__PURE__*/jsx(CartLineItem, {
        orderItemID: orderItemID,
        isDisabled: true
      }, orderItemID); // this cannot be index or it wont force a rerender
    }), /*#__PURE__*/jsx(SlideNavigation, {
      currentStep: currentStep
    })]
  });
};

var TermPayment = function TermPayment(_ref) {
  var method = _ref.method;
  var dispatch = useDispatch();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      accountAddressID = _useState2[0],
      setAccountAddressID = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      saveShippingAsBilling = _useState4[0],
      setSaveShippingAsBilling = _useState4[1];

  var _useSelector = useSelector(orderPayment),
      purchaseOrderNumber = _useSelector.purchaseOrderNumber;

  var _useState5 = useState(purchaseOrderNumber),
      _useState6 = _slicedToArray(_useState5, 2),
      termOrderNumber = _useState6[0],
      setTermOrderNumber = _useState6[1];

  var selectedAccountID = useSelector(billingAccountAddressSelector);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useSelector2 = useSelector(fulfillmentSelector),
      fulfillmentMethod = _useSelector2.fulfillmentMethod;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: "row mb-3",
      children: [/*#__PURE__*/jsx("div", {
        className: "col-sm-12",
        children: /*#__PURE__*/jsxs("div", {
          className: "form-group",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "purchaseOrderNumber",
            children: t('frontend.checkout.payment.po.number')
          }), /*#__PURE__*/jsx("input", {
            className: "form-control",
            type: "text",
            id: "purchaseOrderNumber",
            value: termOrderNumber,
            onChange: function onChange(e) {
              e.preventDefault();
              setTermOrderNumber(e.target.value);
            }
          })]
        })
      }), fulfillmentMethod.fulfillmentMethodType === 'shipping' && /*#__PURE__*/jsx("div", {
        className: "col-sm-12",
        children: /*#__PURE__*/jsx("div", {
          className: "form-group",
          children: /*#__PURE__*/jsxs("div", {
            className: "custom-control custom-checkbox",
            children: [/*#__PURE__*/jsx("input", {
              className: "custom-control-input",
              type: "checkbox",
              id: "saveShippingAsBilling",
              checked: saveShippingAsBilling,
              onChange: function onChange(e) {
                setSaveShippingAsBilling(!saveShippingAsBilling);
              }
            }), /*#__PURE__*/jsx("label", {
              className: "custom-control-label",
              htmlFor: "saveShippingAsBilling",
              children: "Same as shipping address"
            })]
          })
        })
      })]
    }), saveShippingAsBilling && termOrderNumber && termOrderNumber.length > 0 && /*#__PURE__*/jsx(Button, {
      label: "Submit",
      onClick: function onClick(e) {
        e.preventDefault();
        console.log('saveShippingAsBilling', saveShippingAsBilling); //TODO: BROKEN

        dispatch(addPayment({
          newOrderPayment: {
            saveShippingAsBilling: 1,
            purchaseOrderNumber: termOrderNumber,
            paymentMethod: {
              paymentMethodID: method
            }
          }
        }));
      }
    }), !saveShippingAsBilling && termOrderNumber && termOrderNumber.length > 0 && /*#__PURE__*/jsx(PaymentAddressSelector, {
      addressTitle: 'Billing Address',
      selectedAccountID: selectedAccountID || accountAddressID,
      onSelect: function onSelect(value) {
        dispatch(addPayment({
          accountAddressID: value,
          newOrderPayment: {
            purchaseOrderNumber: termOrderNumber,
            paymentMethod: {
              paymentMethodID: method
            }
          }
        }));
        setAccountAddressID(value);
      },
      onSave: function onSave(values) {
        if (values.saveAddress) {
          dispatch(addNewAccountAndSetAsBilling(_objectSpread2({}, values)));
        } else {
          dispatch(addPayment({
            newOrderPayment: {
              billingAddress: {
                name: values.name,
                streetAddress: values.streetAddress,
                street2Address: values.street2Address,
                city: values.city,
                statecode: values.stateCode,
                postalcode: values.postalCode,
                countrycode: values.countryCode
              },
              purchaseOrderNumber: termOrderNumber,
              paymentMethod: {
                paymentMethodID: method
              }
            }
          }));
        }
      }
    })]
  });
};

var PaymentList = function PaymentList() {
  var payments = useSelector(getAllOrderPayments);
  var disableInteraction = useSelector(disableInteractionSelector);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useDispatch();

  if (payments.length === 0) {
    return null;
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("p", {
      className: "h6",
      children: [t('frontend.checkout.payments'), ":"]
    }), /*#__PURE__*/jsx("div", {
      className: "row ",
      children: payments.map(function (payment) {
        return /*#__PURE__*/jsxs("div", {
          className: "bg-lightgray rounded mb-5 pt-2 col-md-4",
          children: [payment.paymentMethod.paymentMethodType === 'creditCard' && /*#__PURE__*/jsx(CCDetails, {
            hideHeading: true,
            creditCardPayment: payment
          }), payment.paymentMethod.paymentMethodType === 'giftCard' && /*#__PURE__*/jsx(GiftCardDetails, {}), payment.paymentMethod.paymentMethodType === 'termPayment' && /*#__PURE__*/jsx(TermPaymentDetails, {
            hideHeading: true,
            termPayment: payment
          }), /*#__PURE__*/jsx("hr", {}), /*#__PURE__*/jsxs("button", {
            className: "btn btn-link px-0 text-danger",
            type: "button",
            disabled: disableInteraction,
            onClick: function onClick(event) {
              event.preventDefault();
              dispatch(removePayment({
                orderPaymentID: payment.orderPaymentID
              }));
            },
            children: [/*#__PURE__*/jsx("i", {
              className: "fal fa-times-circle"
            }), /*#__PURE__*/jsxs("span", {
              className: "font-size-sm",
              children: [" ", t('frontend.core.remove')]
            })]
          })]
        }, payment.orderPaymentID);
      })
    })]
  });
};

var GiftCardPayment = function GiftCardPayment() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx("h1", {
      children: t('frontend.checkout.payment.giftCard.title')
    })
  });
};

var CreditCardPayment = function CreditCardPayment() {
  var paymentMethods = useSelector(accountPaymentMethods);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      newOrderPayment = _useState2[0],
      setNewOrderPayment = _useState2[1];

  var _useSelector = useSelector(orderPayment),
      _useSelector$accountP = _useSelector.accountPaymentMethod,
      accountPaymentMethod = _useSelector$accountP === void 0 ? {
    accountPaymentMethodID: ''
  } : _useSelector$accountP;

  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    if (paymentMethods.length === 0) {
      // if there is no payment method found for the user , open new payment form
      setNewOrderPayment('new');
    }
  }, [paymentMethods]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "row mb-3",
      children: /*#__PURE__*/jsxs("div", {
        className: "col-sm-12",
        children: [/*#__PURE__*/jsx(SwRadioSelect, {
          label: t('frontend.checkout.payment.select'),
          options: paymentMethods,
          onChange: function onChange(value) {
            if (value === 'new') {
              setNewOrderPayment('new');
            } else {
              setNewOrderPayment(false);
              dispatch(addPayment({
                accountPaymentMethodID: value
              }));
            }
          },
          selectedValue: newOrderPayment ? newOrderPayment : accountPaymentMethod.accountPaymentMethodID,
          displayNew: true
        }), newOrderPayment !== 'new' && /*#__PURE__*/jsx("button", {
          className: "btn btn-secondary mt-2",
          onClick: function onClick() {
            setNewOrderPayment('new');
          },
          children: t('frontend.checkout.payment.add')
        })]
      })
    }), newOrderPayment === 'new' && /*#__PURE__*/jsx(CreditCardDetails, {
      onSubmit: function onSubmit() {
        setNewOrderPayment(false);
      }
    })]
  });
};

var CREDIT_CARD$1 = '444df303dedc6dab69dd7ebcc9b8036a';
var GIFT_CARD = '50d8cd61009931554764385482347f3a';
var TERM_PAYMENT = '2c918088783591e3017836350bd21385';

var PaymentSlide = function PaymentSlide(_ref) {
  var currentStep = _ref.currentStep;
  var orderRequirementsList = useSelector(function (state) {
    return state.cart.orderRequirementsList;
  });
  var eligiblePaymentMethodDetails = useSelector(eligiblePaymentMethodDetailSelector);

  var _useSelector = useSelector(orderPayment),
      paymentMethod = _useSelector.paymentMethod;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      selectedPaymentMethod = _useState2[0],
      setSelectedPaymentMethod = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      paymentMethodOnOrder = _useState4[0],
      setPaymentMethodOnOrder = _useState4[1];

  var allPayments = useSelector(getAllOrderPayments);

  var _useSelector2 = useSelector(function (state) {
    return state.cart;
  }),
      isFetching = _useSelector2.isFetching;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (paymentMethod && paymentMethod.paymentMethodID && paymentMethodOnOrder !== paymentMethod.paymentMethodID) {
    setPaymentMethodOnOrder(paymentMethod.paymentMethodID);
    setSelectedPaymentMethod(paymentMethod.paymentMethodID);
  }

  return /*#__PURE__*/jsxs(Overlay, {
    active: isFetching,
    spinner: true,
    children: [/*#__PURE__*/jsx(PaymentList, {}), allPayments.length === 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: "row mb-3",
        children: /*#__PURE__*/jsx("div", {
          className: "col-sm-12",
          children: /*#__PURE__*/jsx(SwRadioSelect, {
            label: t('frontend.checkout.payment.select'),
            options: eligiblePaymentMethodDetails,
            onChange: function onChange(value) {
              setSelectedPaymentMethod(value);
            },
            selectedValue: selectedPaymentMethod.length > 0 ? selectedPaymentMethod : paymentMethodOnOrder
          })
        })
      }), selectedPaymentMethod === CREDIT_CARD$1 && /*#__PURE__*/jsx(CreditCardPayment, {}), selectedPaymentMethod === GIFT_CARD && /*#__PURE__*/jsx(GiftCardPayment, {}), selectedPaymentMethod === TERM_PAYMENT && /*#__PURE__*/jsx(TermPayment, {
        method: selectedPaymentMethod
      })]
    }), /*#__PURE__*/jsx(SlideNavigation, {
      currentStep: currentStep,
      nextActive: !orderRequirementsList.includes('payment')
    })]
  });
};

var CREDIT_CARD = '444df303dedc6dab69dd7ebcc9b8036a';
var months = Array.from({
  length: 12
}, function (_, i) {
  return {
    key: i + 1,
    value: i + 1
  };
});
var years = Array(10).fill(new Date().getFullYear()).map(function (year, index) {
  return {
    key: year + index,
    value: year + index
  };
});
/* see: userAction addPaymentMethod */

var addPaymentMethodAndSetAsPayment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newPaymentMethod, callback, dispatch, t) {
    var response, _response$success, accountPaymentMethod;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return SlatwallApiService.account.addPaymentMethod(_objectSpread2(_objectSpread2({}, newPaymentMethod), {}, {
              returnJSONObjects: 'account'
            }));

          case 2:
            response = _context.sent;

            if (response.isSuccess()) {
              _response$success = response.success(), accountPaymentMethod = _response$success.accountPaymentMethod;
              dispatch(addPayment({
                accountPaymentMethodID: accountPaymentMethod.accountPaymentMethodID
              }));
            } else {
              toast.error(t('frontend.core.save_failed'));
            }

            callback();

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addPaymentMethodAndSetAsPayment(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var CreditCardDetails = function CreditCardDetails(_ref2) {
  var _onSubmit = _ref2.onSubmit;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useDispatch();
  var billingAccountAddress = useSelector(function (state) {
    return state.cart.billingAccountAddress;
  });

  var _useSelector = useSelector(fulfillmentSelector),
      fulfillmentMethod = _useSelector.fulfillmentMethod;

  var formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      creditCardNumber: '',
      nameOnCreditCard: '',
      expirationMonth: new Date().getMonth() + 1,
      expirationYear: new Date().getFullYear().toString().substring(2),
      securityCode: '',
      accountPaymentMethodName: '',
      accountAddressID: billingAccountAddress ? billingAccountAddress.accountAddressID : '',
      saveShippingAsBilling: false,
      savePaymentMethodToAccount: false,
      returnJSONObjects: 'cart'
    },
    onSubmit: function onSubmit(values) {
      var payload = {
        accountPaymentMethodName: values.accountPaymentMethodName,
        paymentMethodType: 'creditCard',
        nameOnCreditCard: values.nameOnCreditCard,
        creditCardNumber: values.creditCardNumber,
        expirationMonth: values.expirationMonth,
        expirationYear: values.expirationYear,
        securityCode: values.securityCode,
        billingAccountAddress: {
          accountAddressID: values.accountAddressID
        }
      };

      if (values.saveShippingAsBilling) {
        payload.newOrderPayment['saveShippingAsBilling'] = 1;
        delete payload.newOrderPayment.accountAddressID;
      }

      addPaymentMethodAndSetAsPayment(payload, _onSubmit, dispatch, t);
    }
  });
  var validCreditCard = formik.values.accountPaymentMethodName.length > 0 && formik.values.nameOnCreditCard.length > 0 && formik.values.creditCardNumber.length > 0 && formik.values.securityCode.length > 0;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "row mb-3",
      children: /*#__PURE__*/jsxs("div", {
        className: "col-sm-12",
        children: [/*#__PURE__*/jsx("h2", {
          className: "h6 pt-1 pb-3 mb-3 border-bottom",
          children: "Credit Card Information"
        }), /*#__PURE__*/jsxs("div", {
          className: "row",
          children: [/*#__PURE__*/jsx("div", {
            className: "col-sm-6",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "accountPaymentMethodName",
                children: t('frontend.account.payment_method.nickname')
              }), /*#__PURE__*/jsx("input", {
                className: "form-control",
                type: "text",
                id: "accountPaymentMethodName",
                value: formik.values.accountPaymentMethodName,
                onChange: formik.handleChange
              }), ' ']
            })
          }), /*#__PURE__*/jsx("div", {
            className: "col-sm-6",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "nameOnCreditCard",
                children: t('frontend.account.payment_method.name')
              }), /*#__PURE__*/jsx("input", {
                className: "form-control",
                type: "text",
                id: "nameOnCreditCard",
                value: formik.values.nameOnCreditCard,
                onChange: formik.handleChange
              })]
            })
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "row",
          children: [/*#__PURE__*/jsx("div", {
            className: "col-sm-5",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "creditCardNumber",
                children: t('frontend.account.payment_method.ccn')
              }), /*#__PURE__*/jsx("input", {
                className: "form-control",
                type: "text",
                id: "creditCardNumber",
                value: formik.values.creditCardNumber,
                onChange: formik.handleChange
              })]
            })
          }), /*#__PURE__*/jsx("div", {
            className: "col-sm-2",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "securityCode",
                children: t('frontend.account.payment_method.cvv')
              }), /*#__PURE__*/jsx("input", {
                className: "form-control",
                type: "text",
                id: "securityCode",
                value: formik.values.securityCode,
                onChange: formik.handleChange
              })]
            })
          }), /*#__PURE__*/jsx("div", {
            className: "col-sm-3",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "expirationMonth",
                children: t('frontend.account.payment_method.expiration_month')
              }), /*#__PURE__*/jsx(SwSelect, {
                id: "expirationMonth",
                value: formik.values.expirationMonth,
                onChange: formik.handleChange,
                options: months
              })]
            })
          }), /*#__PURE__*/jsx("div", {
            className: "col-sm-2",
            children: /*#__PURE__*/jsxs("div", {
              className: "form-group",
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: "expirationYear",
                children: t('frontend.account.payment_method.expiration_year')
              }), /*#__PURE__*/jsx(SwSelect, {
                id: "expirationYear",
                value: formik.values.expirationYear,
                onChange: formik.handleChange,
                options: years
              })]
            })
          })]
        }), /*#__PURE__*/jsx("div", {
          className: "row mb-3",
          children: /*#__PURE__*/jsx("div", {
            className: "col-sm-12",
            children: /*#__PURE__*/jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/jsxs("div", {
                className: "col-sm-6",
                children: [fulfillmentMethod.fulfillmentMethodType === 'shipping' && /*#__PURE__*/jsxs("div", {
                  className: "custom-control custom-checkbox",
                  children: [/*#__PURE__*/jsx("input", {
                    className: "custom-control-input",
                    type: "checkbox",
                    id: "saveShippingAsBilling",
                    checked: formik.values.saveShippingAsBilling,
                    onChange: formik.handleChange
                  }), /*#__PURE__*/jsx("label", {
                    className: "custom-control-label",
                    htmlFor: "saveShippingAsBilling",
                    children: t('frontend.checkout.shipping_address_clone')
                  })]
                }), /*#__PURE__*/jsxs("div", {
                  className: "custom-control custom-checkbox",
                  children: [/*#__PURE__*/jsx("input", {
                    className: "custom-control-input",
                    type: "checkbox",
                    id: "savePaymentMethodToAccount",
                    checked: formik.values.savePaymentMethodToAccount,
                    onChange: formik.handleChange
                  }), /*#__PURE__*/jsx("label", {
                    className: "custom-control-label",
                    htmlFor: "savePaymentMethodToAccount",
                    children: t('frontend.checkout.payment.save_to_account')
                  })]
                })]
              }), /*#__PURE__*/jsx("div", {
                className: "col-sm-6",
                children: formik.values.saveShippingAsBilling && validCreditCard && /*#__PURE__*/jsx(Button, {
                  label: "Submit",
                  onClick: function onClick(e) {
                    e.preventDefault(); //TODO: BROKEN

                    if (formik.values.savePaymentMethodToAccount && formik.values.saveShippingAsBilling) {
                      // Create account Payment and use cloned shpiing address
                      // Payment with Account  CC
                      dispatch(addPayment({
                        newOrderPayment: {
                          saveShippingAsBilling: 1,
                          nameOnCreditCard: formik.values.nameOnCreditCard,
                          creditCardNumber: formik.values.creditCardNumber,
                          expirationMonth: formik.values.expirationMonth,
                          expirationYear: formik.values.expirationYear,
                          securityCode: formik.values.securityCode,
                          paymentMethod: {
                            paymentMethodID: CREDIT_CARD
                          }
                        },
                        saveAccountPaymentMethodFlag: formik.values.savePaymentMethodToAccount
                      }));
                    } else {
                      // Payment with Single use CC and address cloned from billing
                      dispatch(addPayment({
                        newOrderPayment: {
                          saveShippingAsBilling: 1,
                          nameOnCreditCard: formik.values.nameOnCreditCard,
                          creditCardNumber: formik.values.creditCardNumber,
                          expirationMonth: formik.values.expirationMonth,
                          expirationYear: formik.values.expirationYear,
                          securityCode: formik.values.securityCode,
                          paymentMethod: {
                            paymentMethodID: CREDIT_CARD
                          }
                        }
                      }));
                    }
                  }
                })
              })]
            })
          })
        })]
      })
    }), validCreditCard && !formik.values.saveShippingAsBilling && /*#__PURE__*/jsx("div", {
      className: "row mb-3",
      children: /*#__PURE__*/jsx("div", {
        className: "col-sm-12",
        children: !formik.values.saveShippingAsBilling && /*#__PURE__*/jsx(PaymentAddressSelector, {
          isShipping: false,
          addressTitle: 'Billing Address',
          selectedAccountID: formik.values.accountAddressID,
          onSelect: function onSelect(value) {
            dispatch(addPayment({
              newOrderPayment: {
                accountAddressID: value,
                nameOnCreditCard: formik.values.nameOnCreditCard,
                creditCardNumber: formik.values.creditCardNumber,
                expirationMonth: formik.values.expirationMonth,
                expirationYear: formik.values.expirationYear,
                securityCode: formik.values.securityCode,
                paymentMethod: {
                  paymentMethodID: CREDIT_CARD
                }
              },
              accountAddressID: value,
              saveAccountPaymentMethodFlag: formik.values.savePaymentMethodToAccount
            }));
          },
          onSave: function onSave(values) {
            if (formik.values.savePaymentMethodToAccount && values.saveAddress) ; else if (values.saveAddress) {
              // Create account address
              // Payment with new Account Address and Single use CC
              var payload = {
                name: values.name,
                streetAddress: values.streetAddress,
                street2Address: values.street2Address,
                city: values.city,
                statecode: values.stateCode,
                postalcode: values.postalCode,
                countrycode: values.countryCode,
                returnJSONObjects: 'account'
              };
              SlatwallApiService.cart.addEditAccountAndSetAsBillingAddress(payload).then(function (response) {
                var _response$success2;

                if (response.isSuccess() && Object.keys(((_response$success2 = response.success()) === null || _response$success2 === void 0 ? void 0 : _response$success2.errors) || {}).length) toast.error(getErrorMessage(response.success().errors));

                if (response.isSuccess()) {
                  dispatch(addPayment({
                    newOrderPayment: {
                      nameOnCreditCard: formik.values.nameOnCreditCard,
                      creditCardNumber: formik.values.creditCardNumber,
                      expirationMonth: formik.values.expirationMonth,
                      expirationYear: formik.values.expirationYear,
                      securityCode: formik.values.securityCode,
                      paymentMethod: {
                        paymentMethodID: CREDIT_CARD
                      }
                    }
                  }));
                }
              });
            } else {
              // and payment with new single use CC and Single use address
              dispatch(addPayment({
                newOrderPayment: {
                  billingAddress: {
                    name: values.name,
                    streetAddress: values.streetAddress,
                    street2Address: values.street2Address,
                    city: values.city,
                    statecode: values.stateCode,
                    postalcode: values.postalCode,
                    countrycode: values.countryCode
                  },
                  nameOnCreditCard: formik.values.nameOnCreditCard,
                  creditCardNumber: formik.values.creditCardNumber,
                  expirationMonth: formik.values.expirationMonth,
                  expirationYear: formik.values.expirationYear,
                  securityCode: formik.values.securityCode,
                  paymentMethod: {
                    paymentMethodID: CREDIT_CARD
                  }
                }
              }));
            }
          }
        })
      })
    })]
  });
};

var initialValues$1 = {
  name: '',
  company: '',
  streetAddress: '',
  street2Address: '',
  city: '',
  stateCode: '',
  emailAddress: '',
  postalCode: '',
  countryCode: 'US',
  accountAddressName: '',
  saveAddress: false,
  blindShip: false
};

var BillingAddress$1 = function BillingAddress(_ref) {
  var onSave = _ref.onSave;
  var dispatch = useDispatch();
  var isFetching = useSelector(function (state) {
    return state.content.isFetching;
  });
  var countryCodeOptions = useSelector(function (state) {
    return state.content.countryCodeOptions;
  });
  var stateCodeOptions = useSelector(function (state) {
    return state.content.stateCodeOptions;
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setEdit = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var formik = useFormik({
    enableReinitialize: false,
    initialValues: initialValues$1,
    onSubmit: function onSubmit(values) {
      setEdit(!isEdit);
      onSave(values);
    }
  });
  useEffect(function () {
    if (countryCodeOptions.length === 0 && !isFetching) {
      dispatch(getCountries());
    }

    if (!stateCodeOptions[formik.values.countryCode] && !isFetching) {
      dispatch(getStateCodeOptionsByCountryCode(formik.values.countryCode));
    }
  }, [dispatch, formik, stateCodeOptions, countryCodeOptions, isFetching]);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs("form", {
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "checkout-country",
              children: t('frontend.account.countryCode')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "countryCode",
              disabled: !isEdit,
              value: formik.values.countryCode,
              onChange: function onChange(e) {
                e.preventDefault();
                dispatch(getStateCodeOptionsByCountryCode(e.target.value));
                formik.handleChange(e);
              },
              options: countryCodeOptions
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "name",
              children: t('frontend.account.name')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "name",
              value: formik.values.name,
              onChange: formik.handleChange
            })]
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "emailAddress",
              children: t('frontend.account.emailAddress')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "emailAddress",
              value: formik.values.emailAddress,
              onChange: formik.handleChange
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsx("div", {
            className: "form-group"
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "streetAddress",
              children: t('frontend.account.streetAddress')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "streetAddress",
              value: formik.values.streetAddress,
              onChange: formik.handleChange
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "street2Address",
              children: t('frontend.account.street2Address')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "street2Address",
              value: formik.values.street2Address,
              onChange: formik.handleChange
            })]
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "city",
              children: t('frontend.account.city')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "city",
              value: formik.values.city,
              onChange: formik.handleChange
            })]
          })
        }), stateCodeOptions[formik.values.countryCode] && stateCodeOptions[formik.values.countryCode].length > 0 && /*#__PURE__*/jsx("div", {
          className: "col-sm-3",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "stateCode",
              children: t('frontend.account.stateCode')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "stateCode",
              disabled: !isEdit,
              value: formik.values.stateCode,
              onChange: function onChange(e) {
                e.preventDefault();
                formik.handleChange(e);
              },
              options: stateCodeOptions[formik.values.countryCode]
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-2",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "postalCode",
              children: t('frontend.account.postalCode')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "postalCode",
              value: formik.values.postalCode,
              onChange: formik.handleChange
            })]
          })
        })]
      }), /*#__PURE__*/jsx("div", {
        className: "row",
        children: /*#__PURE__*/jsx("div", {
          className: "col-sm-12",
          children: /*#__PURE__*/jsx("div", {
            className: "form-group",
            children: /*#__PURE__*/jsxs("div", {
              className: "custom-control custom-checkbox",
              children: [/*#__PURE__*/jsx("input", {
                className: "custom-control-input",
                type: "checkbox",
                id: "saveAddress",
                checked: formik.values.saveAddress,
                onChange: formik.handleChange
              }), /*#__PURE__*/jsx("label", {
                className: "custom-control-label",
                htmlFor: "saveAddress",
                children: t('frontend.account.save_to')
              })]
            })
          })
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "d-lg-flex pt-4 mt-3",
        children: [/*#__PURE__*/jsx("div", {
          className: "w-50 pr-3"
        }), /*#__PURE__*/jsx("div", {
          className: "w-50 pl-2",
          children: /*#__PURE__*/jsx("button", {
            className: "btn btn-outline-primary btn-block",
            onClick: formik.handleSubmit,
            children: /*#__PURE__*/jsx("span", {
              className: "d-none d-sm-inline",
              children: t('frontend.core.save')
            })
          })
        })]
      })]
    })
  });
};

var PaymentAddressSelector = function PaymentAddressSelector(_ref2) {
  var onSelect = _ref2.onSelect,
      _onSave = _ref2.onSave,
      selectedAccountID = _ref2.selectedAccountID,
      _ref2$addressTitle = _ref2.addressTitle,
      addressTitle = _ref2$addressTitle === void 0 ? 'frontend.account.addresses' : _ref2$addressTitle,
      _ref2$isShipping = _ref2.isShipping,
      isShipping = _ref2$isShipping === void 0 ? true : _ref2$isShipping;
  var accountAddresses = useSelector(function (state) {
    return state.userReducer.accountAddresses;
  });

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAddress = _useState4[0],
      setShowAddress = _useState4[1];

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  if (showAddress || accountAddresses.length === 0) {
    selectedAccountID = 'new';
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h2", {
      className: "h6 pt-1 pb-3 mb-3 border-bottom",
      children: t(addressTitle)
    }), accountAddresses && /*#__PURE__*/jsx("div", {
      className: "row",
      children: /*#__PURE__*/jsxs("div", {
        className: "col-sm-12",
        children: [/*#__PURE__*/jsx(SwRadioSelect, {
          options: accountAddresses.map(function (_ref3) {
            var accountAddressName = _ref3.accountAddressName,
                accountAddressID = _ref3.accountAddressID,
                streetAddress = _ref3.address.streetAddress;
            return {
              name: "".concat(accountAddressName, " - ").concat(streetAddress),
              value: accountAddressID
            };
          }),
          onChange: function onChange(value) {
            setShowAddress(false);
            onSelect(value);
          },
          customLabel: t('frontend.checkout.receive_option'),
          selectedValue: selectedAccountID,
          displayNew: true
        }), /*#__PURE__*/jsx("button", {
          className: "btn btn-secondary mt-2",
          onClick: function onClick() {
            return setShowAddress(true);
          },
          children: "New Address"
        })]
      })
    }), showAddress && /*#__PURE__*/jsx(BillingAddress$1, {
      isShipping: isShipping,
      setShowAddress: showAddress,
      onSave: function onSave(values) {
        setShowAddress(false);

        _onSave(values);
      }
    })]
  });
};

var PickupLocationPicker = function PickupLocationPicker() {
  var dispatch = useDispatch();
  var pickupLocations = useSelector(pickupLocationOptions);
  var pickupLocation = useSelector(pickupLocationSelector);

  var _useSelector = useSelector(fulfillmentSelector),
      orderFulfillmentID = _useSelector.orderFulfillmentID,
      estimatedShippingDate = _useSelector.estimatedShippingDate;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isFutureDate = function isFutureDate(date) {
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return date >= currentDate;
  };

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "row mb-3",
      children: /*#__PURE__*/jsx("div", {
        className: "col-sm-12",
        children: /*#__PURE__*/jsxs("div", {
          className: "form-group",
          children: [/*#__PURE__*/jsx("label", {
            htmlFor: "locationPickupDate",
            children: t('frontend.checkout.fulfilment.pickup.date')
          }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx(DatePicker, {
            id: "locationPickupDate",
            selected: estimatedShippingDate ? new Date(estimatedShippingDate) : '',
            showTimeSelect: true,
            timeIntervals: 60,
            timeCaption: "Time",
            dateFormat: "MM/dd/yyyy h:mm aa",
            filterDate: isFutureDate,
            className: "form-control",
            onChange: function onChange(pickupDate) {
              dispatch(setPickupDate({
                pickupDate: pickupDate.toISOString(),
                orderFulfillmentID: orderFulfillmentID
              }));
            }
          })]
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: "row mb-3",
      children: /*#__PURE__*/jsx("div", {
        className: "col-sm-12",
        children: pickupLocations.length > 0 && /*#__PURE__*/jsx(SwRadioSelect, {
          label: t('frontend.checkout.location_option'),
          options: pickupLocations,
          onChange: function onChange(value) {
            dispatch(addPickupLocation({
              value: value
            }));
          },
          selectedValue: pickupLocation.locationID
        })
      })
    })]
  });
};

var ShippingMethodPicker = function ShippingMethodPicker() {
  var dispatch = useDispatch();
  var orderFulfillments = useSelector(function (state) {
    return state.cart.orderFulfillments;
  });
  var selectedShippingMethod = useSelector(shippingMethodSelector);
  var orderFulfillment = useSelector(fulfillmentSelector);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsx("div", {
    className: "row mb-3",
    children: /*#__PURE__*/jsxs("div", {
      className: "col-sm-12",
      children: [orderFulfillments.length > 0 && /*#__PURE__*/jsx(SwRadioSelect, {
        label: t('frontend.checkout.delivery_option'),
        options: orderFulfillment.shippingMethodOptions,
        onChange: function onChange(value) {
          dispatch(addShippingMethod({
            shippingMethodID: value,
            fulfillmentID: orderFulfillment.orderFulfillmentID
          }));
        },
        selectedValue: selectedShippingMethod.shippingMethodID
      }), orderFulfillment.shippingMethodOptions.length === 0 && /*#__PURE__*/jsx("div", {
        className: "alert alert-info",
        role: "alert",
        children: t('frontend.checkout.fulfilment.shipping.no_eligible_options')
      })]
    })
  });
};

var FulfillmentPicker = function FulfillmentPicker() {
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state.cart;
  }),
      eligibleFulfillmentMethods = _useSelector.eligibleFulfillmentMethods,
      orderItems = _useSelector.orderItems;

  var selectedFulfillmentMethod = useSelector(fulfillmentMethodSelector);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsx("div", {
    className: "row mb-3",
    children: /*#__PURE__*/jsx("div", {
      className: "col-sm-12",
      children: eligibleFulfillmentMethods && eligibleFulfillmentMethods.length > 0 && /*#__PURE__*/jsx(SwRadioSelect, {
        label: t('frontend.checkout.receive_option'),
        options: eligibleFulfillmentMethods,
        onChange: function onChange(fulfillmentMethodID) {
          var orderItemIDList = orderItems.map(function (orderItem) {
            return orderItem.orderItemID;
          }).join();
          dispatch(changeOrderFulfillment({
            fulfillmentMethodID: fulfillmentMethodID,
            orderItemIDList: orderItemIDList
          }));
        },
        selectedValue: selectedFulfillmentMethod.fulfillmentMethodID
      })
    })
  });
};

var initialValues = {
  name: '',
  company: '',
  streetAddress: '',
  street2Address: '',
  city: '',
  stateCode: '',
  emailAddress: '',
  postalCode: '',
  countryCode: 'US',
  accountAddressName: '',
  saveAddress: false,
  blindShip: false
};

var BillingAddress = function BillingAddress(_ref) {
  var onSave = _ref.onSave;
  var dispatch = useDispatch();
  var isFetching = useSelector(function (state) {
    return state.content.isFetching;
  });
  var countryCodeOptions = useSelector(function (state) {
    return state.content.countryCodeOptions;
  });
  var stateCodeOptions = useSelector(function (state) {
    return state.content.stateCodeOptions;
  });

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setEdit = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var formik = useFormik({
    enableReinitialize: false,
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Required'),
      streetAddress: Yup.string().required('Required'),
      city: Yup.string().required('Required'),
      postalCode: Yup.string().required('Required'),
      stateCode: Yup.string().required('Required')
    }),
    onSubmit: function onSubmit(values) {
      setEdit(!isEdit);
      onSave(values);
    }
  });
  useEffect(function () {
    if (countryCodeOptions.length === 0 && !isFetching) {
      dispatch(getCountries());
    }

    if (!stateCodeOptions[formik.values.countryCode] && !isFetching) {
      dispatch(getStateCodeOptionsByCountryCode(formik.values.countryCode));
    }
  }, [dispatch, formik, stateCodeOptions, countryCodeOptions, isFetching]);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsxs("form", {
      onSubmit: formik.handleSubmit,
      children: [/*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "checkout-country",
              children: t('frontend.account.countryCode')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "countryCode",
              disabled: !isEdit,
              value: formik.values.countryCode,
              onChange: function onChange(e) {
                e.preventDefault();
                dispatch(getStateCodeOptionsByCountryCode(e.target.value));
                formik.handleChange(e);
              },
              options: countryCodeOptions
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "name",
              children: t('frontend.account.name')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "name",
              value: formik.values.name,
              onChange: formik.handleChange
            }), formik.errors.name && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.name
            })]
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "emailAddress",
              children: t('frontend.account.emailAddress')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "emailAddress",
              value: formik.values.emailAddress,
              onChange: formik.handleChange
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsx("div", {
            className: "form-group"
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "streetAddress",
              children: t('frontend.account.streetAddress')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "streetAddress",
              value: formik.values.streetAddress,
              onChange: formik.handleChange
            }), formik.errors.streetAddress && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.streetAddress
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "street2Address",
              children: t('frontend.account.street2Address')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "street2Address",
              value: formik.values.street2Address,
              onChange: formik.handleChange
            })]
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-sm-6",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "city",
              children: t('frontend.account.city')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "city",
              value: formik.values.city,
              onChange: formik.handleChange
            }), formik.errors.city && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.city
            })]
          })
        }), stateCodeOptions[formik.values.countryCode] && stateCodeOptions[formik.values.countryCode].length > 0 && /*#__PURE__*/jsx("div", {
          className: "col-sm-3",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "stateCode",
              children: t('frontend.account.stateCode')
            }), /*#__PURE__*/jsx(SwSelect, {
              id: "stateCode",
              disabled: !isEdit,
              value: formik.values.stateCode,
              onChange: function onChange(e) {
                e.preventDefault();
                formik.handleChange(e);
              },
              options: stateCodeOptions[formik.values.countryCode]
            }), formik.errors.stateCode && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.stateCode
            })]
          })
        }), /*#__PURE__*/jsx("div", {
          className: "col-sm-2",
          children: /*#__PURE__*/jsxs("div", {
            className: "form-group",
            children: [/*#__PURE__*/jsx("label", {
              htmlFor: "postalCode",
              children: t('frontend.account.postalCode')
            }), /*#__PURE__*/jsx("input", {
              disabled: !isEdit,
              className: "form-control",
              type: "text",
              id: "postalCode",
              value: formik.values.postalCode,
              onChange: formik.handleChange
            }), formik.errors.postalCode && /*#__PURE__*/jsx("span", {
              className: "form-error-msg",
              children: formik.errors.postalCode
            })]
          })
        })]
      }), /*#__PURE__*/jsx("div", {
        className: "row",
        children: /*#__PURE__*/jsx("div", {
          className: "col-sm-12",
          children: /*#__PURE__*/jsx("div", {
            className: "form-group",
            children: /*#__PURE__*/jsxs("div", {
              className: "custom-control custom-checkbox",
              children: [/*#__PURE__*/jsx("input", {
                className: "custom-control-input",
                type: "checkbox",
                id: "saveAddress",
                checked: formik.values.saveAddress,
                onChange: formik.handleChange
              }), /*#__PURE__*/jsx("label", {
                className: "custom-control-label",
                htmlFor: "saveAddress",
                children: t('frontend.account.save_to')
              })]
            })
          })
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "d-lg-flex pt-4 mt-3",
        children: [/*#__PURE__*/jsx("div", {
          className: "w-50 pr-3"
        }), /*#__PURE__*/jsx("div", {
          className: "w-50 pl-2",
          children: /*#__PURE__*/jsx("button", {
            type: "submit",
            className: "btn btn-outline-primary btn-block",
            children: /*#__PURE__*/jsx("span", {
              className: "d-none d-sm-inline",
              children: t('frontend.core.save')
            })
          })
        })]
      })]
    })
  });
};

var FulfilmentAddressSelector = function FulfilmentAddressSelector(_ref2) {
  var onSelect = _ref2.onSelect,
      _onSave = _ref2.onSave,
      selectedAccountID = _ref2.selectedAccountID,
      _ref2$addressTitle = _ref2.addressTitle,
      addressTitle = _ref2$addressTitle === void 0 ? 'frontend.account.addresses' : _ref2$addressTitle,
      _ref2$isShipping = _ref2.isShipping,
      isShipping = _ref2$isShipping === void 0 ? true : _ref2$isShipping;
  var accountAddresses = useSelector(function (state) {
    return state.userReducer.accountAddresses;
  });
  var fulfillments = useSelector(function (state) {
    return state.cart.orderFulfillments;
  });

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAddress = _useState4[0],
      setShowAddress = _useState4[1];

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var dispatch = useDispatch();

  if (showAddress || accountAddresses.length === 0) {
    selectedAccountID = 'new';
  }

  var hasShippingAddress = fulfillments.length > 0 && fulfillments[0].shippingAddress.addressID.length > 0;
  var showNewAddress = showAddress || selectedAccountID === 'new';
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h2", {
      className: "h6 pt-1 pb-3 mb-3 border-bottom",
      children: t(addressTitle)
    }), hasShippingAddress && /*#__PURE__*/jsx("div", {
      className: "row ",
      children: fulfillments.map(function (_ref3) {
        var shippingAddress = _ref3.shippingAddress,
            orderFulfillmentID = _ref3.orderFulfillmentID;
        return /*#__PURE__*/jsxs("div", {
          className: "bg-lightgray rounded mb-5 pt-2 col-md-4",
          children: [/*#__PURE__*/jsxs("p", {
            children: [/*#__PURE__*/jsx("em", {
              children: shippingAddress.name
            }), /*#__PURE__*/jsx("br", {}), shippingAddress.streetAddress, " ", /*#__PURE__*/jsx("br", {}), "".concat(shippingAddress.city, ", ").concat(shippingAddress.stateCode, " ").concat(shippingAddress.postalCode), " ", /*#__PURE__*/jsx("br", {})]
          }), /*#__PURE__*/jsx("hr", {}), /*#__PURE__*/jsxs("button", {
            className: "btn btn-link px-0 text-danger",
            type: "button",
            disabled: false,
            onClick: function onClick(event) {
              event.preventDefault();
              dispatch(clearOrderFulfillment(orderFulfillmentID));
            },
            children: [/*#__PURE__*/jsx("i", {
              className: "fal fa-times-circle"
            }), /*#__PURE__*/jsx("span", {
              className: "font-size-sm",
              children: " Remove"
            })]
          })]
        }, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.addressID);
      })
    }), !hasShippingAddress && accountAddresses && /*#__PURE__*/jsx("div", {
      className: "row mb-4",
      children: /*#__PURE__*/jsxs("div", {
        className: "col-sm-12",
        children: [/*#__PURE__*/jsx(SwRadioSelect, {
          options: accountAddresses.map(function (_ref4) {
            var accountAddressName = _ref4.accountAddressName,
                accountAddressID = _ref4.accountAddressID,
                address = _ref4.address;
            var addressString = " ".concat(address.streetAddress, ", ").concat(address.city, ", ").concat(address.stateCode, " ").concat(address.postalCode);
            var name = accountAddressName ? "".concat(accountAddressName, " - ").concat(addressString, " ") : addressString;
            return {
              name: name,
              value: accountAddressID
            };
          }),
          onChange: function onChange(value) {
            setShowAddress(false);
            onSelect(value);
          },
          customLabel: t('frontend.checkout.receive_option'),
          selectedValue: selectedAccountID,
          displayNew: true
        }), !showNewAddress && /*#__PURE__*/jsx("button", {
          className: "btn btn-secondary mt-2",
          onClick: function onClick() {
            return setShowAddress(true);
          },
          children: t('frontend.account.address.add')
        })]
      })
    }), showNewAddress && !hasShippingAddress && /*#__PURE__*/jsx(BillingAddress, {
      isShipping: isShipping,
      setShowAddress: showAddress,
      onSave: function onSave(values) {
        setShowAddress(false);

        _onSave(values);
      }
    })]
  });
};

var ShippingSlide = function ShippingSlide(_ref) {
  var currentStep = _ref.currentStep;
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state.cart;
  }),
      orderRequirementsList = _useSelector.orderRequirementsList;

  var selectedFulfillmentMethod = useSelector(fulfillmentSelector);
  var selectedAccountID = useSelector(accountAddressSelector);
  var orderFulfillment = useSelector(fulfillmentSelector);

  var _useSelector2 = useSelector(function (state) {
    return state.cart;
  }),
      isFetching = _useSelector2.isFetching;

  useEffect(function () {
    dispatch(getEligibleFulfillmentMethods());
    dispatch(getPickupLocations());
  }, [dispatch]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Overlay, {
      active: isFetching,
      spinner: true,
      children: [/*#__PURE__*/jsx(FulfillmentPicker, {}), selectedFulfillmentMethod.fulfillmentMethod.fulfillmentMethodType === 'pickup' && /*#__PURE__*/jsx(PickupLocationPicker, {}), selectedFulfillmentMethod.fulfillmentMethod.fulfillmentMethodType === 'shipping' && /*#__PURE__*/jsx(FulfilmentAddressSelector, {
        selectedAccountID: selectedAccountID,
        onSelect: function onSelect(value) {
          dispatch(addShippingAddressUsingAccountAddress({
            accountAddressID: value,
            fulfillmentID: orderFulfillment.orderFulfillmentID
          }));
        },
        onSave: function onSave(values) {
          if (values.saveAddress) {
            dispatch(addNewAddressAndAttachAsShipping(_objectSpread2({}, values)));
          } else {
            dispatch(addShippingAddress(_objectSpread2(_objectSpread2({}, values), {}, {
              fulfillmentID: orderFulfillment.orderFulfillmentID,
              returnJSONObjects: 'cart'
            })));
          }
        }
      }), selectedFulfillmentMethod.fulfillmentMethod.fulfillmentMethodType === 'shipping' && orderFulfillment.shippingAddress.addressID.length > 0 && /*#__PURE__*/jsx(ShippingMethodPicker, {})]
    }), /*#__PURE__*/jsx(SlideNavigation, {
      currentStep: currentStep,
      nextActive: !orderRequirementsList.includes('fulfillment')
    })]
  });
};

var ListingGridLoader$1 = function ListingGridLoader(props) {
  return /*#__PURE__*/jsxs(ContentLoader, _objectSpread2(_objectSpread2({
    viewBox: "0 0 1200 500",
    height: 400,
    width: 1000
  }, props), {}, {
    children: [/*#__PURE__*/jsx("rect", {
      x: "100",
      y: "20",
      rx: "8",
      ry: "8",
      width: "300",
      height: "300"
    }), /*#__PURE__*/jsx("rect", {
      x: "100",
      y: "350",
      rx: "0",
      ry: "0",
      width: "300",
      height: "32"
    }), /*#__PURE__*/jsx("rect", {
      x: "100",
      y: "400",
      rx: "0",
      ry: "0",
      width: "180",
      height: "36"
    }), /*#__PURE__*/jsx("rect", {
      x: "500",
      y: "20",
      rx: "8",
      ry: "8",
      width: "300",
      height: "300"
    }), /*#__PURE__*/jsx("rect", {
      x: "500",
      y: "350",
      rx: "0",
      ry: "0",
      width: "300",
      height: "36"
    }), /*#__PURE__*/jsx("rect", {
      x: "500",
      y: "400",
      rx: "0",
      ry: "0",
      width: "180",
      height: "30"
    }), /*#__PURE__*/jsx("rect", {
      x: "900",
      y: "20",
      rx: "8",
      ry: "8",
      width: "300",
      height: "300"
    }), /*#__PURE__*/jsx("rect", {
      x: "900",
      y: "350",
      rx: "0",
      ry: "0",
      width: "300",
      height: "32"
    }), /*#__PURE__*/jsx("rect", {
      x: "900",
      y: "400",
      rx: "0",
      ry: "0",
      width: "180",
      height: "36"
    })]
  }));
};

var Grid = function Grid(_ref) {
  var isFetching = _ref.isFetching,
      _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products;
  return /*#__PURE__*/jsxs("div", {
    className: "row mx-n2",
    children: [isFetching && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ListingGridLoader$1, {}), " ", /*#__PURE__*/jsx(ListingGridLoader$1, {}), " ", /*#__PURE__*/jsx(ListingGridLoader$1, {})]
    }), !isFetching && products.map(function (product, index) {
      return /*#__PURE__*/jsx("div", {
        className: "col-md-4 col-sm-6 mb-3 p-0",
        children: /*#__PURE__*/jsx(ProductCard, _objectSpread2({}, product))
      }, "".concat(product.productID).concat(index));
    })]
  });
};

var Listing = function Listing(_ref) {
  var preFilter = _ref.preFilter,
      _ref$hide = _ref.hide,
      hide = _ref$hide === void 0 ? [] : _ref$hide;

  var _useListing = useListing(preFilter),
      records = _useListing.records,
      isFetching = _useListing.isFetching,
      potentialFilters = _useListing.potentialFilters,
      total = _useListing.total,
      totalPages = _useListing.totalPages,
      setSort = _useListing.setSort,
      updateAttribute = _useListing.updateAttribute,
      setPage = _useListing.setPage,
      setKeyword = _useListing.setKeyword,
      params = _useListing.params;

  var products = records.map(function (sku) {
    return _objectSpread2(_objectSpread2({}, sku), {}, {
      salePrice: sku.skuPrice,
      productName: sku.product_productName,
      urlTitle: sku.product_urlTitle,
      productCode: sku.product_productCode,
      imageFile: sku.sku_imageFile,
      skuID: sku.sku_skuID,
      skuCode: sku.sku_skuCode
    });
  });
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx("div", {
      className: "container pb-5 mb-2 mb-md-4",
      children: /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("aside", {
          className: "col-lg-4",
          children: /*#__PURE__*/jsx(ListingSidebar, {
            isFetching: isFetching,
            hide: hide,
            filtering: potentialFilters,
            recordsCount: total,
            keyword: params['keyword'],
            setKeyword: setKeyword,
            updateAttribute: updateAttribute
          })
        }), /*#__PURE__*/jsxs("div", {
          className: "col-lg-8",
          children: [/*#__PURE__*/jsx(ListingToolBar, _objectSpread2(_objectSpread2({
            hide: hide
          }, potentialFilters), {}, {
            orderBy: params['orderBy'],
            removeFilter: updateAttribute,
            setSort: setSort
          })), /*#__PURE__*/jsx(ListingGrid, {
            isFetching: isFetching,
            pageRecords: products
          }), /*#__PURE__*/jsx(ListingPagination, {
            recordsCount: total,
            currentPage: params['currentPage'],
            totalPages: totalPages,
            setPage: setPage
          })]
        })]
      })
    })
  });
};

var ListingGridLoader = function ListingGridLoader(props) {
  return /*#__PURE__*/jsxs(ContentLoader, _objectSpread2(_objectSpread2({
    viewBox: "0 0 1200 500",
    height: 400,
    width: 1000
  }, props), {}, {
    children: [/*#__PURE__*/jsx("rect", {
      x: "100",
      y: "20",
      rx: "8",
      ry: "8",
      width: "300",
      height: "300"
    }), /*#__PURE__*/jsx("rect", {
      x: "100",
      y: "350",
      rx: "0",
      ry: "0",
      width: "300",
      height: "32"
    }), /*#__PURE__*/jsx("rect", {
      x: "100",
      y: "400",
      rx: "0",
      ry: "0",
      width: "180",
      height: "36"
    }), /*#__PURE__*/jsx("rect", {
      x: "500",
      y: "20",
      rx: "8",
      ry: "8",
      width: "300",
      height: "300"
    }), /*#__PURE__*/jsx("rect", {
      x: "500",
      y: "350",
      rx: "0",
      ry: "0",
      width: "300",
      height: "36"
    }), /*#__PURE__*/jsx("rect", {
      x: "500",
      y: "400",
      rx: "0",
      ry: "0",
      width: "180",
      height: "30"
    }), /*#__PURE__*/jsx("rect", {
      x: "900",
      y: "20",
      rx: "8",
      ry: "8",
      width: "300",
      height: "300"
    }), /*#__PURE__*/jsx("rect", {
      x: "900",
      y: "350",
      rx: "0",
      ry: "0",
      width: "300",
      height: "32"
    }), /*#__PURE__*/jsx("rect", {
      x: "900",
      y: "400",
      rx: "0",
      ry: "0",
      width: "180",
      height: "36"
    })]
  }));
};

var ListingGrid = function ListingGrid(_ref) {
  var isFetching = _ref.isFetching,
      pageRecords = _ref.pageRecords;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs("div", {
    className: "row mx-n2",
    children: [isFetching && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ListingGridLoader, {}), " ", /*#__PURE__*/jsx(ListingGridLoader, {}), " ", /*#__PURE__*/jsx(ListingGridLoader, {})]
    }), !isFetching && pageRecords.length > 0 && pageRecords.map(function (product, index) {
      return /*#__PURE__*/jsx("div", {
        className: "col-md-4 col-sm-6 mb-3 p-0",
        children: /*#__PURE__*/jsx(ProductCard, _objectSpread2({}, product))
      }, "".concat(product.productName).concat(index));
    }), !isFetching && pageRecords.length === 0 && /*#__PURE__*/jsxs("div", {
      className: "col",
      children: [t('frontend.listing.noProductsFound'), /*#__PURE__*/jsx("br", {}), t('frontend.listing.needAssistance'), " ", /*#__PURE__*/jsx(Link, {
        to: "/contact",
        children: t('frontend.nav.contact')
      })]
    })]
  });
};

var LEFT_PAGE = 'LEFT';
var RIGHT_PAGE = 'RIGHT'; // Built from here: https://www.digitalocean.com/community/tutorials/how-to-build-custom-pagination-with-react

/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */

var range = function range(from, to) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = from;
  var range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

var calculatePageNumbers = function calculatePageNumbers(currentPage, pageNeighbours, totalPages) {
  /**
   * totalNumbers: the total page numbers to show on the control
   * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
   */
  var totalNumbers = pageNeighbours * 2 + 3;
  var totalBlocks = totalNumbers + 2;

  if (totalPages > totalBlocks) {
    var startPage = Math.max(2, currentPage - pageNeighbours);
    var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    var pages = range(startPage, endPage);
    /**
     * hasLeftSpill: has hidden pages to the left
     * hasRightSpill: has hidden pages to the right
     * spillOffset: number of hidden pages either to the left or to the right
     */

    var hasLeftSpill = startPage > 2;
    var hasRightSpill = totalPages - endPage > 1;
    var spillOffset = totalNumbers - (pages.length + 1);

    switch (true) {
      // handle: (1) < {5 6} [7] {8 9} (10)
      case hasLeftSpill && !hasRightSpill:
        {
          var extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE].concat(_toConsumableArray(extraPages), _toConsumableArray(pages));
          break;
        }
      // handle: (1) {2 3} [4] {5 6} > (10)

      case !hasLeftSpill && hasRightSpill:
        {
          var _extraPages = range(endPage + 1, endPage + spillOffset);

          pages = [].concat(_toConsumableArray(pages), _toConsumableArray(_extraPages), [RIGHT_PAGE]);
          break;
        }
      // handle: (1) < {4 5} [6] {7 8} > (10)

      case hasLeftSpill && hasRightSpill:
      default:
        {
          pages = [LEFT_PAGE].concat(_toConsumableArray(pages), [RIGHT_PAGE]);
          break;
        }
    }

    return [1].concat(_toConsumableArray(pages), [totalPages]);
  }

  return range(1, totalPages);
};

var ListingPagination = function ListingPagination(_ref) {
  var recordsCount = _ref.recordsCount,
      _ref$pageNeighbours = _ref.pageNeighbours,
      pageNeighbours = _ref$pageNeighbours === void 0 ? 2 : _ref$pageNeighbours,
      currentPage = _ref.currentPage,
      _ref$totalPages = _ref.totalPages,
      totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
      setPage = _ref.setPage;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  recordsCount = typeof recordsCount === 'string' || recordsCount instanceof String ? parseInt(recordsCount) : recordsCount;
  currentPage = typeof currentPage === 'string' || currentPage instanceof String ? parseInt(currentPage) : currentPage;
  totalPages = typeof totalPages === 'string' || totalPages instanceof String ? parseInt(totalPages) : totalPages;

  var gotoPage = function gotoPage(pageTo) {
    var newPage = Math.max(0, Math.min(pageTo, totalPages));
    setPage(newPage);
  };

  var pages = calculatePageNumbers(currentPage, pageNeighbours, totalPages);
  if (!recordsCount || recordsCount.length === 0 || totalPages === 1) return null;
  return /*#__PURE__*/jsx("nav", {
    className: "d-flex justify-content-between pt-2",
    "aria-label": "Page navigation",
    children: /*#__PURE__*/jsx("ul", {
      className: "mx-auto pagination",
      children: pages.map(function (page, index) {
        if (page === LEFT_PAGE) return /*#__PURE__*/jsx("li", {
          className: "page-item",
          children: /*#__PURE__*/jsxs("div", {
            className: "page-link",
            href: "",
            "aria-label": "Previous",
            onClick: function onClick(evt) {
              evt.preventDefault();
              gotoPage(currentPage - pageNeighbours * 2 - 1);
            },
            children: [/*#__PURE__*/jsx("span", {
              "aria-hidden": "true",
              children: "\xAB"
            }), /*#__PURE__*/jsx("span", {
              className: "sr-only",
              children: t('frontend.pagination.previous')
            })]
          })
        }, index);
        if (page === RIGHT_PAGE) return /*#__PURE__*/jsx("li", {
          className: "page-item",
          children: /*#__PURE__*/jsxs("div", {
            className: "page-link",
            "aria-label": "Next",
            onClick: function onClick(evt) {
              evt.preventDefault();
              gotoPage(currentPage + pageNeighbours * 2 + 1);
            },
            children: [/*#__PURE__*/jsx("span", {
              "aria-hidden": "true",
              children: "\xBB"
            }), /*#__PURE__*/jsx("span", {
              className: "sr-only",
              children: t('frontend.pagination.next')
            })]
          })
        }, index);
        return /*#__PURE__*/jsx("li", {
          className: "page-item".concat(currentPage === page ? ' active' : ''),
          children: /*#__PURE__*/jsx("div", {
            className: "page-link",
            onClick: function onClick(evt) {
              evt.preventDefault();
              var newPage = Math.max(0, Math.min(page, totalPages));
              setPage(newPage);
            },
            children: page
          })
        }, index);
      })
    })
  });
};

var ListingPaginationModern = function ListingPaginationModern(_ref) {
  var _ref$currentPage = _ref.currentPage,
      currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
      setPage = _ref.setPage,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  currentPage = parseInt(currentPage);
  return /*#__PURE__*/jsx("nav", {
    className: "d-flex justify-content-between pt-2",
    "aria-label": "Page navigation",
    children: /*#__PURE__*/jsxs("ul", {
      className: "mx-auto pagination",
      children: [currentPage > 1 && /*#__PURE__*/jsx("li", {
        className: "page-item",
        children: /*#__PURE__*/jsxs("div", {
          className: "page-link",
          href: "",
          "aria-label": "Previous",
          onClick: function onClick(evt) {
            evt.preventDefault();
            setPage(currentPage - 1);
          },
          children: [/*#__PURE__*/jsx("span", {
            "aria-hidden": "true",
            children: "\xAB"
          }), /*#__PURE__*/jsx("span", {
            className: "sr-only",
            children: t('frontend.pagination.previous')
          })]
        })
      }), /*#__PURE__*/jsx("li", {
        className: "page-item",
        children: /*#__PURE__*/jsx("span", {
          className: "",
          children: currentPage
        })
      }), count === 12 && /*#__PURE__*/jsx("li", {
        className: "page-item",
        children: /*#__PURE__*/jsxs("div", {
          className: "page-link",
          "aria-label": "Next",
          onClick: function onClick(evt) {
            evt.preventDefault();
            setPage(currentPage + 1);
          },
          children: [/*#__PURE__*/jsx("span", {
            "aria-hidden": "true",
            children: "\xBB"
          }), /*#__PURE__*/jsx("span", {
            className: "sr-only",
            children: t('frontend.pagination.next')
          })]
        })
      })]
    })
  });
};

var FacetSearch = function FacetSearch(_ref) {
  var searchTerm = _ref.searchTerm,
      search = _ref.search,
      facetKey = _ref.facetKey;
  return /*#__PURE__*/jsxs("div", {
    className: "input-group-overlay ".concat(facetKey, "-search input-group-sm mb-2"),
    children: [/*#__PURE__*/jsx("input", {
      className: "cz-filter-search form-control form-control-sm appended-form-control",
      value: searchTerm,
      onChange: function onChange(event) {
        search(event.target.value);
      },
      type: "text",
      placeholder: "Search"
    }), /*#__PURE__*/jsx("div", {
      className: "input-group-append-overlay",
      children: /*#__PURE__*/jsx("span", {
        className: "input-group-text",
        children: /*#__PURE__*/jsx("i", {
          className: "far fa-search"
        })
      })
    })]
  });
};

var FacetHeading = function FacetHeading(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return /*#__PURE__*/jsx("div", {
    className: "card-header",
    children: /*#__PURE__*/jsx("h3", {
      className: "accordion-heading",
      children: /*#__PURE__*/jsx("a", {
        className: "",
        onClick: function onClick(e) {
          e.preventDefault();
        },
        href: "#filer".concat(value),
        role: "button",
        "aria-expanded": "true",
        "aria-controls": "filer".concat(value),
        children: name
      })
    })
  });
};

var AttributeList = function AttributeList(_ref) {
  var _ref$facetKeyName = _ref.facetKeyName,
      facetKeyName = _ref$facetKeyName === void 0 ? 'name' : _ref$facetKeyName,
      facet = _ref.facet,
      filterName = _ref.filterName,
      facetKey = _ref.facetKey,
      updateAttribute = _ref.updateAttribute,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected;
  var token = filterName.replace(/\s/g, '') + facet.name.replace(/\s/g, '') + 'input';
  return /*#__PURE__*/jsx("li", {
    className: "widget-list-item cz-filter-item",
    children: /*#__PURE__*/jsxs("div", {
      className: "widget-list-link d-flex justify-content-between align-items-center",
      children: [/*#__PURE__*/jsx("span", {
        className: "cz-filter-item-text",
        children: /*#__PURE__*/jsxs("div", {
          className: "custom-control custom-checkbox",
          children: [/*#__PURE__*/jsx("input", {
            className: "custom-control-input",
            type: "checkbox",
            checked: isSelected,
            onChange: function onChange() {
              var hashKey = !isSelected ? token : null;
              updateAttribute({
                name: facet[facetKeyName],
                filterName: facetKey
              }, hashKey);
            },
            id: token
          }), /*#__PURE__*/jsx("label", {
            className: "custom-control-label",
            htmlFor: token,
            children: facet.displayName
          })]
        })
      }), facet.count && /*#__PURE__*/jsx("span", {
        className: "font-size-xs text-muted ml-3",
        children: facet.count
      })]
    })
  });
};

var FacetFilter = function FacetFilter(_ref2) {
  var filter = _ref2.filter,
      updateAttribute = _ref2.updateAttribute,
      _ref2$facetIdentifier = _ref2.facetIdentifier,
      facetIdentifier = _ref2$facetIdentifier === void 0 ? '' : _ref2$facetIdentifier,
      _ref2$facetKey = _ref2.facetKey,
      facetKey = _ref2$facetKey === void 0 ? '' : _ref2$facetKey;

  var _useListingFilter = useListingFilter(filter.options, filter.selectType, facetKey),
      searchTerm = _useListingFilter.searchTerm,
      setSearchTerm = _useListingFilter.setSearchTerm,
      searchResults = _useListingFilter.searchResults,
      appliedFilters = _useListingFilter.appliedFilters;

  return /*#__PURE__*/jsxs("div", {
    className: "card border-bottom pt-1 pb-2 my-1",
    children: [/*#__PURE__*/jsx(FacetHeading, {
      name: filter.name,
      value: facetKey
    }), /*#__PURE__*/jsx("div", {
      className: "collapse show",
      "aria-labelledby": "filer".concat(facetKey),
      id: "filer".concat(facetKey),
      "data-parent": "#shop-categories",
      children: /*#__PURE__*/jsx("div", {
        className: "card-body",
        children: /*#__PURE__*/jsxs("div", {
          className: "widget widget-links cz-filter",
          children: [/*#__PURE__*/jsx(FacetSearch, {
            facetKey: facetKey,
            searchTerm: searchTerm,
            search: setSearchTerm
          }), /*#__PURE__*/jsx("div", {
            className: "widget-list cz-filter-list pt-1  ".concat(facetKey, "-list"),
            style: {
              maxHeight: '12rem',
              overflowY: 'auto'
            },
            children: searchResults && searchResults.map(function (facet) {
              var isSelected = appliedFilters.includes(facet[facetIdentifier]);
              return /*#__PURE__*/jsx(AttributeList, {
                facetKeyName: facetIdentifier,
                filterName: filter.name,
                isSelected: isSelected,
                facet: facet,
                facetKey: facetKey,
                updateAttribute: updateAttribute
              }, facet.id || facet.name);
            })
          })]
        })
      })
    })]
  });
};

var FilterLoader = function FilterLoader(props) {
  return /*#__PURE__*/jsxs(ContentLoader, _objectSpread2(_objectSpread2({
    speed: 2,
    width: 400,
    height: 150,
    viewBox: "0 0 400 200",
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("rect", {
      x: "25",
      y: "15",
      rx: "5",
      ry: "5",
      width: "350",
      height: "20"
    }), /*#__PURE__*/jsx("rect", {
      x: "25",
      y: "45",
      rx: "5",
      ry: "5",
      width: "350",
      height: "10"
    }), /*#__PURE__*/jsx("rect", {
      x: "25",
      y: "60",
      rx: "5",
      ry: "5",
      width: "350",
      height: "10"
    }), /*#__PURE__*/jsx("rect", {
      x: "26",
      y: "75",
      rx: "5",
      ry: "5",
      width: "350",
      height: "10"
    }), /*#__PURE__*/jsx("rect", {
      x: "27",
      y: "107",
      rx: "5",
      ry: "5",
      width: "350",
      height: "20"
    }), /*#__PURE__*/jsx("rect", {
      x: "26",
      y: "135",
      rx: "5",
      ry: "5",
      width: "350",
      height: "10"
    }), /*#__PURE__*/jsx("rect", {
      x: "26",
      y: "150",
      rx: "5",
      ry: "5",
      width: "350",
      height: "10"
    }), /*#__PURE__*/jsx("rect", {
      x: "27",
      y: "165",
      rx: "5",
      ry: "5",
      width: "350",
      height: "10"
    })]
  }));
};

var ListingSidebar = function ListingSidebar(_ref) {
  var _productType$options, _brand$options, _category$options, _priceRange$options;

  var isFetching = _ref.isFetching,
      hide = _ref.hide,
      filtering = _ref.filtering,
      keyword = _ref.keyword,
      recordsCount = _ref.recordsCount,
      setKeyword = _ref.setKeyword,
      updateAttribute = _ref.updateAttribute;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var textInput = useRef(null);

  var _useFilterFormatter = useFilterFormatter(_objectSpread2({}, filtering)),
      option = _useFilterFormatter.option,
      brand = _useFilterFormatter.brand,
      attribute = _useFilterFormatter.attribute,
      category = _useFilterFormatter.category,
      priceRange = _useFilterFormatter.priceRange,
      productType = _useFilterFormatter.productType;

  var location = useLocation$2();
  useEffect(function () {
    setTimeout(function () {
      var id = location.hash.replace('#', '');
      var element = document.getElementById(id);

      if (!isFetching && element) {
        element.scrollIntoView({
          block: 'center',
          behavior: 'smooth'
        });
      }
    }, 100);
  }, [isFetching, location]);
  return /*#__PURE__*/jsxs("div", {
    className: "cz-sidebar rounded-lg box-shadow-lg",
    id: "shop-sidebar",
    children: [/*#__PURE__*/jsx("div", {
      className: "cz-sidebar-header box-shadow-sm",
      children: /*#__PURE__*/jsxs("button", {
        className: "close ml-auto",
        type: "button",
        "data-toggle": "collapse",
        "data-target": "#shop-sidebar",
        "aria-expanded": "false",
        children: [/*#__PURE__*/jsxs("span", {
          className: "d-inline-block font-size-xs font-weight-normal align-middle",
          children: [t('frontend.core.close_sidebar'), " "]
        }), /*#__PURE__*/jsx("span", {
          className: "d-inline-block align-middle ml-2",
          "aria-hidden": "true",
          children: /*#__PURE__*/jsx("i", {
            className: "far fa-times"
          })
        })]
      })
    }), /*#__PURE__*/jsx("div", {
      className: "cz-sidebar-body",
      children: /*#__PURE__*/jsxs("div", {
        className: "widget widget-categories mb-3",
        children: [/*#__PURE__*/jsxs("div", {
          className: "row",
          children: [/*#__PURE__*/jsx("h3", {
            className: "widget-title col",
            children: t('frontend.core.filters')
          }), recordsCount && /*#__PURE__*/jsx("span", {
            className: "text-right col",
            children: "".concat(recordsCount, " ").concat(t('frontend.core.results'))
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "input-group-overlay input-group-sm mb-2",
          children: [/*#__PURE__*/jsx("input", {
            className: "cz-filter-search form-control form-control-sm appended-form-control",
            type: "text",
            defaultValue: keyword,
            ref: textInput,
            onKeyDown: function onKeyDown(e) {
              if (e.key === 'Enter') {
                e.preventDefault();
                setKeyword(e.target.value);
              }
            },
            placeholder: t('frontend.plp.search.placeholder')
          }, keyword), /*#__PURE__*/jsx("div", {
            className: "input-group-append-overlay",
            children: /*#__PURE__*/jsx("span", {
              className: "input-group-text",
              children: /*#__PURE__*/jsx("i", {
                className: "fa fa-search",
                onClick: function onClick(e) {
                  e.preventDefault();
                  setKeyword(textInput.current.value);
                }
              })
            })
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: "accordion mt-3 border-top",
          id: "shop-categories",
          children: [isFetching && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(FilterLoader, {}), /*#__PURE__*/jsx(FilterLoader, {}), /*#__PURE__*/jsx(FilterLoader, {})]
          }), !isFetching && (productType === null || productType === void 0 ? void 0 : (_productType$options = productType.options) === null || _productType$options === void 0 ? void 0 : _productType$options.length) > 0 && !hide.includes(productType.facetKey) && [productType].map(function (filter) {
            return /*#__PURE__*/jsx(FacetFilter, {
              filter: filter,
              facetIdentifier: "slug",
              facetKey: "productType_slug",
              updateAttribute: updateAttribute
            }, "productType_slug");
          }), !isFetching && (brand === null || brand === void 0 ? void 0 : (_brand$options = brand.options) === null || _brand$options === void 0 ? void 0 : _brand$options.length) > 0 && !hide.includes(brand.facetKey) && [brand].map(function (filter) {
            return /*#__PURE__*/jsx(FacetFilter, {
              filter: filter,
              facetIdentifier: "slug",
              facetKey: "brand_slug",
              updateAttribute: updateAttribute
            }, "brand");
          }), !isFetching && (attribute === null || attribute === void 0 ? void 0 : attribute.subFacets) && Object.values(attribute.subFacets).sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          }).map(function (filter) {
            return /*#__PURE__*/jsx(FacetFilter, {
              filter: filter,
              facetIdentifier: "name",
              facetKey: "attribute_".concat(filter.subFacetKey),
              updateAttribute: updateAttribute
            }, "attribute_".concat(filter.subFacetKey));
          }), !isFetching && (option === null || option === void 0 ? void 0 : option.subFacets) && Object.values(option.subFacets).sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          }).map(function (filter) {
            return /*#__PURE__*/jsx(FacetFilter, {
              filter: filter,
              facetIdentifier: "name",
              facetKey: "option_".concat(filter.subFacetKey),
              updateAttribute: updateAttribute
            }, "option_".concat(filter.subFacetKey));
          }), !isFetching && (category === null || category === void 0 ? void 0 : (_category$options = category.options) === null || _category$options === void 0 ? void 0 : _category$options.length) > 0 && !hide.includes(category.facetKey) && [category].map(function (filter) {
            return /*#__PURE__*/jsx(FacetFilter, {
              filter: filter,
              facetIdentifier: "name",
              facetKey: "category",
              updateAttribute: updateAttribute
            }, "category");
          }), !isFetching && (priceRange === null || priceRange === void 0 ? void 0 : (_priceRange$options = priceRange.options) === null || _priceRange$options === void 0 ? void 0 : _priceRange$options.length) > 0 && !hide.includes(priceRange.facetKey) && [priceRange].map(function (filter) {
            return /*#__PURE__*/jsx(FacetFilter, {
              filter: filter,
              facetIdentifier: "value",
              facetKey: "priceRange",
              updateAttribute: updateAttribute
            }, "priceRange");
          })]
        })]
      })
    })]
  });
};

var ListingToolBar = function ListingToolBar(_ref) {
  var sorting = _ref.sorting,
      orderBy = _ref.orderBy,
      setSort = _ref.setSort;
  return /*#__PURE__*/jsxs("div", {
    className: "d-flex justify-content-between justify-md-content-between align-items-start pt-2 pb-4 pb-sm-5",
    children: [/*#__PURE__*/jsxs("button", {
      className: "cz-handheld-toolbar-item p-2 bg-white border rounded d-lg-none",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#shop-sidebar",
      id: "sidebar",
      "aria-expanded": "false",
      children: [/*#__PURE__*/jsx("span", {
        className: "cz-handheld-toolbar-icon",
        children: /*#__PURE__*/jsx("i", {
          className: "fal fa-sliders-h"
        })
      }), /*#__PURE__*/jsx("span", {
        className: "cz-handheld-toolbar-label mt-1 font-weight-bold text-dark",
        children: "Filters"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "d-sm-flex pb-3 align-items-center ml-auto",
      children: [/*#__PURE__*/jsx("label", {
        className: "text-dark opacity-75 text-nowrap mr-2 mb-0 d-none d-sm-block",
        htmlFor: "sorting",
        children: "Sort by:"
      }), /*#__PURE__*/jsx("select", {
        className: "form-control custom-select",
        id: "sorting",
        value: orderBy,
        style: {
          minWidth: '150'
        },
        onChange: function onChange(event) {
          setSort(event.target.value);
        },
        children: sorting && sorting.options && sorting.options.length > 1 && sorting.options.map(function (_ref2, index) {
          var name = _ref2.name,
              value = _ref2.value;
          return /*#__PURE__*/jsx("option", {
            value: value,
            children: name
          }, index);
        })
      })]
    })]
  });
};

var ProductTypeList = function ProductTypeList(_ref) {
  var _data$childProductTyp;

  var data = _ref.data,
      onSelect = _ref.onSelect,
      _ref$isFetching = _ref.isFetching,
      isFetching = _ref$isFetching === void 0 ? true : _ref$isFetching;

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [isFetching && /*#__PURE__*/jsx("div", {
      className: "container bg-light box-shadow-lg rounded-lg p-5",
      children: /*#__PURE__*/jsx(Spinner, {})
    }), !isFetching && data.childProductTypes && ((_data$childProductTyp = data.childProductTypes) === null || _data$childProductTyp === void 0 ? void 0 : _data$childProductTyp.length) > 0 && /*#__PURE__*/jsxs("div", {
      className: "container bg-light box-shadow-lg rounded-lg p-5",
      children: [/*#__PURE__*/jsx("div", {
        onClick: eventHandlerForWSIWYG,
        dangerouslySetInnerHTML: {
          __html: data === null || data === void 0 ? void 0 : data.productTypeDescription
        }
      }), /*#__PURE__*/jsx("div", {
        className: "row",
        children: data.childProductTypes.sort(function (a, b) {
          return a.productTypeName > b.productTypeName ? 1 : -1;
        }).map(function (_ref2) {
          var productTypeID = _ref2.productTypeID,
              productTypeName = _ref2.productTypeName,
              imageFile = _ref2.imageFile,
              urlTitle = _ref2.urlTitle,
              childProductTypes = _ref2.childProductTypes;
          var customImagePath = '';
          var imageFileName = '';

          if (imageFile !== '') {
            imageFileName = imageFile.split('/').reverse()[0];
            customImagePath = imageFile.split('/').slice(0, -1).join('/') + '/';
          }

          return /*#__PURE__*/jsx("div", {
            className: "col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-3",
            children: /*#__PURE__*/jsxs("div", {
              className: "card border-0",
              children: [/*#__PURE__*/jsx("div", {
                className: "d-block overflow-hidden rounded-lg typelisting-image",
                onClick: function onClick(e) {
                  e.preventDefault();
                  onSelect(urlTitle);
                },
                children: /*#__PURE__*/jsx(SWImage, {
                  className: "d-block w-100",
                  customPath: customImagePath,
                  src: imageFileName,
                  alt: productTypeName,
                  type: "productType"
                })
              }), /*#__PURE__*/jsxs("div", {
                className: "card-body text-center",
                children: [/*#__PURE__*/jsx("h2", {
                  className: "h5",
                  children: /*#__PURE__*/jsx("button", {
                    className: "link-button ",
                    onClick: function onClick(e) {
                      e.preventDefault();
                      onSelect(urlTitle);
                    },
                    children: productTypeName
                  })
                }), /*#__PURE__*/jsx("ul", {
                  className: "list-unstyled font-size-sm mb-0",
                  children: childProductTypes.sort(function (a, b) {
                    return a.productTypeName > b.productTypeName ? 1 : -1;
                  }).map(function (_ref3) {
                    var productTypeID = _ref3.productTypeID,
                        productTypeName = _ref3.productTypeName,
                        urlTitle = _ref3.urlTitle;
                    return /*#__PURE__*/jsx("li", {
                      children: /*#__PURE__*/jsxs("button", {
                        className: "link-button nav-link-style d-flex align-items-center justify-content-between text-left",
                        onClick: function onClick(e) {
                          e.preventDefault();
                          onSelect(urlTitle);
                        },
                        children: [/*#__PURE__*/jsx("i", {
                          className: "far fa-chevron-circle-right pr-2"
                        }), productTypeName]
                      })
                    }, productTypeID);
                  })
                })]
              })]
            })
          }, productTypeID);
        })
      })]
    }), ' ']
  });
};

var ProductCard = function ProductCard(props) {
  var productName = props.productName,
      productCode = props.productCode,
      salePrice = props.salePrice,
      urlTitle = props.urlTitle,
      brandName = props.brandName,
      brandUrlTitle = props.brandUrlTitle,
      _props$imageFallbackF = props.imageFallbackFileName,
      imageFallbackFileName = _props$imageFallbackF === void 0 ? '' : _props$imageFallbackF,
      listPrice = props.listPrice,
      images = props.images,
      imageFile = props.imageFile,
      productClearance = props.productClearance,
      imagePath = props.imagePath,
      _props$skuID = props.skuID,
      skuID = _props$skuID === void 0 ? '' : _props$skuID,
      skuCode = props.skuCode;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var brand = useSelector(getBrandRoute);
  var product = useSelector(getProductRoute);
  var productLink = "/".concat(product, "/").concat(urlTitle) + (skuID.length ? "?skuid=".concat(skuID) : '');
  var useResizedImage = images && (images === null || images === void 0 ? void 0 : images.length) > 0;
  return /*#__PURE__*/jsxs("div", {
    className: "card product-card pb-2 pt-3 mx-2",
    children: [productClearance === true && /*#__PURE__*/jsx("span", {
      className: "badge badge-primary",
      children: t('frontend.core.special')
    }), /*#__PURE__*/jsx(HeartButton, {
      skuID: skuID
    }), /*#__PURE__*/jsxs(Link, {
      className: "card-img-top d-block overflow-hidden",
      to: productLink,
      children: [useResizedImage && /*#__PURE__*/jsx(SimpleImage, {
        className: "d-block mx-auto",
        src: images[0],
        alt: productName
      }), !useResizedImage && imagePath && /*#__PURE__*/jsx(ProductImage, {
        imageFile: imagePath,
        skuID: skuID,
        customPath: "/",
        fallbackFileName: imageFallbackFileName
      }), !useResizedImage && imageFile && /*#__PURE__*/jsx(ProductImage, {
        imageFile: imageFile,
        skuID: skuID,
        fallbackFileName: imageFallbackFileName
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "card-body py-2 text-left",
      children: [/*#__PURE__*/jsx(Link, {
        className: "product-meta d-block font-size-xs pb-1",
        to: "/".concat(brand, "/").concat(brandUrlTitle),
        children: brandName
      }), !skuCode && productCode && /*#__PURE__*/jsx("h3", {
        className: "font-size-sm text-muted mb-2",
        children: /*#__PURE__*/jsx(Link, {
          to: productLink,
          children: productCode
        })
      }), skuCode && /*#__PURE__*/jsx("h3", {
        className: "product-code mb-2",
        children: /*#__PURE__*/jsx(Link, {
          to: productLink,
          children: skuCode
        })
      }), /*#__PURE__*/jsx("h3", {
        className: "product-title",
        children: /*#__PURE__*/jsx(Link, {
          to: productLink,
          children: productName
        })
      }), /*#__PURE__*/jsx("div", {
        className: "d-flex justify-content-between",
        children: /*#__PURE__*/jsx(ProductPrice, {
          salePrice: salePrice,
          listPrice: listPrice
        })
      })]
    })]
  });
};

var ProductPrice = function ProductPrice(_ref) {
  var _ref$salePrice = _ref.salePrice,
      salePrice = _ref$salePrice === void 0 ? 0 : _ref$salePrice,
      _ref$listPrice = _ref.listPrice,
      listPrice = _ref$listPrice === void 0 ? 0 : _ref$listPrice,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'product' : _ref$type,
      salePriceSuffixKey = _ref.salePriceSuffixKey,
      _ref$accentSalePrice = _ref.accentSalePrice,
      accentSalePrice = _ref$accentSalePrice === void 0 ? true : _ref$accentSalePrice,
      _ref$listPriceSuffixK = _ref.listPriceSuffixKey,
      listPriceSuffixKey = _ref$listPriceSuffixK === void 0 ? 'frontend.core.list' : _ref$listPriceSuffixK;

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var _useProductPrice = useProductPrice({
    salePrice: salePrice,
    listPrice: listPrice,
    type: type
  }),
      showSalePrice = _useProductPrice.showSalePrice,
      showListPrice = _useProductPrice.showListPrice,
      showMissingPrice = _useProductPrice.showMissingPrice;

  var _useUtilities = useUtilities(),
      isAuthenticated = _useUtilities.isAuthenticated;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isAuthed = isAuthenticated();
  return /*#__PURE__*/jsxs("div", {
    className: "product-price d-flex align-items-center",
    children: [isAuthed, showMissingPrice && /*#__PURE__*/jsx("small", {
      children: t('frontend.product.price.missing')
    }), !showMissingPrice && showSalePrice && /*#__PURE__*/jsxs("div", {
      style: {
        marginRight: '5px'
      },
      children: [/*#__PURE__*/jsx("span", {
        className: accentSalePrice ? 'text-accent font-weight-bold' : '',
        children: formatCurrency(salePrice)
      }), /*#__PURE__*/jsx("small", {
        children: salePriceSuffixKey && " ".concat(t(salePriceSuffixKey))
      })]
    }), !showMissingPrice && showListPrice && /*#__PURE__*/jsx("span", {
      children: /*#__PURE__*/jsxs("small", {
        children: ["".concat(formatCurrency(listPrice)), "\xA0", t(listPriceSuffixKey)]
      })
    })]
  });
};

var ProductSlider = function ProductSlider(_ref) {
  var children = _ref.children,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params,
      settings = _ref.settings,
      title = _ref.title,
      _ref$slidesToShow = _ref.slidesToShow,
      slidesToShow = _ref$slidesToShow === void 0 ? 4 : _ref$slidesToShow;

  var _useGetProductsByEnti = useGetProductsByEntity(),
      _useGetProductsByEnti2 = _slicedToArray(_useGetProductsByEnti, 2),
      request = _useGetProductsByEnti2[0],
      setRequest = _useGetProductsByEnti2[1];

  useEffect(function () {
    var didCancel = false;

    if (!didCancel && !request.isFetching && !request.isLoaded) {
      setRequest(_objectSpread2(_objectSpread2({}, request), {}, {
        params: _objectSpread2({
          includeImages: true
        }, params),
        entity: 'product',
        makeRequest: true,
        isFetching: true,
        isLoaded: false
      }));
    }

    return function () {
      didCancel = true;
    };
  }, [request, setRequest, params]);

  if (!request.data.length) {
    return null;
  }

  settings = settings ? settings : {
    dots: false,
    infinite: request.data && request.data.length >= slidesToShow,
    // infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }]
  };
  var products = request.data.map(function (product) {
    return _objectSpread2(_objectSpread2({}, product), {}, {
      brandName: product.brand_brandName,
      brandUrlTitle: product.brand_urlTitle,
      imageFile: product.defaultSku_imageFile,
      skuCode: product.defaultSku_skuCode,
      product: product.defaultSku_imageFile,
      skuID: product.defaultSku_skuID
    });
  });
  return /*#__PURE__*/jsx("div", {
    className: "container",
    children: /*#__PURE__*/jsxs("div", {
      className: "featured-products shadow bg-white text-center my-5 py-3",
      children: [/*#__PURE__*/jsx("h3", {
        className: "h3 mb-0",
        children: title
      }), children, /*#__PURE__*/jsx(Slider, _objectSpread2(_objectSpread2({
        style: {
          margin: '0 4rem',
          height: 'fit-content'
        },
        className: "row mt-4"
      }, settings), {}, {
        children: products.map(function (product) {
          return /*#__PURE__*/createElement(ProductCard, _objectSpread2(_objectSpread2({}, product), {}, {
            key: product.defaultSku_skuID
          }));
        })
      }))]
    })
  });
};

var RelatedProductsSlider = function RelatedProductsSlider(_ref) {
  var productID = _ref.productID,
      _ref$slidesToShow = _ref.slidesToShow,
      slidesToShow = _ref$slidesToShow === void 0 ? 4 : _ref$slidesToShow;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState({
    products: [],
    isLoaded: false,
    err: '',
    productID: productID
  }),
      _useState2 = _slicedToArray(_useState, 2),
      relatedProducts = _useState2[0],
      setRelatedProducts = _useState2[1];

  if (relatedProducts.productID !== productID) {
    setRelatedProducts({
      products: [],
      isLoaded: false,
      err: '',
      productID: productID
    });
  }

  useEffect(function () {
    var didCancel = false;

    if (!relatedProducts.isLoaded) {
      SlatwallApiService.products.getRelatedProducts({
        productID: productID
      }).then(function (response) {
        if (response.isSuccess() && !didCancel) {
          var newProducts = response.success().relatedProducts;
          setRelatedProducts(_objectSpread2(_objectSpread2({}, relatedProducts), {}, {
            isLoaded: true,
            products: newProducts
          }));
        } else {
          setRelatedProducts(_objectSpread2(_objectSpread2({}, relatedProducts), {}, {
            isLoaded: true,
            err: 'oops'
          }));
        }
      });
    }

    return function () {
      didCancel = true;
    };
  }, [relatedProducts, setRelatedProducts, productID]);

  if (!relatedProducts.products.length) {
    return null;
  }

  var settings = {
    dots: false,
    infinite: relatedProducts.products && relatedProducts.products.length >= slidesToShow,
    // infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }]
  };
  var products = relatedProducts.products.map(function (sku) {
    return _objectSpread2(_objectSpread2({}, sku), {}, {
      productName: sku.relatedProduct_productName,
      productCode: sku.relatedProduct_productCode,
      urlTitle: sku.relatedProduct_urlTitle,
      brandName: sku.relatedProduct_brand_brandName,
      brandUrlTitle: sku.relatedProduct_brand_urlTitle,
      imageFile: sku.relatedProduct_defaultSku_imageFile,
      skuID: sku.relatedProduct_defaultSku_skuID,
      skuCode: sku.relatedProduct_defaultSku_skuCode
    });
  });
  return /*#__PURE__*/jsx("div", {
    className: "container",
    children: /*#__PURE__*/jsxs("div", {
      className: "featured-products shadow bg-white text-center my-5 py-3",
      children: [/*#__PURE__*/jsx("h3", {
        className: "h3 mb-0",
        children: t('frontend.product.related')
      }), /*#__PURE__*/jsx(Slider, _objectSpread2(_objectSpread2({
        style: {
          margin: '0 4rem',
          height: 'fit-content'
        },
        className: "row mt-4"
      }, settings), {}, {
        children: products.map(function (product) {
          return /*#__PURE__*/createElement(ProductCard, _objectSpread2(_objectSpread2({}, product), {}, {
            key: product.productCode
          }));
        })
      }))]
    })
  });
};

var ProductDetailGallery = function ProductDetailGallery(_ref) {
  var productID = _ref.productID,
      skuID = _ref.skuID,
      imageFile = _ref.imageFile;

  var _useProductDetailGall = useProductDetailGallery({
    productID: productID,
    skuID: skuID,
    imageFile: imageFile
  }),
      productImageGallery = _useProductDetailGall.productImageGallery,
      sliders = _useProductDetailGall.sliders,
      slider1 = _useProductDetailGall.slider1,
      slider2 = _useProductDetailGall.slider2,
      filterImages = _useProductDetailGall.filterImages;

  return /*#__PURE__*/jsxs("div", {
    className: "col-lg-6 pr-lg-5 pt-0",
    children: [/*#__PURE__*/jsx("div", {
      className: "cz-product-gallery",
      children: /*#__PURE__*/jsx("div", {
        className: "cz-preview order-sm-2",
        children: /*#__PURE__*/jsxs("div", {
          className: "cz-preview-item active",
          id: "primaryProductImage",
          children: [/*#__PURE__*/jsx("div", {
            children: /*#__PURE__*/jsx(Slider, {
              arrows: false,
              asNavFor: sliders.nav2,
              ref: function ref(slider) {
                return slider1.current = slider;
              },
              children: productImageGallery.isLoaded && (filterImages === null || filterImages === void 0 ? void 0 : filterImages.map(function (_ref2, index) {
                var RESIZEDIMAGEPATHS = _ref2.RESIZEDIMAGEPATHS,
                    _ref2$ORIGINALFILENAM = _ref2.ORIGINALFILENAME,
                    ORIGINALFILENAME = _ref2$ORIGINALFILENAM === void 0 ? '' : _ref2$ORIGINALFILENAM;
                return /*#__PURE__*/jsx(SWImage, {
                  customPath: "/",
                  src: RESIZEDIMAGEPATHS[0],
                  className: "cz-image-zoom w-100 mx-auto",
                  alt: "Product",
                  style: {
                    maxWidth: '500px'
                  }
                }, "".concat(ORIGINALFILENAME, "-").concat(index));
              }))
            })
          }), /*#__PURE__*/jsx("div", {
            className: "cz-image-zoom-pane"
          })]
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: "cz-product-gallery",
      children: /*#__PURE__*/jsx("div", {
        className: "cz-preview order-sm-2",
        children: /*#__PURE__*/jsx("div", {
          className: "cz-preview-item active",
          id: "primaryProductImageRow",
          children: /*#__PURE__*/jsx("div", {
            children: filterImages && filterImages.length > 1 && /*#__PURE__*/jsx(Slider, {
              arrows: false,
              infinite: filterImages.length > 3,
              asNavFor: sliders.nav1,
              ref: function ref(slider) {
                return slider2.current = slider;
              },
              slidesToShow: 3,
              swipeToSlide: true,
              focusOnSelect: true,
              children: productImageGallery.isLoaded && filterImages.map(function (_ref3, index) {
                var RESIZEDIMAGEPATHS = _ref3.RESIZEDIMAGEPATHS,
                    _ref3$ORIGINALFILENAM = _ref3.ORIGINALFILENAME,
                    ORIGINALFILENAME = _ref3$ORIGINALFILENAM === void 0 ? '' : _ref3$ORIGINALFILENAM;
                return /*#__PURE__*/jsx(SWImage, {
                  customPath: "/",
                  src: RESIZEDIMAGEPATHS[1],
                  className: "cz-image-zoom w-100 mx-auto",
                  alt: "Product",
                  style: {
                    maxWidth: '100px'
                  }
                }, "".concat(ORIGINALFILENAME, "-").concat(index));
              })
            })
          })
        })
      })
    })]
  });
};

var ProductPageHeader = function ProductPageHeader(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      children = _ref.children;
  return /*#__PURE__*/jsx("div", {
    className: "page-title-overlap bg-lightgray pt-4",
    children: /*#__PURE__*/jsxs("div", {
      className: "container d-lg-flex justify-content-between py-2 py-lg-3",
      children: [/*#__PURE__*/jsx("div", {
        className: "order-lg-1 pr-lg-4 text-center text-lg-left",
        children: /*#__PURE__*/jsx("h1", {
          className: "h3 text-dark mb-0 font-accent",
          children: title
        })
      }), /*#__PURE__*/jsx("div", {
        className: "order-lg-2 mb-3 mb-lg-0 pt-lg-2",
        children: children
      })]
    })
  });
};

var ProductPagePanels = function ProductPagePanels(_ref) {
  var _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product,
      _ref$attributeSets = _ref.attributeSets,
      attributeSets = _ref$attributeSets === void 0 ? [] : _ref$attributeSets;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var filteredAttributeSets = attributeSets.map(function (set) {
    return _objectSpread2(_objectSpread2({}, set), {}, {
      attributes: set.attributes.filter(function (attr) {
        return attr.attributeCode in product && product[attr.attributeCode] !== ' ';
      }).sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      })
    });
  }).filter(function (set) {
    return set.attributes.length;
  });
  return /*#__PURE__*/jsxs("div", {
    className: "accordion mb-4",
    id: "productPanels",
    children: [filteredAttributeSets.map(function (set) {
      return /*#__PURE__*/jsxs("div", {
        className: "card",
        children: [/*#__PURE__*/jsx("div", {
          className: "card-header",
          children: /*#__PURE__*/jsx("h3", {
            className: "accordion-heading",
            children: /*#__PURE__*/jsxs("a", {
              href: "#".concat(set.attributeSetCode),
              role: "button",
              "data-toggle": "collapse",
              "aria-expanded": "true",
              "aria-controls": set.attributeSetCode,
              children: [/*#__PURE__*/jsx("i", {
                className: "far fa-key font-size-lg align-middle mt-n1 mr-2"
              }), set.attributeSetName, /*#__PURE__*/jsx("span", {
                className: "accordion-indicator"
              })]
            })
          })
        }), /*#__PURE__*/jsx("div", {
          className: "collapse show",
          id: set.attributeSetCode,
          children: /*#__PURE__*/jsx("ul", {
            className: "pdp-attributes card-body list-unstyled m-0 font-size-sm",
            children: set.attributes.map(function (_ref2) {
              var attributeName = _ref2.attributeName,
                  attributeCode = _ref2.attributeCode;
              return /*#__PURE__*/jsxs("li", {
                className: "d-flex font-size-sm",
                children: [/*#__PURE__*/jsxs("span", {
                  className: "mr-2",
                  children: [attributeName, ": "]
                }), /*#__PURE__*/jsx("span", {
                  className: "text-muted",
                  children: isBoolean(product[attributeCode]) ? booleanToString(product[attributeCode]) : product[attributeCode]
                })]
              }, attributeCode);
            })
          })
        })]
      }, set.attributeSetCode);
    }), /*#__PURE__*/jsxs("div", {
      className: "card",
      children: [/*#__PURE__*/jsx("div", {
        className: "card-header",
        children: /*#__PURE__*/jsx("h3", {
          className: "accordion-heading",
          children: /*#__PURE__*/jsxs("a", {
            className: "collapsed",
            href: "#questions",
            role: "button",
            "data-toggle": "collapse",
            "aria-expanded": "true",
            "aria-controls": "questions",
            children: [/*#__PURE__*/jsx("i", {
              className: "far fa-question-circle font-size-lg align-middle mt-n1 mr-2"
            }), t('frontend.product.questions.heading'), /*#__PURE__*/jsx("span", {
              className: "accordion-indicator"
            })]
          })
        })
      }), /*#__PURE__*/jsx("div", {
        className: "collapse",
        id: "questions",
        children: /*#__PURE__*/jsxs("div", {
          className: "card-body",
          children: [/*#__PURE__*/jsx("p", {
            children: t('frontend.product.questions.detail')
          }), /*#__PURE__*/jsx(Link, {
            to: "/contact",
            children: t('frontend.nav.contact')
          })]
        })
      })]
    })]
  });
};

var SkuOptions = function SkuOptions(_ref) {
  var productOptions = _ref.productOptions,
      selection = _ref.selection,
      _ref$skus = _ref.skus,
      skus = _ref$skus === void 0 ? [] : _ref$skus;

  var _useProductDetail = useProductDetail(),
      filterSkusBySelectedOptions = _useProductDetail.filterSkusBySelectedOptions,
      generateOptionGroupPair = _useProductDetail.generateOptionGroupPair;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var loc = useLocation$2();
  var history = useHistory$1(); // http://localhost:3006/product/test-product?colors=global-black&soccerBallColor=orange&soccerBallSize=3

  var selectedOption = function selectedOption() {
    var skus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var optionGroupCode = arguments.length > 1 ? arguments[1] : undefined;
    var optionCode = arguments.length > 2 ? arguments[2] : undefined;
    var selection = arguments.length > 3 ? arguments[3] : undefined;
    var singlePair = generateOptionGroupPair(optionGroupCode, optionCode);
    selection[optionGroupCode] = optionCode;
    var optionsToTest = Object.keys(selection).map(function (key) {
      return generateOptionGroupPair(key, selection[key]);
    });
    var matchingSkus = filterSkusBySelectedOptions(skus, optionsToTest);

    if (matchingSkus.length === 1) {
      // http://localhost:3006/product/test-product?colors=global-black&soccerBallSize=3
      console.log('Single Matching sku');
      history.replace({
        pathname: loc.pathname,
        search: matchingSkus[0].slug
      });
    } else if (matchingSkus.length === 0) {
      var possibleSKus = filterSkusBySelectedOptions(skus, [singlePair]);

      if (possibleSKus.length === 1) {
        console.log('Single Matching sku'); // http://localhost:3006/product/test-product?soccerBallColor=orange&colors=global-red&soccerBallSize=3  select 4

        history.replace({
          pathname: loc.pathname,
          search: possibleSKus[0].slug
        });
      } else if (possibleSKus.length > 1) {
        console.log('The selection was not valid so we will reset option selection to current selection'); // http://localhost:3006/product/test-product?soccerBallColor=yellow&colors=global-black&soccerBallSize=4 ==> select red

        history.replace({
          pathname: loc.pathname,
          search: singlePair
        });
      }
    } else {
      console.log('Multiple remaining skus after new selection'); // http://localhost:3006/product/test-product?soccerBallColor=orange&soccerBallSize=3 select orange

      history.replace({
        pathname: loc.pathname,
        search: optionsToTest.join('&')
      });
    }
  };

  return /*#__PURE__*/jsx(Fragment, {
    children: productOptions.length > 0 && productOptions.map(function (_ref2) {
      var optionGroupName = _ref2.optionGroupName,
          options = _ref2.options,
          optionGroupID = _ref2.optionGroupID,
          optionGroupCode = _ref2.optionGroupCode;
      var selectedOptionCode = selection[optionGroupCode] || 'select';
      return /*#__PURE__*/jsxs("div", {
        className: "form-group",
        children: [/*#__PURE__*/jsx("div", {
          className: "d-flex justify-content-between align-items-center pb-1",
          children: /*#__PURE__*/jsx("label", {
            className: "font-weight-medium",
            htmlFor: optionGroupID,
            children: optionGroupName
          })
        }), /*#__PURE__*/jsxs("select", {
          className: "custom-select",
          required: true,
          value: selectedOptionCode,
          id: optionGroupID,
          onChange: function onChange(e) {
            selectedOption(skus, optionGroupCode, e.target.value, selection);
          },
          children: [selectedOptionCode === 'select' && /*#__PURE__*/jsx("option", {
            className: "option nonactive",
            value: "select",
            children: t('frontend.product.select')
          }), options && options.map(function (option) {
            return /*#__PURE__*/jsxs("option", {
              className: "option ".concat(option.active ? 'active' : 'nonactive'),
              value: option.optionCode,
              children: [option.available && option.optionName, !option.available && option.optionName + ' - ' + t('frontend.product.na')]
            }, option.optionID);
          })]
        })]
      }, optionGroupID);
    })
  });
};

var HeartButton = function HeartButton(_ref) {
  var skuID = _ref.skuID,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'btn-wishlist btn-sm' : _ref$className;
  var dispatch = useDispatch();
  var primaryColor = useSelector(function (state) {
    return state.configuration.theme.primaryColor;
  });
  var defaultWishlist = useSelector(getDefaultWishlist);
  var isListLoaded = useSelector(function (state) {
    return state.userReducer.wishList.isListLoaded;
  });
  var items = useSelector(getItemsForDefaultWishList);

  if (!isAuthenticated()) {
    return null;
  }

  if (items.includes(skuID)) {
    return /*#__PURE__*/jsx("button", {
      className: className,
      onClick: function onClick(e) {
        e.preventDefault();
        dispatch(removeWishlistItem(skuID, defaultWishlist === null || defaultWishlist === void 0 ? void 0 : defaultWishlist.value));
      },
      type: "button",
      "data-toggle": "tooltip",
      "data-placement": "left",
      title: "",
      "data-original-title": "Remove from wishlist",
      children: /*#__PURE__*/jsx("i", {
        className: "fas fa-heart",
        style: {
          color: "#".concat(primaryColor)
        }
      })
    });
  } else {
    return /*#__PURE__*/jsx("button", {
      onClick: function onClick(e) {
        e.preventDefault();

        if (isListLoaded && !(defaultWishlist !== null && defaultWishlist !== void 0 && defaultWishlist.value)) {
          dispatch(createListAndAddItem(skuID));
        } else {
          dispatch(addSkuToWishList(skuID, defaultWishlist === null || defaultWishlist === void 0 ? void 0 : defaultWishlist.value));
        }
      },
      className: className,
      type: "button",
      "data-toggle": "tooltip",
      "data-placement": "left",
      title: "",
      "data-original-title": "Add to wishlist",
      children: /*#__PURE__*/jsx("i", {
        className: "far fa-heart"
      })
    });
  }
};

var ProductDetails = function ProductDetails(_ref) {
  var sku = _ref.sku,
      product = _ref.product;
  var brand = useSelector(getBrandRoute);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: "d-flex justify-content-between align-items-center mb-2",
      children: [/*#__PURE__*/jsxs("span", {
        className: "d-inline-block font-size-sm align-middle px-2 bg-primary text-light",
        children: [" ", product.productClearance === true && ' On Special']
      }), sku && /*#__PURE__*/jsx(HeartButton, {
        skuID: sku.skuID,
        className: 'btn-wishlist mr-0'
      })]
    }), /*#__PURE__*/jsx("h2", {
      className: "h4 mb-2",
      children: product.productName
    }), /*#__PURE__*/jsxs("div", {
      className: "mb-2",
      children: [/*#__PURE__*/jsx("span", {
        className: "text-small text-muted",
        children: "SKU: "
      }), sku && /*#__PURE__*/jsx("span", {
        className: "font-weight-normal text-large text-accent mr-1",
        children: sku.skuCode
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "mb-2",
      children: [/*#__PURE__*/jsx("span", {
        className: "text-small text-muted",
        children: "Brand: "
      }), product && /*#__PURE__*/jsx("span", {
        className: "font-weight-normal text-large  mr-1",
        children: /*#__PURE__*/jsx(Link, {
          to: "/".concat(brand, "/").concat(product.brand_urlTitle),
          children: product.brand_brandName
        })
      })]
    })]
  });
};

var Button = function Button(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$classList = _ref.classList,
      classList = _ref$classList === void 0 ? 'btn btn-primary btn-block' : _ref$classList,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      children = _ref.children,
      label = _ref.label,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsxs("button", {
    type: "button",
    disabled: disabled,
    className: classList,
    onClick: onClick,
    children: [children && children, !children && t(label), isLoading && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("span", {
        children: " "
      }), /*#__PURE__*/jsx("i", {
        className: "far fa fa-spinner fa fa-spin font-size-lg mr-2"
      })]
    })]
  });
};

function ProductQuantityInput(_ref) {
  var setQuantity = _ref.setQuantity,
      quantity = _ref.quantity,
      sku = _ref.sku,
      _ref$stock = _ref.stock,
      stock = _ref$stock === void 0 ? 0 : _ref$stock;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var quantityInput = useSelector(function (state) {
    return state.configuration.products.quantityInput;
  }) || 'text';
  var showInventory = useSelector(function (state) {
    return state.configuration.products.showInventory;
  }) || false;

  var validateQuantity = function validateQuantity(quantity) {
    quantity = parseInt(quantity);
    if (quantity >= sku.skuOrderMinimumQuantity && quantity <= sku.skuOrderMaximumQuantity) setQuantity(quantity);
  };

  return /*#__PURE__*/jsxs("div", {
    className: "position-relative",
    children: [quantityInput === 'text' ? /*#__PURE__*/jsx("input", {
      type: "number",
      onChange: function onChange(event) {
        validateQuantity(event.target.value);
      },
      value: quantity,
      className: "form-control mr-3",
      style: {
        width: '120px'
      }
    }) : /*#__PURE__*/jsx("select", {
      value: quantity,
      onChange: function onChange(event) {
        validateQuantity(event.target.value);
      },
      className: "custom-select mr-3",
      style: {
        width: '120px'
      },
      children: sku && sku.calculatedQATS > 0 && _toConsumableArray(Array(sku.calculatedQATS > 20 ? 20 : sku.calculatedQATS).keys()).map(function (value, index) {
        return /*#__PURE__*/jsx("option", {
          value: index + 1,
          children: index + 1
        }, index + 1);
      })
    }), showInventory && stock > 0 && /*#__PURE__*/jsxs("div", {
      className: "position-absolute text-muted",
      style: {
        bottom: '-30px'
      },
      children: [stock, " ", t('frontend.product.in_stock')]
    })]
  });
}

var ProductForm = function ProductForm(_ref) {
  var sku = _ref.sku,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      productUrl = _ref.productUrl;
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var checkInvetoryFlag = useSelector(checkInvetory);

  var _useProductPrice = useProductPrice({
    salePrice: sku === null || sku === void 0 ? void 0 : sku.salePrice,
    listPrice: sku === null || sku === void 0 ? void 0 : sku.listPrice
  }),
      showAddToCart = _useProductPrice.showAddToCart;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      quantity = _useState2[0],
      setQuantity = _useState2[1];

  if (checkInvetoryFlag && (!sku || (sku === null || sku === void 0 ? void 0 : sku.calculatedQATS) < 1 || (sku === null || sku === void 0 ? void 0 : sku.stocks_calculatedQATS) < 1)) return /*#__PURE__*/jsx("div", {
    style: {
      marginRight: '5px'
    },
    children: /*#__PURE__*/jsxs("span", {
      className: "text-accent",
      children: [" ", t('frontend.checkout.stock')]
    })
  });
  return /*#__PURE__*/jsxs("form", {
    className: "mb-grid-gutter",
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    children: [showAddToCart && /*#__PURE__*/jsxs("div", {
      className: "form-group d-flex align-items-start mb-5",
      children: [/*#__PURE__*/jsx(ProductQuantityInput, {
        setQuantity: setQuantity,
        quantity: quantity,
        sku: sku,
        stock: sku.calculatedQATS || sku.stocks_calculatedQATS
      }), /*#__PURE__*/jsxs(Button, {
        disabled: isDisabled,
        isLoading: isLoading,
        className: "btn btn-primary btn-block",
        onClick: function onClick(event) {
          dispatch(addToCart(sku.skuID, quantity, t('frontend.checkout.item_added_successfully')));
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        },
        children: [/*#__PURE__*/jsx("i", {
          className: "far fa-shopping-cart font-size-lg mr-2"
        }), t('frontend.product.add_to_cart')]
      })]
    }), !isAuthenticated() && /*#__PURE__*/jsxs("div", {
      className: "alert alert-warning d-flex flex-column",
      role: "alert",
      children: [t('frontend.pdp.loginToView'), " ", /*#__PURE__*/jsx(Link, {
        to: "/my-account?redirect=/product/".concat(productUrl),
        children: t('frontend.account.login')
      })]
    })]
  });
};
 // a

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,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";

var img$1 = "data:image/png;base64,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";

var img = "data:image/png;base64,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";

var DefaultImage = function DefaultImage(_ref) {
  var _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      style = _ref.style,
      type = _ref.type,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;

  if (type === 'product') {
    return /*#__PURE__*/jsx("img", {
      className: className,
      style: style,
      src: img,
      alt: alt
    });
  } else if (type === 'productType') {
    return /*#__PURE__*/jsx("img", {
      className: className,
      style: style,
      src: img$1,
      alt: alt
    });
  } else if (type === 'brand') {
    return /*#__PURE__*/jsx("img", {
      className: className,
      style: style,
      src: img$2,
      alt: alt
    });
  }

  return /*#__PURE__*/jsx("img", {
    className: className,
    style: style,
    src: img$3,
    alt: alt
  });
};

var SWImage = function SWImage(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      customPath = _ref2.customPath,
      src = _ref2.src,
      _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      _ref2$style = _ref2.style,
      style = _ref2$style === void 0 ? {} : _ref2$style,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'product' : _ref2$type,
      _ref2$fallbackPath = _ref2.fallbackPath,
      fallbackPath = _ref2$fallbackPath === void 0 ? '' : _ref2$fallbackPath;

  var _useSelector = useSelector(function (state) {
    return state.configuration.theme;
  }),
      host = _useSelector.host,
      basePath = _useSelector.basePath;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      retryCount = _useState2[0],
      setRetryCount = _useState2[1];

  var _useState3 = useState(['productImage']),
      _useState4 = _slicedToArray(_useState3, 2),
      classList = _useState4[0],
      setClassList = _useState4[1];

  var path = customPath ? customPath : basePath;

  var onErrorCallback = function onErrorCallback(e) {
    e.preventDefault();
    e.target.onerror = null;
    var localRetryCount = retryCount + 1;
    var showFallback = fallbackPath.length && localRetryCount === 1 ? 'fallbackImage' : '';
    var showDefault = fallbackPath.length && localRetryCount > 1 || !fallbackPath.length && localRetryCount === 1 ? 'defaultImage' : '';
    setRetryCount(localRetryCount);
    setClassList(['productImage', className, showFallback, showDefault]);

    if (type === 'product') {
      e.target.src = showFallback ? "".concat(host).concat(fallbackPath) : img;
    } else if (type === 'productType') {
      e.target.src = img$1;
    } else if (type === 'brand') {
      e.target.src = img$2;
    } else {
      e.target.src = img$3;
    }
  };

  if (src) {
    return /*#__PURE__*/jsx("img", {
      className: classList.join(' '),
      src: path ? host + path + src : host + src,
      alt: alt,
      style: style,
      onError: onErrorCallback
    });
  }

  return /*#__PURE__*/jsx(DefaultImage, {
    className: "".concat(className, " defaultImage"),
    style: style,
    type: type
  });
};

var SimpleImage = function SimpleImage(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      src = _ref3.src,
      _ref3$alt = _ref3.alt,
      alt = _ref3$alt === void 0 ? '' : _ref3$alt,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? 'product' : _ref3$type;

  var _useSelector2 = useSelector(function (state) {
    return state.configuration.theme;
  }),
      host = _useSelector2.host;

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      retryCount = _useState6[0],
      setRetryCount = _useState6[1];

  var _useState7 = useState(['productImage']),
      _useState8 = _slicedToArray(_useState7, 2),
      classList = _useState8[0],
      setClassList = _useState8[1];

  var onErrorCallback = function onErrorCallback(e) {
    e.preventDefault();
    e.target.onerror = null;
    var localRetryCount = retryCount + 1;
    var showDefault = localRetryCount > 0 ? 'defaultImage' : '';
    setRetryCount(localRetryCount);
    setClassList(['productImage', className, showDefault]);

    if (type === 'product') {
      e.target.src = img;
    } else if (type === 'productType') {
      e.target.src = img$1;
    } else if (type === 'brand') {
      e.target.src = img$2;
    } else {
      e.target.src = img$3;
    }
  };

  if (src) {
    return /*#__PURE__*/jsx("img", {
      className: classList.join(' '),
      src: "".concat(host).concat(src),
      alt: alt,
      style: style,
      onError: onErrorCallback
    });
  }

  return /*#__PURE__*/jsx(DefaultImage, {
    className: "".concat(className, " defaultImage"),
    style: style,
    type: type
  });
};

var ProductImage = function ProductImage(_ref) {
  var skuID = _ref.skuID,
      imageFile = _ref.imageFile,
      defaultSku_imageFile = _ref.defaultSku_imageFile,
      customPath = _ref.customPath;
      _ref.forceImageCall;
      var _ref$fallbackFileName = _ref.fallbackFileName,
      fallbackFileName = _ref$fallbackFileName === void 0 ? '' : _ref$fallbackFileName;

  var _useProductImage = useProductImage(skuID),
      callForImage = _useProductImage.callForImage,
      request = _useProductImage.request;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [!callForImage && /*#__PURE__*/jsx(SWImage, {
      customPath: customPath ? customPath : 'custom/assets/images/product/default/',
      src: imageFile || defaultSku_imageFile,
      alt: "Product",
      fallbackPath: fallbackFileName.length ? "".concat(fallbackFileName) : ''
    }), callForImage && request.isLoaded && /*#__PURE__*/jsx(SWImage, {
      customPath: "/",
      src: request.data[skuID],
      alt: "Product",
      fallbackPath: fallbackFileName.length ? "".concat(fallbackFileName) : ''
    })]
  });
};

var _excluded$1 = ["children"];

var Overlay = function Overlay(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/jsx(LoadingOverlay, _objectSpread2(_objectSpread2({}, props), {}, {
    children: children
  }));
};

var Spinner = function Spinner() {
  return /*#__PURE__*/jsx("div", {
    className: "sk-wrapper",
    children: /*#__PURE__*/jsxs("div", {
      className: "sk-chase",
      children: [/*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      })]
    })
  });
};

var OverlaySpinner = function OverlaySpinner() {
  return /*#__PURE__*/jsx("div", {
    className: "sk-overlay",
    children: /*#__PURE__*/jsxs("div", {
      className: "sk-chase",
      children: [/*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      }), /*#__PURE__*/jsx("div", {
        className: "sk-chase-dot"
      })]
    })
  });
};

var SWForm = function SWForm(_ref) {
  var formik = _ref.formik,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$subTitle = _ref.subTitle,
      subTitle = _ref$subTitle === void 0 ? '' : _ref$subTitle,
      _ref$primaryButtontex = _ref.primaryButtontext,
      primaryButtontext = _ref$primaryButtontex === void 0 ? '' : _ref$primaryButtontex;

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("h2", {
      className: "h4 mb-1",
      children: title
    }), /*#__PURE__*/jsx("p", {
      className: "font-size-sm text-muted mb-4",
      onClick: eventHandlerForWSIWYG,
      dangerouslySetInnerHTML: {
        __html: subTitle
      }
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: formik.handleSubmit,
      children: [children, /*#__PURE__*/jsx("hr", {
        className: "mt-4"
      }), /*#__PURE__*/jsx("div", {
        className: "text-right pt-4",
        children: /*#__PURE__*/jsx("button", {
          className: "btn btn-primary",
          type: "submit",
          children: primaryButtontext
        })
      })]
    })]
  });
};

var SWInput = function SWInput(_ref2) {
  _ref2.required;
      var formik = _ref2.formik,
      _ref2$token = _ref2.token,
      token = _ref2$token === void 0 ? '' : _ref2$token,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label,
      _ref2$wrapperClasses = _ref2.wrapperClasses,
      wrapperClasses = _ref2$wrapperClasses === void 0 ? 'row' : _ref2$wrapperClasses,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'text' : _ref2$type,
      _ref2$showErrors = _ref2.showErrors,
      showErrors = _ref2$showErrors === void 0 ? true : _ref2$showErrors;
  return /*#__PURE__*/jsx("div", {
    className: wrapperClasses,
    children: /*#__PURE__*/jsxs("div", {
      className: "col form-group",
      children: [/*#__PURE__*/jsx("label", {
        className: "control-label",
        htmlFor: token,
        children: label
      }), /*#__PURE__*/jsx("input", {
        className: "form-control",
        type: type,
        id: token,
        value: formik.values[token],
        onChange: formik.handleChange,
        onBlur: formik.handleBlur
      }), showErrors && formik.touched[token] && formik.errors[token] && /*#__PURE__*/jsx("span", {
        className: "form-error-msg",
        children: formik.errors[token]
      })]
    })
  });
};

var SwRadioSelect = function SwRadioSelect(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      selectedValue = _ref.selectedValue;
  return /*#__PURE__*/jsxs("div", {
    className: "form-group",
    children: [label && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("label", {
        className: "w-100 h6",
        children: label
      }), /*#__PURE__*/jsx("hr", {}), /*#__PURE__*/jsx("br", {})]
    }), /*#__PURE__*/jsx("div", {
      className: "d-flex flex-column",
      children: options.length > 0 && options.map(function (_ref2) {
        var value = _ref2.value,
            name = _ref2.name,
            code = _ref2.code;
        return /*#__PURE__*/jsxs("div", {
          className: "form-check form-check-inline custom-control custom-radio d-inline-flex mt-1",
          style: {
            zIndex: 0
          },
          children: [/*#__PURE__*/jsx("input", {
            className: "custom-control-input",
            type: "radio",
            id: code || value,
            value: value,
            onChange: function onChange(e) {},
            checked: selectedValue === value
          }), /*#__PURE__*/jsx("label", {
            className: "custom-control-label",
            htmlFor: code || value,
            onClick: function onClick() {
              onChange(value);
            },
            style: {
              letterSpacing: '1.1'
            },
            children: name
          })]
        }, value);
      })
    })]
  });
};

var SwSelect = function SwSelect(_ref) {
  var id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      disabled = _ref.disabled;
  return /*#__PURE__*/jsx("select", {
    disabled: disabled,
    className: "form-control custom-select",
    id: id,
    name: "['".concat(id, "']"),
    value: value,
    onChange: onChange,
    children: options && options.map(function (_ref2, index) {
      var key = _ref2.key,
          name = _ref2.name,
          value = _ref2.value;
      return /*#__PURE__*/jsx("option", {
        value: value,
        children: key || name
      }, index);
    })
  });
};

var Loading = function Loading() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(SEO, {}), /*#__PURE__*/jsx(Header, {}), /*#__PURE__*/jsx("div", {
      style: {
        minHeight: '100vh'
      }
    }), /*#__PURE__*/jsx(Footer, {})]
  });
};

var ScrollToTop = function ScrollToTop() {
  var history = useHistory$1();
  useEffect(function () {
    var unload = history.listen(function (location) {
      if (!location.pathname.includes('/product/')) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
    return function () {
      unload();
    };
  }, [history]);
  return null;
};

var SEO = function SEO() {
  var loc = useLocation$2();
  var path = loc.pathname.split('/').reverse()[0].toLowerCase();
  var configuration = useSelector(function (state) {
    return state.configuration;
  });
  var content = useSelector(function (state) {
    return state.content[path];
  });
  var _configuration$site = configuration.site,
      site = _configuration$site === void 0 ? {} : _configuration$site,
      _configuration$seo = configuration.seo,
      seo = _configuration$seo === void 0 ? {} : _configuration$seo;
  var title = site.siteName;

  if (content) {
    title = content.settings.contentHTMLTitleString;
  }

  return /*#__PURE__*/jsx(Helmet, {
    title: title,
    children: seo.description && /*#__PURE__*/jsx("meta", {
      name: "description",
      content: seo.description
    })
  });
};

var CMSWrapper = function CMSWrapper(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();

  var _useLocation = useLocation$2('home'),
      pathname = _useLocation.pathname;

  var history = useHistory$1();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = useState(pathname),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPath = _useState4[0],
      setCurrentPath = _useState4[1];

  useEffect(function () {
    if (!isLoaded) {
      var basePath = pathname.split('/')[1].toLowerCase();
      basePath = basePath.length ? basePath : 'home';
      dispatch(getWishLists());
      dispatch(getPageContent({
        'f:urlTitlePath:like': "header%",
        includeSettings: true
      }, 'header'));
      dispatch(getPageContent({
        'f:urlTitlePath:like': "404%",
        includeSettings: true
      }, '404'));
      dispatch(getPageContent({
        'f:urlTitlePath:like': "footer%",
        includeSettings: true
      }, 'footer'));
      dispatch(getPageContent({
        'f:urlTitlePath:like': "".concat(basePath, "%"),
        includeSettings: true
      }, basePath));
      setIsLoaded(true);
    }
  }, [dispatch, history, pathname, isLoaded]);
  useEffect(function () {
    var unload = history.listen(function (location) {
      if (location.pathname !== currentPath) {
        var newPath = location.pathname.split('/').reverse()[0].toLowerCase();
        newPath = newPath.length ? newPath : 'home';
        setCurrentPath(location.pathname);
        dispatch(getPageContent({
          'f:urlTitlePath:like': "".concat(newPath, "%"),
          includeSettings: true
        }, newPath));
      }
    });
    return function () {
      unload();
    };
  }, [dispatch, history, setCurrentPath, currentPath]);
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "footer{\n    color: #2E2B2C;\n}\n\n.Footer-module_bottomBar__1Kqde{\n    background-color: #F9F9F9;\n}\n\nh3{\n    font-weight: 400 !important;\n}\n\n.Footer-module_stayInformed__lTPEM h3{\n    margin-bottom: 0.3em !important;\n}\n\n.Footer-module_stayInformed__lTPEM p{\n    font-size: 12px;\n    font-weight: 100;\n}\n\n.Footer-module_bgFooter__1vrsm{\n    background-color: #221E20;\n    color: #918E8F;\n}";
var styles$1 = {"bottomBar":"Footer-module_bottomBar__1Kqde","stayInformed":"Footer-module_stayInformed__lTPEM","bgFooter":"Footer-module_bgFooter__1vrsm"};
styleInject(css_248z$1);

function Footer() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var formLink = useSelector(function (state) {
    return state.configuration.footer.formLink;
  });
  var contentStore = useSelector(getAllFooterContentSelector);

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  var getInTouch,
      stayInformed,
      siteLinks = '';

  if (contentStore.length) {
    getInTouch = contentStore.map(function (content) {
      return content.key === 'footer/get-in-touch' ? content : null;
    }).filter(function (item) {
      return item;
    });
    getInTouch = getInTouch.length ? getInTouch[0].customBody : '';
    stayInformed = contentStore.map(function (content) {
      return content.key === 'footer/stay-informed' ? content : null;
    }).filter(function (item) {
      return item;
    });
    stayInformed = stayInformed.length ? stayInformed[0].customBody : '';
    siteLinks = contentStore.map(function (content) {
      return content.key === 'footer/site-links' ? content : null;
    }).filter(function (item) {
      return item;
    });
    siteLinks = siteLinks.length ? siteLinks[0].customBody : '';
  }

  return /*#__PURE__*/jsxs("footer", {
    className: "pt-5",
    children: [/*#__PURE__*/jsx(ActionBanner, {}), /*#__PURE__*/jsx("div", {
      className: "".concat(styles$1.bottomBar, " p-5"),
      children: /*#__PURE__*/jsx("div", {
        className: "container",
        children: /*#__PURE__*/jsxs("div", {
          className: "row pt-2",
          children: [/*#__PURE__*/jsx("div", {
            className: "col-md-2 col-sm-6",
            children: /*#__PURE__*/jsx("div", {
              className: "widget widget-links pb-2 mb-4",
              onClick: eventHandlerForWSIWYG,
              dangerouslySetInnerHTML: {
                __html: siteLinks
              }
            })
          }), /*#__PURE__*/jsx("div", {
            className: "col-md-4 col-sm-6",
            children: /*#__PURE__*/jsx("div", {
              className: "widget widget-links pb-2 mb-4",
              dangerouslySetInnerHTML: {
                __html: getInTouch
              }
            })
          }), /*#__PURE__*/jsx("div", {
            className: "col-md-6",
            children: /*#__PURE__*/jsxs("div", {
              className: "widget pb-2 mb-4",
              children: [/*#__PURE__*/jsx("div", {
                className: "".concat(styles$1.stayInformed),
                dangerouslySetInnerHTML: {
                  __html: stayInformed
                }
              }), /*#__PURE__*/jsx(SignUpForm, {
                url: formLink
              })]
            })
          })]
        })
      })
    }), /*#__PURE__*/jsx("div", {
      className: "".concat(styles$1.bgFooter, " p-4"),
      children: /*#__PURE__*/jsx("div", {
        className: "container",
        children: /*#__PURE__*/jsx("div", {
          className: "text-center font-size-xs",
          children: "@".concat(new Date().getFullYear(), " ").concat(t('frontend.copywrite'))
        })
      })
    })]
  });
}

var extractMenuFromContent = function extractMenuFromContent(content) {
  var menu = Object.keys(content).map(function (key) {
    return key.includes('productcategories') ? content[key] : null;
  }).filter(function (item) {
    return item;
  }).sort(function (a, b) {
    return a.sortOrder - b.sortOrder;
  });

  if (menu.length) {
    var groupedItems = groupBy(menu, 'parentContent_contentID');
    menu = menu.map(function (item) {
      item.children = groupedItems.hasOwnProperty(item.contentID) ? groupedItems[item.contentID] : [];
      return item;
    }).filter(function (item) {
      return item.children.length;
    }).filter(function (item) {
      return item.urlTitle !== 'productcategories';
    }).sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    });
  }

  return menu;
};

var MegaMenu = function MegaMenu(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  return /*#__PURE__*/jsxs("li", {
    className: "nav-item dropdown",
    children: [/*#__PURE__*/jsx("a", {
      className: "nav-link dropdown-toggle",
      href: props.linkUrl || '/',
      "data-toggle": "dropdown",
      children: props.title
    }), /*#__PURE__*/jsxs("div", {
      className: "dropdown-menu pt-0 pb-3",
      children: [/*#__PURE__*/jsx("div", {
        className: "nav-shop-all",
        children: /*#__PURE__*/jsxs(Link, {
          to: props.linkUrl || '/',
          children: ["".concat(t('frontend.nav.shopall'), " ").concat(props.title), /*#__PURE__*/jsx("i", {
            className: "far fa-arrow-right ml-2"
          })]
        })
      }), /*#__PURE__*/jsx("div", {
        className: "d-flex flex-wrap flex-lg-nowrap px-2",
        children: props.subMenu.map(function (productCategory, index) {
          return /*#__PURE__*/jsx("div", {
            className: "mega-dropdown-column py-4 px-3",
            children: /*#__PURE__*/jsx("div", {
              className: "widget widget-links mb-3",
              onClick: eventHandlerForWSIWYG,
              dangerouslySetInnerHTML: {
                __html: productCategory['customBody']
              }
            })
          }, index);
        })
      })]
    })]
  });
};

function Header(_ref) {
  var logo = _ref.logo,
      mobileLogo = _ref.mobileLogo;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var history = useHistory();
  var content = useSelector(function (state) {
    return state.content;
  });

  var _useSelector = useSelector(function (state) {
    return state.configuration;
  }),
      shopByManufacturer = _useSelector.shopByManufacturer;

  var menuItems = extractMenuFromContent(content);
  var mainNavigation = content['header/main-navigation'] ? content['header/main-navigation'].customBody : '';
  var textInput = useRef(null);
  var mobileTextInput = useRef(null);
  var toggleMenuButton = useRef(null);

  var _useUtilities2 = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities2.eventHandlerForWSIWYG;

  useEffect(function () {
    var unload = history.listen(function (location) {
      toggleNav();
    });
    return function () {
      unload();
    };
  }, [history]);
  /**
   * Toggle menu , while the sub-menu is clicked
   */

  var toggleNav = function toggleNav() {
    if (toggleMenuButton.current && toggleMenuButton.current.ariaExpanded === 'true') {
      toggleMenuButton.current.click();
    }
  };
  /**
   * Search Input validation
   * @return {boolean}
   */


  var searchInputValidation = function searchInputValidation() {
    textInput.current.value = textInput.current.value.toString().trim(); // trim white spaces around input
    // check input validation

    if (!textInput.current.checkValidity()) {
      textInput.current.value = '';
      return false;
    } // minimum 3 keywords required to make a search


    if (textInput.current.value.length < 3) {
      return false;
    }

    return true;
  };
  /**
   * Search Products
   * @param {event} e
   * @return {void}
   */


  var searchForProducts = function searchForProducts(e) {
    if ((e.key === 'Enter' || (e === null || e === void 0 ? void 0 : e.type) === 'click') && searchInputValidation()) {
      e.preventDefault();
      history.push({
        pathname: '/search',
        search: queryString.stringify({
          keyword: textInput.current.value
        }, {
          arrayFormat: 'comma'
        })
      });
      textInput.current.value = '';
    }
  };

  return /*#__PURE__*/jsx("header", {
    className: "shadow-sm",
    children: /*#__PURE__*/jsxs("div", {
      className: "navbar-sticky bg-light",
      children: [/*#__PURE__*/jsx("div", {
        className: "navbar navbar-expand-lg navbar-light",
        children: /*#__PURE__*/jsxs("div", {
          className: "container",
          children: [/*#__PURE__*/jsx(Link, {
            className: "navbar-brand d-none d-md-block mr-3 flex-shrink-0",
            to: "/",
            children: /*#__PURE__*/jsx("img", {
              style: {
                maxHeight: '75px'
              },
              src: logo,
              alt: t('frontend.logo')
            })
          }), /*#__PURE__*/jsx(Link, {
            className: "navbar-brand d-md-none mr-2",
            to: "/",
            children: /*#__PURE__*/jsx("img", {
              src: mobileLogo,
              style: {
                minWidth: '90px'
              },
              alt: t('frontend.logo')
            })
          }), /*#__PURE__*/jsxs("div", {
            className: "navbar-right",
            children: [/*#__PURE__*/jsxs("div", {
              className: "navbar-topright",
              children: [/*#__PURE__*/jsxs("div", {
                className: "input-group-overlay d-none d-lg-flex",
                children: [/*#__PURE__*/jsx("input", {
                  className: "form-control appended-form-control",
                  type: "text",
                  required: true,
                  ref: textInput,
                  onKeyDown: searchForProducts,
                  placeholder: t('frontend.search.placeholder')
                }), /*#__PURE__*/jsx("div", {
                  className: "input-group-append-overlay",
                  children: /*#__PURE__*/jsx("span", {
                    className: "input-group-text",
                    children: /*#__PURE__*/jsx("i", {
                      style: {
                        cursor: 'pointer'
                      },
                      onClick: searchForProducts,
                      className: "far fa-search"
                    })
                  })
                })]
              }), /*#__PURE__*/jsxs("div", {
                className: "navbar-toolbar d-flex flex-shrink-0 align-items-center",
                children: [/*#__PURE__*/jsx("button", {
                  ref: toggleMenuButton,
                  className: "navbar-toggler",
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "#navbarCollapse",
                  id: "menuToggleButton",
                  children: /*#__PURE__*/jsx("span", {
                    className: "navbar-toggler-icon"
                  })
                }), /*#__PURE__*/jsx(Link, {
                  className: "navbar-tool ml-1 ml-lg-0 mr-n1 mr-lg-2",
                  to: "/my-account",
                  "data-toggle": "modal",
                  children: /*#__PURE__*/jsx(AccountBubble, {})
                }), /*#__PURE__*/jsx(CartMenuItem, {})]
              })]
            }), /*#__PURE__*/jsx("div", {
              className: "navbar-main-links",
              onClick: eventHandlerForWSIWYG,
              dangerouslySetInnerHTML: {
                __html: mainNavigation
              }
            })]
          })]
        })
      }), /*#__PURE__*/jsx("div", {
        className: "navbar navbar-expand-lg navbar-dark bg-dark navbar-stuck-menu mt-2 pt-0 pb-0",
        children: /*#__PURE__*/jsx("div", {
          className: "container p-0",
          children: /*#__PURE__*/jsxs("div", {
            className: "collapse navbar-collapse",
            id: "navbarCollapse",
            children: [/*#__PURE__*/jsxs("div", {
              className: "input-group-overlay d-lg-none my-3 ml-0",
              children: [/*#__PURE__*/jsx("div", {
                className: "input-group-prepend-overlay",
                children: /*#__PURE__*/jsx("span", {
                  className: "input-group-text",
                  children: /*#__PURE__*/jsx("i", {
                    className: "far fa-search",
                    onClick: function onClick(e) {
                      e.preventDefault();
                      history.push({
                        pathname: '/search',
                        search: mobileTextInput.stringify({
                          keyword: mobileTextInput.current.value
                        }, {
                          arrayFormat: 'comma'
                        })
                      });
                      mobileTextInput.current.value = '';
                    }
                  })
                })
              }), /*#__PURE__*/jsx("input", {
                className: "form-control prepended-form-control",
                onKeyDown: function onKeyDown(e) {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    history.push({
                      pathname: '/search',
                      search: queryString.stringify({
                        keyword: e.target.value
                      }, {
                        arrayFormat: 'comma'
                      })
                    });
                    mobileTextInput.current.value = '';
                  }
                },
                type: "text",
                ref: mobileTextInput,
                placeholder: t('frontend.search.placeholder')
              })]
            }), /*#__PURE__*/jsx("ul", {
              className: "navbar-nav nav-categories",
              children: menuItems.map(function (menuItem, index) {
                return /*#__PURE__*/jsx(MegaMenu, {
                  subMenu: menuItem.children,
                  title: menuItem.title,
                  linkUrl: menuItem.linkUrl
                }, index);
              })
            }), shopByManufacturer.showInMenu && /*#__PURE__*/jsx("ul", {
              className: "navbar-nav mega-nav ml-lg-2",
              children: /*#__PURE__*/jsx("li", {
                className: "nav-item",
                children: /*#__PURE__*/jsxs(Link, {
                  className: "nav-link",
                  to: shopByManufacturer.slug,
                  children: [/*#__PURE__*/jsx("i", {
                    className: "far fa-industry-alt mr-2"
                  }), t('frontend.nav.manufacturer')]
                })
              })
            })]
          })
        })
      })]
    })
  });
}

var AccountBubble = function AccountBubble() {
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useSelector = useSelector(function (state) {
    return state.userReducer;
  }),
      firstName = _useSelector.firstName,
      lastName = _useSelector.lastName,
      accountID = _useSelector.accountID;

  var name = "".concat(firstName, " ").concat(lastName);
  useEffect(function () {
    dispatch(getUser());
  }, [dispatch]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "navbar-tool-icon-box d-flex justify-content-center align-items-center",
      children: /*#__PURE__*/jsx("i", {
        className: "far fa-user"
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "navbar-tool-text ml-n3",
      children: [/*#__PURE__*/jsxs("small", {
        children: ["Hello, ", accountID && name, !accountID && t('frontend.account.sign_in')]
      }), "My Account"]
    })]
  });
};

var CartMenuItem = function CartMenuItem() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var cart = useSelector(function (state) {
    return state.cart;
  });
  var cartQuantity = cart.orderItems.reduce(function (accumulator, orderItem) {
    return accumulator + orderItem.quantity;
  }, 0);

  var _useFormatCurrency = useFormatCurrency({}),
      _useFormatCurrency2 = _slicedToArray(_useFormatCurrency, 1),
      formatCurrency = _useFormatCurrency2[0];

  var isAuthed = isAuthenticated();
  var isVerified = useSelector(isAccountVerified);
  return /*#__PURE__*/jsxs("div", {
    className: "navbar-tool ml-3",
    children: [/*#__PURE__*/jsxs(Link, {
      className: "navbar-tool-icon-box bg-secondary",
      to: "/shopping-cart",
      children: [cartQuantity > 0 && /*#__PURE__*/jsx("span", {
        className: "navbar-tool-label",
        children: cartQuantity
      }), /*#__PURE__*/jsx("i", {
        className: "far fa-shopping-cart"
      })]
    }), isAuthed && isVerified && /*#__PURE__*/jsxs(Link, {
      className: "navbar-tool-text",
      to: "/shopping-cart",
      children: [/*#__PURE__*/jsx("small", {
        children: t('frontend.cart.my')
      }), formatCurrency(cart.total)]
    })]
  });
};

var AuthenticationStepUp = function AuthenticationStepUp(_ref) {
  var _ref$messageKey = _ref.messageKey,
      messageKey = _ref$messageKey === void 0 ? 'frontend.account.auth.price' : _ref$messageKey;
  var loc = useLocation$2();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var orderItemsCount = useSelector(orderItemsCountSelector);
  if (isAuthenticated() || orderItemsCount === 0) return null;
  return /*#__PURE__*/jsxs("div", {
    className: "alert alert-warning",
    role: "alert",
    children: [t(messageKey), " ", /*#__PURE__*/jsx(Link, {
      to: "/my-account?redirect=".concat(loc.pathname),
      children: t('frontend.account.login')
    })]
  });
};

var Layout = function Layout(_ref) {
  var classNameList = _ref.classNameList,
      children = _ref.children;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ToastContainer, {}), /*#__PURE__*/jsx("div", {
      style: {
        minHeight: '100vh'
      },
      className: classNameList,
      children: children
    }), /*#__PURE__*/jsx(Footer, {})]
  });
};

var _excluded = ["title", "children"];

var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var loc = useLocation();
  var path = loc.pathname.split('/').reverse()[0].toLowerCase();
  var contentStore = useSelector(function (state) {
    return state.content[path];
  }) || {};
  return /*#__PURE__*/jsx("div", {
    className: "page-title-overlap bg-lightgray pt-4",
    children: /*#__PURE__*/jsxs("div", {
      className: "container d-lg-flex justify-content-between",
      children: [/*#__PURE__*/jsx(BreadCrumb, _objectSpread2({}, props)), /*#__PURE__*/jsxs("div", {
        className: "order-lg-1 pr-lg-4 text-center text-lg-left flex-1",
        children: [!!title && /*#__PURE__*/jsx("h1", {
          className: "h3 text-dark mb-0 font-accent",
          children: title || contentStore.title || ''
        }), children]
      })]
    })
  });
};

var ActionBanner = function ActionBanner(props) {
  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  var loc = useLocation();
  var path = loc.pathname.split('/').reverse()[0]; // Get All contnent of type Banner

  var allBanners = useSelector(getAllbanners);
  var banner = {
    customBody: ''
  };

  if (allBanners.length === 1) {
    // Only one banner so lets use that
    banner = allBanners[0];
  } else if (allBanners.length > 1) {
    // lets try and see if we have a banner prefixed with this path
    var actionBannersForPath = allBanners.filter(function (banner) {
      return banner.key.includes("".concat(path, "/"));
    });

    if (actionBannersForPath.length === 0 || actionBannersForPath.length > 1) {
      // no  banner for this path so lets check footer
      var actionBannersForFooter = allBanners.filter(function (banner) {
        return banner.key.includes("footer/");
      }); // set the footer banner or the first banner in the global list

      banner = actionBannersForFooter.length === 0 || actionBannersForFooter.length > 1 ? allBanners[0] : actionBannersForFooter[0];
    } else {
      // set the banner for path
      banner = actionBannersForPath[0];
    }
  }

  return /*#__PURE__*/jsx("div", {
    className: "bg-primary p-5",
    children: /*#__PURE__*/jsx("div", {
      className: "container",
      children: /*#__PURE__*/jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/jsx("div", {
          className: "col-0 col-md-2"
        }), /*#__PURE__*/jsx("div", {
          className: "col-md-8 text-center",
          onClick: eventHandlerForWSIWYG,
          dangerouslySetInnerHTML: {
            __html: banner.customBody
          }
        }), /*#__PURE__*/jsx("div", {
          className: "col-0 col-md-2"
        })]
      })
    })
  });
};

var Crumb = function Crumb(_ref) {
  var urlTitle = _ref.urlTitle,
      title = _ref.title;
  return /*#__PURE__*/jsx("li", {
    className: "breadcrumb-item ",
    children: /*#__PURE__*/jsx(Link, {
      className: "text-nowrap",
      to: urlTitle,
      children: title
    })
  });
};

var BreadCrumb = function BreadCrumb(_ref2) {
  var crumbs = _ref2.crumbs,
      _ref2$includeHome = _ref2.includeHome,
      includeHome = _ref2$includeHome === void 0 ? true : _ref2$includeHome,
      _ref2$brand = _ref2.brand,
      brand = _ref2$brand === void 0 ? [] : _ref2$brand;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/jsx("div", {
    className: "order-lg-2 mb-3 mb-lg-0 pt-lg-2",
    children: crumbs && /*#__PURE__*/jsx("nav", {
      "aria-label": "breadcrumb",
      children: /*#__PURE__*/jsxs("ol", {
        className: "breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-start",
        children: [includeHome && /*#__PURE__*/jsx("li", {
          className: "breadcrumb-item ",
          children: /*#__PURE__*/jsxs(Link, {
            className: "text-nowrap",
            to: "/",
            children: [/*#__PURE__*/jsx("i", {
              className: "far fa-home"
            }), t('frontend.core.home')]
          })
        }), brand.map(function (crumb) {
          return /*#__PURE__*/jsx(Crumb, _objectSpread2({}, crumb), crumb.urlTitle);
        }), crumbs.map(function (crumb) {
          return /*#__PURE__*/jsx(Crumb, _objectSpread2({}, crumb), crumb.urlTitle);
        })]
      })
    })
  });
};

var BannerSlide = function BannerSlide(_ref) {
  var customBody = _ref.customBody,
      title = _ref.title,
      associatedImage = _ref.associatedImage,
      linkUrl = _ref.linkUrl,
      linkLabel = _ref.linkLabel,
      slideKey = _ref.slideKey;

  var _useSelector = useSelector(function (state) {
    return state.configuration.theme;
  }),
      host = _useSelector.host;

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  return /*#__PURE__*/jsx("div", {
    className: "hero text-white text-center pb-4",
    style: {
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.6),rgba(0, 0, 0, 0.6)), url(".concat(host, "custom/assets/files/associatedimage/").concat(associatedImage)
    },
    children: /*#__PURE__*/jsx("div", {
      className: "container",
      children: /*#__PURE__*/jsx("div", {
        style: {
          height: 'fit-content'
        },
        className: "main-banner",
        children: /*#__PURE__*/jsxs("div", {
          index: slideKey,
          className: "repeater",
          children: [/*#__PURE__*/jsx("h2", {
            className: "h2",
            children: title
          }), /*#__PURE__*/jsx("p", {
            onClick: eventHandlerForWSIWYG,
            dangerouslySetInnerHTML: {
              __html: customBody
            }
          }), linkUrl && linkUrl.trim().length > 0 && /*#__PURE__*/jsx("a", {
            href: linkUrl,
            className: "btn btn-light btn-long",
            children: linkLabel
          })]
        })
      })
    })
  });
};
/*
TODO: we shoud match contentful

only use how is image url is not FQDN

*/


var ContentSlider = function ContentSlider() {
  var contentStore = useSelector(function (state) {
    return state.content;
  });
  var homeMainBanner = [];
  Object.keys(contentStore).forEach(function (key) {
    if (key.includes('main-banner-slider/')) {
      homeMainBanner.push(contentStore[key]);
    }
  });
  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  return /*#__PURE__*/jsx(Slider, _objectSpread2(_objectSpread2({
    className: "main-slider slider-dark"
  }, settings), {}, {
    children: homeMainBanner.length > 0 && homeMainBanner.sort(function (a, b) {
      return a.sortOrder - b.sortOrder;
    }).map(function (slideData, index) {
      return /*#__PURE__*/createElement(BannerSlide, _objectSpread2(_objectSpread2({}, slideData), {}, {
        key: index,
        slideKey: index
      }));
    })
  }));
};

var BrandBanner = function BrandBanner(_ref) {
  var _ref$brandName = _ref.brandName,
      brandName = _ref$brandName === void 0 ? '' : _ref$brandName,
      images = _ref.images,
      brandDescription = _ref.brandDescription,
      subHeading = _ref.subHeading;
  return /*#__PURE__*/jsxs("div", {
    className: "row align-items-center",
    children: [!!images && /*#__PURE__*/jsx(SimpleImage, {
      className: "d-block mx-auto",
      src: images[0],
      alt: brandName,
      style: {
        maxHeight: '150px',
        maxWidth: '190px',
        background: '#FFF'
      },
      type: "brand"
    }), /*#__PURE__*/jsxs("div", {
      className: "col text-left",
      children: [/*#__PURE__*/jsx("h1", {
        className: "h3 text-dark mb-0 font-accent",
        children: brandName
      }), !!subHeading && /*#__PURE__*/jsx("h3", {
        className: "h5 m-0",
        children: subHeading
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "col text-right ",
      children: /*#__PURE__*/jsx("span", {
        dangerouslySetInnerHTML: {
          __html: brandDescription
        }
      })
    })]
  });
};

var BandSlide = function BandSlide(_ref) {
  var _ref$urlTitle = _ref.urlTitle,
      urlTitle = _ref$urlTitle === void 0 ? '' : _ref$urlTitle,
      title = _ref.title,
      images = _ref.images;
  var brand = useSelector(getBrandRoute);
  return /*#__PURE__*/jsx("div", {
    className: "repeater",
    children: /*#__PURE__*/jsx("div", {
      className: "brand-box bg-white box-shadow-sm rounded-lg m-3",
      children: /*#__PURE__*/jsx(Link, {
        className: "d-block p-4",
        to: "/".concat(brand, "/").concat(urlTitle),
        children: !!images && /*#__PURE__*/jsx(SimpleImage, {
          className: "d-block mx-auto",
          src: images[0],
          alt: title,
          type: "brand"
        })
      })
    })
  });
};

var BrandSlider = function BrandSlider(_ref2) {
  var params = _ref2.params;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useGetEntity = useGetEntity(),
      _useGetEntity2 = _slicedToArray(_useGetEntity, 2),
      request = _useGetEntity2[0],
      setRequest = _useGetEntity2[1];

  var shopBy = useSelector(getShopBy);
  var shopByManufacturer = useSelector(function (state) {
    return state.configuration.shopByManufacturer;
  });
  params = _objectSpread2({
    includeImages: true
  }, params);
  useEffect(function () {
    var didCancel = false;

    if (!request.isFetching && !request.isLoaded && !didCancel) {
      setRequest(_objectSpread2(_objectSpread2({}, request), {}, {
        isFetching: true,
        isLoaded: false,
        entity: 'brand',
        params: params,
        makeRequest: true
      }));
    }

    return function () {
      didCancel = true;
    };
  }, [request, setRequest, params]);
  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }]
  };
  return /*#__PURE__*/jsxs("div", {
    style: {
      height: 'fit-content'
    },
    className: "home-brand container-slider container py-lg-4 mb-4 mt-4 text-center",
    children: [/*#__PURE__*/jsx("h3", {
      className: "h3",
      children: shopBy.title
    }), /*#__PURE__*/jsx(Slider, _objectSpread2(_objectSpread2({}, settings), {}, {
      children: request.isLoaded && request.data.map(function (slide) {
        return /*#__PURE__*/jsx(BandSlide, _objectSpread2({}, slide), slide.brandID);
      })
    })), /*#__PURE__*/jsx(Link, {
      className: "btn btn-primary mt-3 btn-long",
      to: shopByManufacturer.slug,
      children: t('frontend.home.more_brands')
    })]
  });
};

function ContentColumns(_ref) {
  var page = _ref.page;
  var content = useSelector(function (state) {
    return state.content;
  });

  var _useUtilities = useUtilities(),
      eventHandlerForWSIWYG = _useUtilities.eventHandlerForWSIWYG;

  var homeContent = [];
  Object.keys(content).forEach(function (key) {
    if (key.includes("".concat(page, "/content-columns/"))) {
      homeContent.push(content[key]);
    }
  });
  return /*#__PURE__*/jsx("div", {
    className: "container",
    children: /*#__PURE__*/jsx("div", {
      className: "row text-center mt-5 mb-5",
      children: homeContent && homeContent.map(function (section, index) {
        return /*#__PURE__*/jsxs("div", {
          className: "col-md",
          children: [/*#__PURE__*/jsx(SWImage, {
            className: "mb-3",
            customPath: "/custom/assets/files/associatedimage/",
            src: section.associatedImage
          }), /*#__PURE__*/jsx("h3", {
            className: "h3",
            children: section.title
          }), /*#__PURE__*/jsx("p", {
            onClick: eventHandlerForWSIWYG,
            dangerouslySetInnerHTML: {
              __html: section.customBody
            }
          })]
        }, index);
      })
    })
  });
}

var css_248z = ".SignUpForm-module_customInput__wZjoi{\n    padding-left: 12px !important;\n    background-color: #fff;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.SignUpForm-module_customInput__wZjoi::placeholder{\n    color: #C2C7CE;\n}";
var styles = {"customInput":"SignUpForm-module_customInput__wZjoi"};
styleInject(css_248z);

var MyForm = function MyForm(_ref) {
  var status = _ref.status,
      message = _ref.message,
      onValidated = _ref.onValidated;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var email, fName, lName, company;

  var submit = function submit() {
    email && lName && fName && company && email.value.indexOf('@') > -1 && onValidated({
      EMAIL: email.value,
      LNAME: lName.value,
      FNAME: fName.value,
      COMPANY: company.value
    });
  };

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: "input-group input-group-overlay flex-nowrap",
      children: [/*#__PURE__*/jsx("div", {
        className: "input-group-prepend-overlay",
        children: /*#__PURE__*/jsx("span", {
          className: "input-group-text text-muted font-size-base"
        })
      }), /*#__PURE__*/jsx("form", {
        onSubmit: function onSubmit(e) {
          submit();
          e.preventDefault();
        },
        children: /*#__PURE__*/jsxs("div", {
          className: "row",
          children: [/*#__PURE__*/jsxs("div", {
            className: "col-12 d-flex",
            children: [/*#__PURE__*/jsx("input", {
              className: "".concat(styles.customInput, " form-control prepended-form-control mr-3"),
              type: "text",
              ref: function ref(node) {
                return fName = node;
              },
              placeholder: t('frontend.account.first_name'),
              required: true
            }), /*#__PURE__*/jsx("input", {
              className: "".concat(styles.customInput, " form-control prepended-form-control mr-3"),
              type: "text",
              ref: function ref(node) {
                return lName = node;
              },
              placeholder: t('frontend.account.last_name'),
              required: true
            }), /*#__PURE__*/jsx("input", {
              className: "".concat(styles.customInput, " form-control prepended-form-control"),
              type: "text",
              ref: function ref(node) {
                return company = node;
              },
              placeholder: t('frontend.account.company'),
              required: true
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: "col-12 d-flex pt-3",
            children: [/*#__PURE__*/jsx("input", {
              className: "".concat(styles.customInput, " form-control prepended-form-control rounded-right-0"),
              ref: function ref(node) {
                return email = node;
              },
              pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+",
              type: "email",
              placeholder: t('frontend.account.email'),
              required: true
            }), /*#__PURE__*/jsx("div", {
              className: "input-group-append",
              children: /*#__PURE__*/jsxs("button", {
                className: "btn btn-primary rounded-left-0",
                type: "submit",
                children: [/*#__PURE__*/jsx("i", {
                  className: "fal fa-envelope"
                }), " ", t('frontend.core.subscribe')]
              })
            })]
          })]
        })
      })]
    }), /*#__PURE__*/jsx("small", {
      className: "form-text opacity-50",
      id: "mc-helper",
      children: t('frontend.mc.info')
    }), /*#__PURE__*/jsxs("div", {
      className: "subscribe-status",
      children: [status === 'sending' && /*#__PURE__*/jsx("div", {
        style: {
          color: 'blue'
        },
        children: t('frontend.mc.sending')
      }), status === 'error' && /*#__PURE__*/jsx("div", {
        style: {
          color: 'red'
        },
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), status === 'success' && /*#__PURE__*/jsx("div", {
        style: {
          color: 'green'
        },
        dangerouslySetInnerHTML: {
          __html: message
        }
      })]
    })]
  });
};

var SignUpForm = function SignUpForm(_ref2) {
  var url = _ref2.url;
  return /*#__PURE__*/jsx(MailchimpSubscribe, {
    url: url,
    render: function render(_ref3) {
      var subscribe = _ref3.subscribe,
          status = _ref3.status,
          message = _ref3.message;
      return /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(MyForm, {
          status: status,
          message: message,
          onValidated: function onValidated(formData) {
            subscribe(formData);
          }
        })
      });
    }
  });
};

var lazyWithPreload = function lazyWithPreload(factory) {
  var Component = /*#__PURE__*/React.lazy(factory);
  Component.preload = factory;
  return Component;
};

export { AccountAddressForm, AccountAddresses, AccountBubble, AccountCarts, AccountContent, AccountFavorites, AccountLayout, AccountLogin, AccountOrderDetail, AccountOrderHistory, AccountOverview, AccountPaymentMethods, AccountProfile, AccountToolBar, ActionBanner, AttributeList, AuthenticationStepUp, BillingAddressDetails, BrandBanner, BrandSlider, BreadCrumb, Button, CART, CCDetails, CMSWrapper, CartLineItem, CartMenuItem, CartPromoBox, CheckoutSideBar, ContentColumns, ContentSlider, CreateAccount, CreateOrEditAccountAddress, CreateOrEditAccountPaymentMethod, CreditCardDetails, CreditCardPayment, FacetFilter, FacetHeading, FacetSearch, Footer, ForgotPassword, ForgotPasswordReset, FulfillmentPicker, FulfilmentAddressSelector, GiftCardDetails, GiftCardPayment, Grid, Header, HeartButton, Layout, Listing, ListingGrid, ListingPagination, ListingPaginationModern, ListingSidebar, ListingToolBar, Loading, OrderDetails, OrderNav, OrderNotes, OrderShipments, OrderSummary, OrderToolbar, Overlay, OverlaySpinner, PAYMENT, PageHeader, PaymentAddressSelector, PaymentList, PaymentMethodItem, PaymentSlide, PickupLocationDetails, PickupLocationPicker, ProductCard, ProductDetailGallery, ProductDetails, ProductForm, ProductImage, ProductPageHeader, ProductPagePanels, ProductPrice, ProductQuantityInput, ProductSlider, ProductTypeList, PromotionalMessaging, PromptLayout, REVIEW, RelatedProductsSlider, ReviewSlide, SEO, SHIPPING, SWForm, SWImage, SWInput, ScrollToTop, ShippingAddressDetails, ShippingMethodPicker, ShippingSlide, SignUpForm, SimpleImage, SkuOptions, SlideNavigation, Spinner, StepsHeader, SwRadioSelect, SwSelect, TermPayment, TermPaymentDetails, UpdatePassword, checkOutSteps, getCurrentStep, lazyWithPreload };
//# sourceMappingURL=index.js.map
